
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i8zdv", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareFeaturesPage", function () { return $d9e295ed58448d6d$export$9a6579f6d73934fc; });

var $loA2J = parcelRequire("loA2J");

var $4LHd8 = parcelRequire("4LHd8");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");
parcelRequire("aMaGe");
var $fLHev = parcelRequire("fLHev");
var $a3arw = parcelRequire("a3arw");
const $d9e295ed58448d6d$export$9a6579f6d73934fc = ()=>{
    var _FeatureGates_checkGate;
    const showJiraSoftwareFeaturesV2 = (_FeatureGates_checkGate = (0, $4LHd8.default).checkGate("wac-jira-features-team24-gate")) !== null && _FeatureGates_checkGate !== void 0 ? _FeatureGates_checkGate : false;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkV6l.SiteSelectorContextProvider), {
        analyticsPrefix: "jsm.show",
        productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE,
        children: showJiraSoftwareFeaturesV2 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $fLHev.JiraSoftwareFeaturesPageTemplate), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $a3arw.JiraSoftwareFeaturesPageTemplate), {})
    });
};

});
parcelRegister("aMaGe", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareFeaturesPageTemplate", function () { return (parcelRequire("a3arw")).JiraSoftwareFeaturesPageTemplate; });
$parcel$export(module.exports, "JiraSoftwareFeaturesPageTemplateV2", function () { return (parcelRequire("fLHev")).JiraSoftwareFeaturesPageTemplate; });

var $a3arw = parcelRequire("a3arw");

var $fLHev = parcelRequire("fLHev");

});
parcelRegister("a3arw", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareFeaturesPageTemplate", function () { return $90972945ed7e5c00$export$eda29bf8e53b5034; });

var $loA2J = parcelRequire("loA2J");

var $kex29 = parcelRequire("kex29");

var $egwTB = parcelRequire("egwTB");

var $3x1D7 = parcelRequire("3x1D7");

var $dJVgs = parcelRequire("dJVgs");

var $h3koM = parcelRequire("h3koM");

var $4j5uS = parcelRequire("4j5uS");

var $lw58d = parcelRequire("lw58d");

var $6hIOc = parcelRequire("6hIOc");

var $89fr1 = parcelRequire("89fr1");

var $9OQpd = parcelRequire("9OQpd");

var $ifJka = parcelRequire("ifJka");

var $1N2Ld = parcelRequire("1N2Ld");

var $jCsS3 = parcelRequire("jCsS3");

var $8TCRB = parcelRequire("8TCRB");
const $90972945ed7e5c00$export$eda29bf8e53b5034 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)("main", {
                id: "content",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $h3koM.JSWFeaturesPageBanner), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9OQpd.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $3x1D7.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1N2Ld.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $egwTB.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ifJka.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6hIOc.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $89fr1.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $lw58d.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jCsS3.SecurityScaleSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $8TCRB.default), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4j5uS.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("egwTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bd3894cf449d408$export$2e2bcd8739ae039; });
/* reports-and-insights.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $bQawl = parcelRequire("bQawl");

var $3FBn4 = parcelRequire("3FBn4");

var $lnhFK = parcelRequire("lnhFK");
const $3bd3894cf449d408$var$containerStyle = null;
const $3bd3894cf449d408$var$headers = null;
const $3bd3894cf449d408$var$h6Styles = null;
const $3bd3894cf449d408$var$h2Styles = null;
const $3bd3894cf449d408$var$pStyle = null;
const $3bd3894cf449d408$var$dropShadowStyle = null;
const $3bd3894cf449d408$var$StyledImage = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedImageSrc = (0, $lnhFK.getReportsAndInsightsSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            alt: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageTemplate.reports-and-insights.imgAlt",
                defaultMessage: "Insights example in Jira Software"
            }),
            src: localizedImageSrc,
            loading: "lazy",
            className: (0, $esG4f.default)([
                "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _kdam1319 _19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsbrs3w _suga1ule _1rfm1osq _tnru1wug _a5zt19bv"
            ])
        })
    });
};
const $3bd3894cf449d408$var$StyledAboveTextImage = ()=>{
    const imageBlockStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_181nglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($3bd3894cf449d408$var$StyledImage, {})
    });
};
const $3bd3894cf449d408$var$StyledBelowTextImage = ()=>{
    const imageBlockStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_sugaglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($3bd3894cf449d408$var$StyledImage, {})
    });
};
const $3bd3894cf449d408$var$JSWFeaturesPageReportsAndInsights = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvr1h6o _1wpz1h6o _y3gn1h6o _tl287vkz _axwiidpf _1hwc7vkz _sp8tidpf _oqicvbgk _1rmjidpf _cjbtvbgk _pnmbidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($3bd3894cf449d408$var$StyledAboveTextImage, {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _1e0c1txw _2lx21bp4 _1bah1h6o _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v _19pkidpf _2hwx1wug _otyridpf _18u01wug _1rfm1osq _14b54xhq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h6", {
                        className: (0, $esG4f.default)([
                            "_syazvwuj _1wyboqnp _1dyzt94y _vwz4cs5v _1pfhidpf _1egl19bv _1tnt7vkz _1p1dangw _k48p1nn1"
                        ]),
                        children: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageTemplate.reports-and-insights.subtitle",
                            defaultMessage: "Learn and improve"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _y3gn1h6o _syaz1bqd _1dyzidpf _1pfhidpf _k48pbfng _s7n4nkob _1egldlk8 _1tnt1tcg _1gw8ahaf _1pah11ph _e4kmnkob"
                        ]),
                        children: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageTemplate.reports-and-insights.title",
                            defaultMessage: "Reports and insights"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_1wyb1j6v _y3gn1h6o _1bah1h6o _syaz1mpp _6rth1tcg _1pfhidpf"
                            ]),
                            children: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageTemplate.reports-and-insights.description",
                                defaultMessage: "Out-of-the-box reports and dashboards in Jira Software offer critical insights within the context of your work to ensure your teams are always up to date and set up for success."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                            text: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageTemplate.reports-and-insights.learnMore",
                                defaultMessage: "Learn more"
                            }),
                            url: (0, $3FBn4.useLocalizedHref)("/software/jira/features/reports"),
                            size: "small",
                            type: "secondary",
                            dataEventProps: {
                                "data-product-key": "jiraSoftwareFeature",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "reportsAndInsightsSection"
                            },
                            className: (0, $esG4f.default)([
                                "_1e0c116y _k48pbfng _19it36id"
                            ])
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($3bd3894cf449d408$var$StyledBelowTextImage, {})
        ]
    });
};
var $3bd3894cf449d408$export$2e2bcd8739ae039 = $3bd3894cf449d408$var$JSWFeaturesPageReportsAndInsights;

});
parcelRegister("lnhFK", function(module, exports) {

$parcel$export(module.exports, "getDevOpsSectionImage", function () { return $f65f635cc81c344e$export$f5fc726b1f3a764d; });
$parcel$export(module.exports, "getDragAndDropSectionImage", function () { return $f65f635cc81c344e$export$f8b70e2e1be2978a; });
$parcel$export(module.exports, "getReportsAndInsightsSectionImage", function () { return $f65f635cc81c344e$export$ffe1b4a595446b8e; });
$parcel$export(module.exports, "getViewRepositoriesSectionImage", function () { return $f65f635cc81c344e$export$6280bda73e2fb4b3; });
$parcel$export(module.exports, "getFeatureCoordinateSectionImage", function () { return $f65f635cc81c344e$export$e64f40386cf4cd9f; });
$parcel$export(module.exports, "getFeatureConnectWorkSectionImage", function () { return $f65f635cc81c344e$export$f6ffb22b19d99166; });
$parcel$export(module.exports, "getScrumSectionImage", function () { return $f65f635cc81c344e$export$c2e90310ecfb278c; });
$parcel$export(module.exports, "getKanbanSectionImage", function () { return $f65f635cc81c344e$export$b2190d24d3c2c633; });
/* eslint-disable @typescript-eslint/no-non-null-assertion */ const $f65f635cc81c344e$var$devOpsSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/dam/jcr:02632bb4-e70f-4f9b-94f9-b28d2d58ae3a/devops-diagram_de-DE.png?cdnVersion=1392",
    es: "https://wac-cdn.atlassian.com/dam/jcr:6a5891b0-9d7e-4411-878a-ad76dac1653a/devops-diagram_es-ES.png?cdnVersion=1392",
    fr: "https://wac-cdn.atlassian.com/dam/jcr:d4dcc1d3-4c05-40cb-a04c-466a26e71ec2/devops-diagram_fr-FR.png?cdnVersion=1392",
    br: "https://wac-cdn.atlassian.com/dam/jcr:a9dbb9ee-0009-434b-a0f4-e99f48508a37/devops-diagram_pt-BR.png?cdnVersion=1392",
    en: "https://wac-cdn.atlassian.com/dam/jcr:c11e57a5-86cc-42b9-afa3-d77e1733d092/devops-diagram.svg?cdnVersion=1392",
    ja: "https://wac-cdn.atlassian.com/dam/jcr:24b84f80-3c90-4d5b-acc6-7dc791de57b9/devops-diagram_ja-JP.png?cdnVersion=1392",
    ru: "https://wac-cdn.atlassian.com/dam/jcr:a45d0330-3a7d-489a-a774-cc8590076601/devops-diagram_ru-RU.png?cdnVersion=1392"
};
const $f65f635cc81c344e$export$f5fc726b1f3a764d = (locale)=>{
    return $f65f635cc81c344e$var$devOpsSectionImageMap[locale] || $f65f635cc81c344e$var$devOpsSectionImageMap["en"];
};
const $f65f635cc81c344e$var$dragAndDropSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/dam/jcr:57415379-cdd9-473d-970a-2d0a2f0cac4e/automation-string%20DE.svg",
    es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-ES.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-FR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string.webp",
    en: "https://wac-cdn.atlassian.com/dam/jcr:d2a791e4-24ca-41cb-b5de-ca6df4e67c0a/automation-string.svg",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-JA.webp",
    ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/automation-string-RU.webp"
};
const $f65f635cc81c344e$export$f8b70e2e1be2978a = (locale)=>{
    return $f65f635cc81c344e$var$dragAndDropSectionImageMap[locale] || $f65f635cc81c344e$var$dragAndDropSectionImageMap["en"];
};
const $f65f635cc81c344e$var$reportsAndInsightsSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_DE.webp",
    es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_ES.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_FR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_pt-BR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_JA.webp",
    ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-insights_RU.webp"
};
const $f65f635cc81c344e$export$ffe1b4a595446b8e = (locale)=>{
    return $f65f635cc81c344e$var$reportsAndInsightsSectionImageMap[locale] || $f65f635cc81c344e$var$reportsAndInsightsSectionImageMap["en"];
};
const $f65f635cc81c344e$var$viewRepositoriesSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_DE.webp",
    es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ES.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_FR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-one.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_JA.webp",
    ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-jira-see-code_RU.webp"
};
const $f65f635cc81c344e$export$6280bda73e2fb4b3 = (locale)=>{
    return $f65f635cc81c344e$var$viewRepositoriesSectionImageMap[locale] || $f65f635cc81c344e$var$viewRepositoriesSectionImageMap["en"];
};
const $f65f635cc81c344e$var$featureCoordinateSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_DE.webp",
    es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ES.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_FR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/features-code-image-two.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_JA.webp",
    ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-dev_20status_20in_20issue_RU.webp"
};
const $f65f635cc81c344e$export$e64f40386cf4cd9f = (locale)=>{
    return $f65f635cc81c344e$var$featureCoordinateSectionImageMap[locale] || $f65f635cc81c344e$var$featureCoordinateSectionImageMap["en"];
};
const $f65f635cc81c344e$var$featureConnectWorkSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_DE.webp",
    es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ES.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_FR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/feature-code-image-three.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_JA.webp",
    ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/screen-advanced_20reporting_RU.webp"
};
const $f65f635cc81c344e$export$f6ffb22b19d99166 = (locale)=>{
    return $f65f635cc81c344e$var$featureConnectWorkSectionImageMap[locale] || $f65f635cc81c344e$var$featureConnectWorkSectionImageMap["en"];
};
const $f65f635cc81c344e$var$scrumSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_DE.webp",
    es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ES.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_FR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-scrum_board@2x.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_JA.webp",
    ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Scrum_board_RU.webp"
};
const $f65f635cc81c344e$export$c2e90310ecfb278c = (locale)=>{
    return $f65f635cc81c344e$var$scrumSectionImageMap[locale] || $f65f635cc81c344e$var$scrumSectionImageMap["en"];
};
const $f65f635cc81c344e$var$kanbanSectionImageMap = {
    de: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_DE.webp",
    es: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ES.webp",
    fr: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_FR.webp",
    br: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_ptBR.webp",
    en: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Screen-kanban_board@2x.webp",
    ja: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_JA.webp",
    ru: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Kanban_RU.webp"
};
const $f65f635cc81c344e$export$b2190d24d3c2c633 = (locale)=>{
    return $f65f635cc81c344e$var$kanbanSectionImageMap[locale] || $f65f635cc81c344e$var$kanbanSectionImageMap["en"];
};

});


parcelRegister("3x1D7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e3c80cf8660ca95$export$2e2bcd8739ae039; });
/* timeline.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $8xSOc = parcelRequire("8xSOc");
parcelRequire("hkKtl");
var $7Xa9M = parcelRequire("7Xa9M");

var $bQawl = parcelRequire("bQawl");

var $3FBn4 = parcelRequire("3FBn4");
const $2e3c80cf8660ca95$var$RoadmapContainerStyle = null;
const $2e3c80cf8660ca95$var$headers = null;
const $2e3c80cf8660ca95$var$h6Styles = null;
const $2e3c80cf8660ca95$var$h2Styles = null;
const $2e3c80cf8660ca95$var$pStyle = null;
const $2e3c80cf8660ca95$var$ContainerStyle = null;
const $2e3c80cf8660ca95$var$Timeline = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvr1h6o _1wpz1h6o _tl287vkz _axwiidpf _1hwc7vkz _sp8tidpf _26vxftgi _40tuvbgk"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _1e0c1txw _2lx21bp4 _1bah1h6o _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v _19pkidpf _2hwx1wug _otyridpf _18u01wug _1rfm1osq _14b54xhq"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h6", {
                        className: (0, $esG4f.default)([
                            "_syazvwuj _1wyboqnp _1dyzt94y _vwz4cs5v _1pfhidpf _6rth19bv _1p1dangw _k48p1nn1"
                        ]),
                        children: intl.formatMessage({
                            defaultMessage: "Plan ahead, pivot quickly",
                            id: "JSWFeaturesTimeline.subheader"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("h2", {
                        className: (0, $esG4f.default)([
                            "_1e0c1ule _y3gn1h6o _syaz1bqd _1dyzidpf _1pfhidpf _k48pbfng _s7n4nkob _1egldlk8 _1tnt1tcg _1gw8ahaf _1pah11ph _e4kmnkob"
                        ]),
                        children: [
                            intl.formatMessage({
                                defaultMessage: "Timelines",
                                id: "JSWFeaturesTimeline.title"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1bsb14y2 _1e0c1o8l"
                                ])
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8xSOc.default), {
                                appearance: "inprogress",
                                isBold: false,
                                children: intl.formatMessage({
                                    defaultMessage: "Try it",
                                    id: "JSWFeaturesTimeline.tryIt"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_1wyb1j6v _y3gn1h6o _6rth1tcg _1pfhidpf _1bah1h6o"
                            ]),
                            children: intl.formatMessage({
                                id: "JSWFeaturesTimeline.description",
                                defaultMessage: `Use the interactive timeline to try adding epics, mapping work items, dependencies, and releases on a timeline. Timelines keep your teams and stakeholders in sync.`
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                            text: intl.formatMessage({
                                id: "JSWFeaturesTimeline.learnMore",
                                defaultMessage: "Learn more"
                            }),
                            url: (0, $3FBn4.useLocalizedHref)("/software/jira/features/roadmaps"),
                            size: "small",
                            type: "secondary",
                            dataEventProps: {
                                "data-product-key": "jiraSoftwareFeature",
                                "data-event": "clicked",
                                "data-event-component": "linkButton",
                                "data-event-container": "timelineSection"
                            },
                            className: (0, $esG4f.default)([
                                "_1e0c116y"
                            ])
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7Xa9M.JswInteractiveRoadmap), {})
            })
        ]
    });
};
var $2e3c80cf8660ca95$export$2e2bcd8739ae039 = $2e3c80cf8660ca95$var$Timeline;

});
parcelRegister("hkKtl", function(module, exports) {
$parcel$export(module.exports, "JswInteractiveRoadmap", function () { return (parcelRequire("7Xa9M")).JswInteractiveRoadmap; });
parcelRequire("7Xa9M");

});
parcelRegister("7Xa9M", function(module, exports) {

$parcel$export(module.exports, "JswInteractiveRoadmap", function () { return $4fdb8344da1fa190$export$100c02c308bdfe24; });
/* jsw-interactive-roadmap.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $gLMN9 = parcelRequire("gLMN9");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $6gPV0 = parcelRequire("6gPV0");

var $5o5lg = parcelRequire("5o5lg");

var $5KXGt = parcelRequire("5KXGt");

var $1ajZN = parcelRequire("1ajZN");

var $4vr3y = parcelRequire("4vr3y");

var $gx96J = parcelRequire("gx96J");

var $5nZ1S = parcelRequire("5nZ1S");

var $bGWQ7 = parcelRequire("bGWQ7");

var $jUUP7 = parcelRequire("jUUP7");

var $fIM1v = parcelRequire("fIM1v");

var $lz6rS = parcelRequire("lz6rS");
const $4fdb8344da1fa190$export$a2b4f255152a6585 = {
    header0: "epic-header",
    header1: "month-1-header",
    header2: "month-2-header",
    header3: "month-3-header"
};
const $4fdb8344da1fa190$export$100c02c308bdfe24 = ({ initialMonth: initialMonth, store: store = (0, $lz6rS.default) })=>{
    const intl = (0, $f6qj2.default)();
    const locale = intl.locale;
    const epicHeader = /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $fIM1v.messages).epicHeader));
    const date = initialMonth ? (0, (/*@__PURE__*/$parcel$interopDefault($gLMN9)))().set("month", initialMonth).locale(locale) : (0, (/*@__PURE__*/$parcel$interopDefault($gLMN9)))().locale(locale);
    const month1 = /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        children: date.format("MMM")
    });
    const month2 = /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        children: date.add(1, "M").format("MMM")
    });
    const month3 = /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        children: date.add(1, "M").format("MMM")
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5KXGt.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6gPV0.Provider), {
            store: store,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    id: "main-content-wrapper-jsw-interactive-roadmap",
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _bfhku67f _ca0q1ou6 _u5f3idpf _n3td1ou6 _19bvidpf _6rth53f4 _1bsb1aai _4t3i1ogm _1e0c1txw _2lx21bp4 _1bah1h6o _2rko19bv _1reo15vq _18m915vq _16qssz1z _1mjbglyw _4rtxtlke"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _19pkidpf _2hwxf6fq _otyridpf _18u0f6fq _1bah1yb4 _2lx2vrvc"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $1ajZN.AvatarGroupStack), {}),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gx96J.RestartButton), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $jUUP7.SpotlightView), {}),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1bsbtu2u _1e0c1txw _19pkidpf _2hwxf6fq _otyridpf _18u0f6fq _16jlzo7u _1o9zkb7n _i0dlf1ug"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1bsbtu2u _1e0c1txw _16jlzo7u _1o9zkb7n _i0dlf1ug"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nZ1S.RoadmapColumn), {
                                            headerId: $4fdb8344da1fa190$export$a2b4f255152a6585.header0,
                                            columnIndex: 0,
                                            children: epicHeader
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nZ1S.RoadmapColumn), {
                                            headerId: $4fdb8344da1fa190$export$a2b4f255152a6585.header1,
                                            columnIndex: 1,
                                            children: month1
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nZ1S.RoadmapColumn), {
                                            headerId: $4fdb8344da1fa190$export$a2b4f255152a6585.header2,
                                            columnIndex: 2,
                                            children: month2
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nZ1S.RoadmapColumn), {
                                            headerId: $4fdb8344da1fa190$export$a2b4f255152a6585.header3,
                                            columnIndex: 3,
                                            children: month3
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $bGWQ7.RoadmapGrid), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4vr3y.CompleteDemoView), {})
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0cglyw _1mjb1txw _z115h2mm _1s4p1osq _1kne1wug _o5kc1h6o _dh1a1h6o _dhfq1ule _oo7i1wug _136r1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                            alt: "Preview of Jira Software Roadmaps",
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/interactiveTimeline.webp"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_kqswstnw _ahbq1wug _12l21wug"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5o5lg.SpotlightStatic), {})
                        })
                    ]
                })
            ]
        })
    });
};
const $4fdb8344da1fa190$var$MainContentWrapper = null;
const $4fdb8344da1fa190$var$JswRoadmapTable = null;
const $4fdb8344da1fa190$var$JswRoadmapHeader = null;
const $4fdb8344da1fa190$var$HeaderWrapper = null;
const $4fdb8344da1fa190$var$staticImageContainer = null;
const $4fdb8344da1fa190$var$staticSpotlightContainer = null;

});
parcelRegister("5o5lg", function(module, exports) {

$parcel$export(module.exports, "SpotlightStatic", function () { return $40e6d7a6bd387336$export$b294c1d9899a349a; });
/* spotlight-static.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $lyYco = parcelRequire("lyYco");
const $40e6d7a6bd387336$var$spotlightHeader = null;
const $40e6d7a6bd387336$var$spotlightContainer = null;
const $40e6d7a6bd387336$export$b294c1d9899a349a = ()=>{
    const [{ messages: messages }] = (0, $lyYco.useInteractiveBoardStore)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsbg8x7 _4t3i1wug _1e0c1txw _2lx21bp4 _ca0q7vkz _u5f3gktf _n3td7vkz _19bvgktf _2rko7vkz _19it1tdf _bfhku67f _16qsjojz _y3gn1h6o _v4pn1ule _bna71wug _rtys1osq _7bcc1mjv _ho2tr0r7"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/shapesStaticJiraDemo.webp",
                alt: ""
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1pfhidpf _1wybgktf _k48p1fw0 _6rtho7ao _1qjn7vkz"
                ]),
                children: messages.staticSpotlightHeading
            })
        ]
    });
};

});

parcelRegister("1ajZN", function(module, exports) {

$parcel$export(module.exports, "AvatarGroupStack", function () { return $c2cc3241c8b1dc06$export$8c9174c6119d0554; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");

var $fIM1v = parcelRequire("fIM1v");
const $c2cc3241c8b1dc06$export$8c9174c6119d0554 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $fIM1v.messages).avatarGroupLabel), {
        children: (label)=>// eslint-disable-next-line no-restricted-syntax
            /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                src: "https://wac-cdn.atlassian.com/dam/jcr:3187ccc5-05f8-4ab1-bb68-3aee84b38cfb/avatarGroup.svg?cdnVersion=1384",
                height: "26px",
                "aria-label": label
            })
    }));
};

});
parcelRegister("fIM1v", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $22329f1d1dbb38a9$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");

var $3FBn4 = parcelRequire("3FBn4");
const $22329f1d1dbb38a9$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    addChild: {
        id: "JswInteractiveRoadmap.addChild",
        defaultMessage: "Create child story"
    },
    avatarGroupLabel: {
        id: "JswInteractiveRoadmap.avatarGroup",
        defaultMessage: "Collection of user avatars showing team members"
    },
    epic: {
        id: "JswInteractiveRoadmap.epic",
        defaultMessage: "Epic."
    },
    epicHeader: {
        id: "JswInteractiveRoadmap.epicHeader",
        defaultMessage: "Epic"
    },
    restartButton: {
        id: "JswInteractiveRoadmap.restartButton",
        defaultMessage: "Restart demo"
    },
    spotlightHeaderStage1: {
        id: "JswInteractiveRoadmap.spotlightHeaderStage1",
        defaultMessage: "Create an epic"
    },
    spotlightBodyStage1: {
        id: "JswInteractiveRoadmap.spotlightBodyStage1",
        defaultMessage: "Epics represent large bodies of work that can be broken down into individual tasks.\nChoose a name for your epic and enter it in the field to the left."
    },
    spotlightHeaderStage2: {
        id: "JswInteractiveRoadmap.spotlightHeaderStage2",
        defaultMessage: "Add a story"
    },
    spotlightBodyStage2: {
        id: "JswInteractiveRoadmap.spotlightBodyStage2.part1",
        defaultMessage: "<p>Each Epic contains individual tasks known as <strong>Stories.</strong></p><strong>Add a story</strong> by clicking the <strong>+</strong> button to the left",
        values: (0, $3FBn4.DEFAULT_VALUES)
    },
    spotlightHeaderStage3: {
        id: "JswInteractiveRoadmap.spotlightHeaderStage3",
        defaultMessage: "Name your story"
    },
    spotlightBodyStage3: {
        id: "JswInteractiveRoadmap.spotlightBodyStage3",
        defaultMessage: "Describe the task that needs to be done to complete your epic then select enter."
    },
    spotlightHeaderStage4: {
        id: "JswInteractiveRoadmap.spotlightHeaderStage4",
        defaultMessage: "Set a project timeline"
    },
    spotlightBodyStage4: {
        id: "JswInteractiveRoadmap.spotlightBodyStage4",
        defaultMessage: "<p>Timelines represent how long an epic or story takes to complete.</p><strong>Hover</strong> and <strong>select</strong> over the timeline to enter your project dates.",
        values: (0, $3FBn4.DEFAULT_VALUES)
    },
    spotlightHeaderStage5: {
        id: "JswInteractiveRoadmap.spotlightHeaderStage5",
        defaultMessage: "Adjust timelines as plans change"
    },
    spotlightBodyStage5: {
        id: "JswInteractiveRoadmap.spotlightBodyStage5",
        defaultMessage: "Extend or shorten timelines as needed by dragging either ends of the timeline bar."
    },
    spotlightHeaderStage6: {
        id: "JswInteractiveRoadmap.spotlightHeaderStage6",
        defaultMessage: "Map project dependencies"
    },
    spotlightBodyStage6: {
        id: "JswInteractiveRoadmap.spotlightBodyStage6",
        defaultMessage: "Dependencies can show the order that stories need to be done and highlight blockers. Select the link icon to connect stories that rely on each other."
    },
    epicName: {
        id: "JswInteractiveRoadmap.epicName",
        defaultMessage: "Start a lemonade stand"
    },
    story: {
        id: "JswInteractiveRoadmap.Story",
        defaultMessage: "Story."
    },
    story1Name: {
        id: "JswInteractiveRoadmap.story1Name",
        defaultMessage: "Create a cold, crisp, drink"
    },
    story2Name: {
        id: "JswInteractiveRoadmap.story2Name",
        defaultMessage: "Design a sign"
    },
    story3Name: {
        id: "JswInteractiveRoadmap.story3Name",
        defaultMessage: "Setup a lemonade stand"
    },
    updateEpicPlaceholder: {
        id: "JswInteractiveRoadmap.updateEpicPlaceholder",
        defaultMessage: "Epic: What needs to be done?"
    },
    updateStoryPlaceholder: {
        id: "JswInteractiveRoadmap.updateStoryPlaceholder",
        defaultMessage: "Story: What needs to be done?"
    },
    completeDemoModalHeader: {
        id: "JswInteractiveRoadmap.completeDemoModalHeader",
        defaultMessage: "Congrats, you're timeline-ready!"
    },
    completeDemoModalSubheader: {
        id: "JswInteractiveRoadmap.completeDemoModalSubheader",
        defaultMessage: "You've learned how to create epics and stories that will help keep your team on track. Close to continue adding other stories to your project or start for free in Jira."
    },
    completeDemoModalButton: {
        id: "JswInteractiveRoadmap.completeDemoModalButton",
        defaultMessage: "Get Jira free"
    },
    closeDemoModalButton: {
        id: "JswInteractiveRoadmap.closeDemoModalButton",
        defaultMessage: "Close"
    },
    unlinkChildStoryButton: {
        id: "JswInteractiveRoadmap.unlinkChildStoryButton",
        defaultMessage: "Unlink child story"
    },
    linkStoriesButton: {
        id: "JswInteractiveRoadmap.linkStoriesButton",
        defaultMessage: "Link stories"
    },
    activateToEditTextDescription: {
        id: "JswInteractiveRoadmap.activateToEditTextDescription",
        defaultMessage: "Activate to edit text."
    },
    ariaLabelLeftVerticalRoadmapBar: {
        id: "JswInteractiveRoadmap.ariaLabelLeftVerticalRoadmapBar",
        defaultMessage: "Left-side vertical line on timeline bar. Press space to toggle edit width."
    },
    ariaLabelRightVerticalRoadmapBar: {
        id: "JswInteractiveRoadmap.ariaLabelRightVerticalRoadmapBar",
        defaultMessage: "Right-side vertical line on timeline bar. Press space to toggle edit width."
    },
    ariaLabelSpacebarToEditKeyPress: {
        id: "JswInteractiveRoadmap.ariaLabelSpacebarToEditKeyPress",
        defaultMessage: "Press A or D keys to edit width of bar"
    },
    ariaLabelSpacebarToPlaceKeyPress: {
        id: "JswInteractiveRoadmap.ariaLabelSpacebarToPlaceKeyPress",
        defaultMessage: "Placing width of timeline bar"
    },
    ariaLabelLeftArrowPress: {
        id: "JswInteractiveRoadmap.ariaLabelLeftArrowKeyPress",
        defaultMessage: "Timeline bar decremented"
    },
    ariaLabelRightArrowPress: {
        id: "JswInteractiveRoadmap.ariaLabelRightArrowPress",
        defaultMessage: "Timeline bar incremented"
    }
});

});


parcelRegister("4vr3y", function(module, exports) {

$parcel$export(module.exports, "CompleteDemoView", function () { return $1dc6cb0263c8c721$export$3ab79cc5b435fc55; });
/* demo-complete-modal.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable jsx-a11y/no-autofocus */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $6IiXU = parcelRequire("6IiXU");

var $8KELJ = parcelRequire("8KELJ");
var $bh8PA = parcelRequire("bh8PA");

var $6k5Ux = parcelRequire("6k5Ux");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $fIM1v = parcelRequire("fIM1v");
parcelRequire("jdqkE");
var $bb1RF = parcelRequire("bb1RF");

var $gtUh9 = parcelRequire("gtUh9");
const $1dc6cb0263c8c721$export$3ab79cc5b435fc55 = ()=>{
    const dispatch = (0, $gtUh9.useAppDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const ctaRef = (0, $iSvIT.useRef)(null);
    const signupHref = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup");
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const openModal = (0, $iSvIT.useCallback)(()=>setIsOpen(true), []);
    const closeModal = (0, $iSvIT.useCallback)(()=>setIsOpen(false), []);
    const [state, isDemoComplete] = (0, $gtUh9.useAppSelector)(({ interactive_state: interactive_state, isDemoComplete: isDemoComplete })=>[
            interactive_state,
            isDemoComplete
        ]);
    const renderComponent = (0, $iSvIT.useMemo)(()=>state === (0, $bb1RF.Actions).COMPLETE_DEMO && !isDemoComplete, [
        state,
        isDemoComplete
    ]);
    const ANIMATION_DELAY = 1500;
    (0, $iSvIT.useEffect)(()=>{
        if (renderComponent) setTimeout(()=>{
            openModal();
            createAnalyticsEvent({
                action: "viewed",
                actionSubject: "modal",
                name: "interactiveRoadmapCelebrationModal",
                eventType: "screen"
            }).fire();
        }, ANIMATION_DELAY);
    }, [
        renderComponent
    ]);
    const getItFreeClick = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "interactiveRoadmapGetItFree",
            eventType: "ui",
            attributes: {
                href: {
                    signupHref: signupHref
                },
                label: "Get it free"
            }
        }).fire();
    };
    const closeModalClick = ()=>{
        var _document_getElementById;
        closeModal();
        dispatch((0, $bb1RF.completeDemo)());
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "interactiveRoadmapModalCompleteClose",
            eventType: "ui"
        }).fire();
        (_document_getElementById = document.getElementById("dependency-unlink-btn")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.focus();
    };
    if (!renderComponent) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "complete-demo-modal-container",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bh8PA.default), {
            children: isOpen && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8KELJ.default), {
                autoFocus: ctaRef,
                onClose: closeModalClick,
                width: 440,
                testId: "demo-complete-modal",
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1vif _4t3i6h4w _2rko1l7b _1q5114y2 _19it10rt _11q715cr _16qs1wkx"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx2vrvc _1bsb1osq _1bah1yb4 _4cvr1y6m _4t3i1wug _19pk19bv _2hwxidpf _otyr19bv _18u0idpf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1bsb9by0"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1lrw1f51 _12vemgnk _ouxl1ssb _4t3i4d55 _1bsb1d57 _1itkwsox"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1bsb9by0"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6k5Ux.CloseModalButton), {
                                        onCloseClick: closeModalClick
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_19pk19bv _2hwxo7ao _otyr19bv _18u0o7ao _syaz1hlo _ect4bzd7 _1wybgktf _zg8l4jg8 _k48p1fw0 _vwz41tcg _1dyznl7k"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $fIM1v.messages).completeDemoModalHeader))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_syaz1hlo _ect4bzd7 _1wyb7vkz _zg8l4jg8 _k48p1nn1 _vwz41tcg _19pk19bv _2hwxo7ao _otyr19bv _18u0o7ao"
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $fIM1v.messages).completeDemoModalSubheader))
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                            testId: "get-it-free-btn",
                            appearance: "primary",
                            ref: ctaRef,
                            href: signupHref,
                            onClick: getItFreeClick,
                            className: (0, $esG4f.default)([
                                "_19pk19bv _2hwxidpf _otyr1tcg _18u0o7ao _1wybdlk8"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $fIM1v.messages).completeDemoModalButton))
                        })
                    ]
                })
            })
        })
    });
};
const $1dc6cb0263c8c721$var$ModalBackground = null;
const $1dc6cb0263c8c721$var$ModalHeader = null;
const $1dc6cb0263c8c721$var$HeaderRight = null;
const $1dc6cb0263c8c721$var$HeaderLeft = null;
const $1dc6cb0263c8c721$var$HeaderCenter = {
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "232px",
    width: "239px"
};
const $1dc6cb0263c8c721$var$ModalTitle = null;
const $1dc6cb0263c8c721$var$ModalSubheading = null;
const $1dc6cb0263c8c721$var$GetFreeButton = null;

});
parcelRegister("jdqkE", function(module, exports) {
$parcel$export(module.exports, "Actions", function () { return (parcelRequire("bb1RF")).Actions; });
$parcel$export(module.exports, "addStory", function () { return (parcelRequire("bb1RF")).addStory; });
$parcel$export(module.exports, "completeDemo", function () { return (parcelRequire("bb1RF")).completeDemo; });
$parcel$export(module.exports, "mapProjectDependicies", function () { return (parcelRequire("bb1RF")).mapProjectDependicies; });
$parcel$export(module.exports, "setEditModeItem", function () { return (parcelRequire("bb1RF")).setEditModeItem; });
$parcel$export(module.exports, "unlinkDependency", function () { return (parcelRequire("bb1RF")).unlinkDependency; });
$parcel$export(module.exports, "updateEpic", function () { return (parcelRequire("bb1RF")).updateEpic; });
$parcel$export(module.exports, "updateStory", function () { return (parcelRequire("bb1RF")).updateStory; });
parcelRequire("bb1RF");
parcelRequire("aeFQk");

});
parcelRegister("bb1RF", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $edff3c16037a47db$export$b52183d5cfb26dc9; });
$parcel$export(module.exports, "updateEpic", function () { return $edff3c16037a47db$export$e5e34aaba2e78c9b; });
$parcel$export(module.exports, "addStory", function () { return $edff3c16037a47db$export$d6f3e7ca92f04d61; });
$parcel$export(module.exports, "updateStory", function () { return $edff3c16037a47db$export$954c0903301a2307; });
$parcel$export(module.exports, "setProjectTimeline", function () { return $edff3c16037a47db$export$736429ae9dfcdc28; });
$parcel$export(module.exports, "adjustProjectTimeline", function () { return $edff3c16037a47db$export$21943c1e94e69d25; });
$parcel$export(module.exports, "mapProjectDependicies", function () { return $edff3c16037a47db$export$c24730f38f082a57; });
$parcel$export(module.exports, "completeDemo", function () { return $edff3c16037a47db$export$bb266ba875f07fab; });
$parcel$export(module.exports, "resetDemo", function () { return $edff3c16037a47db$export$da3f8d114e8c057b; });
$parcel$export(module.exports, "unlinkDependency", function () { return $edff3c16037a47db$export$1352f443626b6096; });
$parcel$export(module.exports, "setEditModeItem", function () { return $edff3c16037a47db$export$a329796e59d82286; });

var $4m2lj = parcelRequire("4m2lj");
var $edff3c16037a47db$export$b52183d5cfb26dc9;
(function(Actions) {
    Actions["UPDATE_EPIC"] = "[JSW INTERACTIVE ROADMAP] UPDATE_EPIC";
    Actions["ADD_STORY"] = "[JSW INTERACTIVE ROADMAP] ADD_STORY";
    Actions["SET_EDIT_MODE_ITEM"] = "[JSW INTERACTIVE ROADMAP] SET_EDIT_MODE_ITEM";
    Actions["UPDATE_STORY"] = "[JSW INTERACTIVE ROADMAP] UPDATE_STORY";
    Actions["SET_PROJECT_TIMELINE"] = "[JSW INTERACTIVE ROADMAP] SET_PROJECT_TIMELINE";
    Actions["ADJUST_PROJECT_TIMELINE"] = "[JSW INTERACTIVE ROADMAP] ADJUST_PROJECT_TIMELINE";
    Actions["MAP_PROJECT_DEPENDENCIES"] = "[JSW INTERACTIVE ROADMAP] MAP_PROJECT_DEPENDENCIES";
    Actions["RESET_DEMO"] = "[JSW INTERACTIVE ROADMAP]\xa0RESET_DEMO";
    Actions["COMPLETE_DEMO"] = "[JSW INTERACTIVE ROADMAP] COMPLETE_DEMO";
    Actions["UNLINK_DEPENDENCY"] = "[JSW INTERACTIVE ROADMAP] UNLINK_DEPENDENCY";
})($edff3c16037a47db$export$b52183d5cfb26dc9 || ($edff3c16037a47db$export$b52183d5cfb26dc9 = {}));
const $edff3c16037a47db$export$e5e34aaba2e78c9b = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP] UPDATE_EPIC");
const $edff3c16037a47db$export$d6f3e7ca92f04d61 = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP] ADD_STORY");
const $edff3c16037a47db$export$954c0903301a2307 = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP] UPDATE_STORY");
const $edff3c16037a47db$export$736429ae9dfcdc28 = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP] SET_PROJECT_TIMELINE");
const $edff3c16037a47db$export$21943c1e94e69d25 = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP] ADJUST_PROJECT_TIMELINE");
const $edff3c16037a47db$export$c24730f38f082a57 = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP] MAP_PROJECT_DEPENDENCIES");
const $edff3c16037a47db$export$bb266ba875f07fab = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP] COMPLETE_DEMO");
const $edff3c16037a47db$export$da3f8d114e8c057b = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP]\xa0RESET_DEMO");
const $edff3c16037a47db$export$1352f443626b6096 = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP] UNLINK_DEPENDENCY");
const $edff3c16037a47db$export$a329796e59d82286 = (0, $4m2lj.createAction)("[JSW INTERACTIVE ROADMAP] SET_EDIT_MODE_ITEM");

});

parcelRegister("aeFQk", function(module, exports) {

$parcel$export(module.exports, "initialState", function () { return $2225ea0deff7d126$export$d4c72bab9d6cc13a; });
$parcel$export(module.exports, "reducer", function () { return $2225ea0deff7d126$export$1650419e431d3ba3; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $4m2lj = parcelRequire("4m2lj");

var $ifJ9E = parcelRequire("ifJ9E");

var $48zDN = parcelRequire("48zDN");

var $fIM1v = parcelRequire("fIM1v");

var $4TAbX = parcelRequire("4TAbX");

var $bb1RF = parcelRequire("bb1RF");
const $2225ea0deff7d126$export$693686a8550d879b = new Map([
    [
        (0, $bb1RF.Actions).UPDATE_EPIC,
        {
            header: (0, $fIM1v.messages).spotlightHeaderStage1,
            body: (0, $fIM1v.messages).spotlightBodyStage1,
            posX: 293,
            posY: 286
        }
    ],
    [
        (0, $bb1RF.Actions).ADD_STORY,
        {
            header: (0, $fIM1v.messages).spotlightHeaderStage2,
            body: (0, $fIM1v.messages).spotlightBodyStage2,
            posX: 270,
            posY: 286
        }
    ],
    [
        (0, $bb1RF.Actions).UPDATE_STORY,
        {
            header: (0, $fIM1v.messages).spotlightHeaderStage3,
            body: (0, $fIM1v.messages).spotlightBodyStage3,
            posX: 297,
            posY: 321
        }
    ],
    [
        (0, $bb1RF.Actions).SET_PROJECT_TIMELINE,
        {
            header: (0, $fIM1v.messages).spotlightHeaderStage4,
            body: (0, $fIM1v.messages).spotlightBodyStage4,
            posX: 495,
            posY: 321
        }
    ],
    [
        (0, $bb1RF.Actions).ADJUST_PROJECT_TIMELINE,
        {
            header: (0, $fIM1v.messages).spotlightHeaderStage5,
            body: (0, $fIM1v.messages).spotlightBodyStage5,
            posX: 505,
            posY: 321
        }
    ],
    [
        (0, $bb1RF.Actions).MAP_PROJECT_DEPENDENCIES,
        {
            header: (0, $fIM1v.messages).spotlightHeaderStage6,
            body: (0, $fIM1v.messages).spotlightBodyStage6,
            posX: 520,
            posY: 209
        }
    ],
    [
        (0, $bb1RF.Actions).RESET_DEMO,
        {
            header: (0, $fIM1v.messages).spotlightHeaderStage1,
            body: (0, $fIM1v.messages).spotlightBodyStage1,
            posX: 0,
            posY: 0
        }
    ],
    [
        (0, $bb1RF.Actions).COMPLETE_DEMO,
        undefined
    ]
]);
/**
 * Represents the initial state of the interactive roadmap.  This is also used when the demo is reset.
 */ // Previously, we used the `v4` function from the uuid module to generate UUIDs and used the `polyfillGetRandomValuesIfNecessary` function
// to define the `getRandomValues` method on crypto. However, due to SSR compilation,
// this code is compiled before runtime and the crypto library is undefined at that point.
const $2225ea0deff7d126$var$initialEpicId = (0, $4TAbX.generateUuid)();
const $2225ea0deff7d126$export$d4c72bab9d6cc13a = {
    editModeItemId: $2225ea0deff7d126$var$initialEpicId,
    isDemoComplete: false,
    interactive_state: (0, $bb1RF.Actions).UPDATE_EPIC,
    dependency_state: "UNLINKED",
    epics: [
        {
            id: (0, $4TAbX.generateUuid)(),
            name: (0, $fIM1v.messages).epicName,
            mode: "VIEW",
            children: [
                {
                    id: (0, $4TAbX.generateUuid)(),
                    name: (0, $fIM1v.messages).story1Name,
                    start: 2,
                    end: 3
                },
                {
                    id: (0, $4TAbX.generateUuid)(),
                    name: (0, $fIM1v.messages).story2Name,
                    start: 2,
                    end: 3
                },
                {
                    id: (0, $4TAbX.generateUuid)(),
                    name: (0, $fIM1v.messages).story3Name,
                    start: 3,
                    end: 4
                }
            ]
        },
        {
            id: $2225ea0deff7d126$var$initialEpicId,
            name: "",
            mode: "EDIT",
            children: []
        }
    ],
    spotlight: $2225ea0deff7d126$export$693686a8550d879b.get((0, $bb1RF.Actions).UPDATE_EPIC)
};
const $2225ea0deff7d126$export$1650419e431d3ba3 = (state)=>(0, $4m2lj.createReducer)(state, (builder)=>builder.addCase((0, $bb1RF.updateEpic), (state, { payload: payload })=>{
            const interactive_state = state.isDemoComplete ? (0, $bb1RF.Actions).COMPLETE_DEMO : (0, $bb1RF.Actions).ADD_STORY;
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            const epic = newState.epics[payload.epicIndex];
            epic.name = payload.epicName;
            epic.canClickAddButton = epic.children.length < 5 && payload.epicIndex === 1;
            const spotlight = $2225ea0deff7d126$export$693686a8550d879b.get(interactive_state);
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                interactive_state: interactive_state,
                spotlight: spotlight,
                editModeItemId: undefined
            });
        }).addCase((0, $bb1RF.addStory), (state)=>{
            var _newState_epics__children, _newState_epics_;
            const editModeItemId = (0, $4TAbX.generateUuid)();
            const interactive_state = (0, $bb1RF.Actions).UPDATE_STORY;
            // do not spotlight if demo is complete.
            const spotlight = state.isDemoComplete ? undefined : $2225ea0deff7d126$export$693686a8550d879b.get(interactive_state);
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            const hideFromRoadmap = ((_newState_epics__children = newState.epics[1].children) === null || _newState_epics__children === void 0 ? void 0 : _newState_epics__children.length) > 0; // can only set project timeline for first story.
            (_newState_epics_ = newState.epics[1]) === null || _newState_epics_ === void 0 ? void 0 : _newState_epics_.children.push({
                id: editModeItemId,
                name: "",
                start: 2,
                end: 3,
                color: (0, $48zDN.P200),
                isVisible: false,
                hideFromRoadmap: hideFromRoadmap,
                lineColor: (0, $48zDN.P500)
            });
            //  temporarily disable click add button if it has just been clicked.
            if (newState.epics[1]) newState.epics[1].canClickAddButton = false;
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                interactive_state: interactive_state,
                spotlight: spotlight,
                editModeItemId: editModeItemId
            });
        }).addCase((0, $bb1RF.updateStory), (state, { payload: payload })=>{
            var _newState_epics_payload_epicIndex;
            // go back to ADD_STORY if demo is complete
            const interactive_state = state.isDemoComplete ? (0, $bb1RF.Actions).ADD_STORY : (0, $bb1RF.Actions).SET_PROJECT_TIMELINE;
            // do not spotlight if demo is complete.
            const spotlight = state.isDemoComplete ? undefined : $2225ea0deff7d126$export$693686a8550d879b.get(interactive_state);
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            // do not allow on click event if demo is complete.
            const onClickPayloadAction = state.isDemoComplete ? undefined : (0, $bb1RF.setProjectTimeline)({
                storyIndex: payload.storyIndex
            });
            const name = payload.storyName;
            const canAdjust = true;
            const story = (_newState_epics_payload_epicIndex = newState.epics[payload.epicIndex]) === null || _newState_epics_payload_epicIndex === void 0 ? void 0 : _newState_epics_payload_epicIndex.children[payload.storyIndex];
            newState.epics[payload.epicIndex].children[payload.storyIndex] = (0, $6iHNw._)((0, $7Knp0._)({}, story), {
                name: name,
                canAdjust: canAdjust,
                onClickPayloadAction: onClickPayloadAction
            });
            // only allow click add button if there are less than 5 stories and the demo is complete
            const epic = newState.epics[payload.epicIndex];
            epic.canClickAddButton = epic.children.length < 5 && payload.epicIndex === 1 && state.isDemoComplete;
            if (state.isDemoComplete) {
                const story = epic === null || epic === void 0 ? void 0 : epic.children[payload.storyIndex];
                story.canAdjust = true;
                story.onClickPayloadAction = (0, $bb1RF.setProjectTimeline)({
                    storyIndex: payload.storyIndex
                });
            }
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                editModeItemId: undefined,
                interactive_state: interactive_state,
                spotlight: spotlight
            });
        }).addCase((0, $bb1RF.setProjectTimeline), (state, { payload: payload })=>{
            var _newState_epics_;
            const interactive_state = state.isDemoComplete ? (0, $bb1RF.Actions).COMPLETE_DEMO : (0, $bb1RF.Actions).ADJUST_PROJECT_TIMELINE;
            const spotlight = $2225ea0deff7d126$export$693686a8550d879b.get(interactive_state);
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            const onMouseDownAndLeavePayloadAction = (0, $bb1RF.adjustProjectTimeline)({
                storyIndex: payload.storyIndex
            });
            const story = (_newState_epics_ = newState.epics[1]) === null || _newState_epics_ === void 0 ? void 0 : _newState_epics_.children[payload.storyIndex];
            const onClickPayloadAction = null;
            const isVisible = true;
            const canAdjust = state.isDemoComplete ? state.dependency_state === "UNLINKED" : true;
            if (newState.epics[1]) newState.epics[1].children[payload.storyIndex] = (0, $6iHNw._)((0, $7Knp0._)({}, story), {
                onMouseDownAndLeavePayloadAction: onMouseDownAndLeavePayloadAction,
                onClickPayloadAction: onClickPayloadAction,
                isVisible: isVisible,
                canAdjust: canAdjust
            });
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                interactive_state: interactive_state,
                spotlight: spotlight
            });
        }).addCase((0, $bb1RF.adjustProjectTimeline), (state, { payload: payload })=>{
            const interactive_state = (0, $bb1RF.Actions).MAP_PROJECT_DEPENDENCIES;
            const spotlight = $2225ea0deff7d126$export$693686a8550d879b.get(interactive_state);
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            if (newState.epics[1]) {
                const story = newState.epics[1].children[payload.storyIndex];
                story.start = 2;
                story.end = 4;
                story.canAdjust = state.isDemoComplete ? true : false;
                story.onMouseDownAndLeavePayloadAction = undefined;
            }
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                interactive_state: interactive_state,
                spotlight: spotlight
            });
        }).addCase((0, $bb1RF.mapProjectDependicies), (state)=>{
            const interactive_state = (0, $bb1RF.Actions).COMPLETE_DEMO;
            const spotlight = $2225ea0deff7d126$export$693686a8550d879b.get(interactive_state);
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                interactive_state: interactive_state,
                spotlight: spotlight,
                dependency_state: "LINKED"
            });
        }).addCase((0, $bb1RF.completeDemo), (state)=>{
            const interactive_state = (0, $bb1RF.Actions).ADD_STORY;
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            if (newState.epics[1]) newState.epics[1].canClickAddButton = true;
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                interactive_state: interactive_state,
                isDemoComplete: true
            });
        }).addCase((0, $bb1RF.setEditModeItem), (state, { payload: payload })=>{
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                editModeItemId: payload.id
            });
        }).addCase((0, $bb1RF.resetDemo), ()=>{
            var _newState_epics_;
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            // generate new id to force re-render
            for (const epic of newState.epics){
                epic.id = (0, $4TAbX.generateUuid)();
                for (const story of epic.children)story.id = (0, $4TAbX.generateUuid)();
            }
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                editModeItemId: (_newState_epics_ = newState.epics[1]) === null || _newState_epics_ === void 0 ? void 0 : _newState_epics_.id
            });
        }).addCase((0, $bb1RF.unlinkDependency), (state)=>{
            const newState = (0, (/*@__PURE__*/$parcel$interopDefault($ifJ9E)))(state);
            // allow user to adjust the roadmap bars once stories are unlinked
            for (const epic of newState.epics)for (const story of epic.children){
                story.canAdjust = true;
                story.onClickPayloadAction = (0, $bb1RF.setProjectTimeline)({
                    storyIndex: Number(epic.children.indexOf(story))
                });
            }
            return (0, $6iHNw._)((0, $7Knp0._)({}, newState), {
                dependency_state: "UNLINKED"
            });
        }));

});
parcelRegister("ifJ9E", function(module, exports) {

var $aDVCx = parcelRequire("aDVCx");
/** Used to compose bitmasks for cloning. */ var $d49ca77d85af0245$var$CLONE_DEEP_FLAG = 1, $d49ca77d85af0245$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d49ca77d85af0245$var$cloneDeep(value) {
    return $aDVCx(value, $d49ca77d85af0245$var$CLONE_DEEP_FLAG | $d49ca77d85af0245$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $d49ca77d85af0245$var$cloneDeep;

});
parcelRegister("aDVCx", function(module, exports) {

var $bcztx = parcelRequire("bcztx");

var $kCpJc = parcelRequire("kCpJc");

var $YhKXQ = parcelRequire("YhKXQ");

var $60TuD = parcelRequire("60TuD");

var $a199s = parcelRequire("a199s");

var $ekHfp = parcelRequire("ekHfp");

var $c7nuc = parcelRequire("c7nuc");

var $cAkgJ = parcelRequire("cAkgJ");

var $atZ4f = parcelRequire("atZ4f");

var $aN7pp = parcelRequire("aN7pp");

var $1COSs = parcelRequire("1COSs");

var $iHlaM = parcelRequire("iHlaM");

var $emPEU = parcelRequire("emPEU");

var $8kbiR = parcelRequire("8kbiR");

var $2gQfZ = parcelRequire("2gQfZ");

var $epu4p = parcelRequire("epu4p");

var $jageE = parcelRequire("jageE");

var $02pdv = parcelRequire("02pdv");

var $7jN5Q = parcelRequire("7jN5Q");

var $dgn1L = parcelRequire("dgn1L");

var $ldH3d = parcelRequire("ldH3d");

var $kiLG8 = parcelRequire("kiLG8");
/** Used to compose bitmasks for cloning. */ var $7bfa3e23e958bd0b$var$CLONE_DEEP_FLAG = 1, $7bfa3e23e958bd0b$var$CLONE_FLAT_FLAG = 2, $7bfa3e23e958bd0b$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $7bfa3e23e958bd0b$var$argsTag = "[object Arguments]", $7bfa3e23e958bd0b$var$arrayTag = "[object Array]", $7bfa3e23e958bd0b$var$boolTag = "[object Boolean]", $7bfa3e23e958bd0b$var$dateTag = "[object Date]", $7bfa3e23e958bd0b$var$errorTag = "[object Error]", $7bfa3e23e958bd0b$var$funcTag = "[object Function]", $7bfa3e23e958bd0b$var$genTag = "[object GeneratorFunction]", $7bfa3e23e958bd0b$var$mapTag = "[object Map]", $7bfa3e23e958bd0b$var$numberTag = "[object Number]", $7bfa3e23e958bd0b$var$objectTag = "[object Object]", $7bfa3e23e958bd0b$var$regexpTag = "[object RegExp]", $7bfa3e23e958bd0b$var$setTag = "[object Set]", $7bfa3e23e958bd0b$var$stringTag = "[object String]", $7bfa3e23e958bd0b$var$symbolTag = "[object Symbol]", $7bfa3e23e958bd0b$var$weakMapTag = "[object WeakMap]";
var $7bfa3e23e958bd0b$var$arrayBufferTag = "[object ArrayBuffer]", $7bfa3e23e958bd0b$var$dataViewTag = "[object DataView]", $7bfa3e23e958bd0b$var$float32Tag = "[object Float32Array]", $7bfa3e23e958bd0b$var$float64Tag = "[object Float64Array]", $7bfa3e23e958bd0b$var$int8Tag = "[object Int8Array]", $7bfa3e23e958bd0b$var$int16Tag = "[object Int16Array]", $7bfa3e23e958bd0b$var$int32Tag = "[object Int32Array]", $7bfa3e23e958bd0b$var$uint8Tag = "[object Uint8Array]", $7bfa3e23e958bd0b$var$uint8ClampedTag = "[object Uint8ClampedArray]", $7bfa3e23e958bd0b$var$uint16Tag = "[object Uint16Array]", $7bfa3e23e958bd0b$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $7bfa3e23e958bd0b$var$cloneableTags = {};
$7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$argsTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$arrayTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$arrayBufferTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$dataViewTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$boolTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$dateTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$float32Tag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$float64Tag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$int8Tag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$int16Tag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$int32Tag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$mapTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$numberTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$objectTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$regexpTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$setTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$stringTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$symbolTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$uint8Tag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$uint8ClampedTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$uint16Tag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$uint32Tag] = true;
$7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$errorTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$funcTag] = $7bfa3e23e958bd0b$var$cloneableTags[$7bfa3e23e958bd0b$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $7bfa3e23e958bd0b$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $7bfa3e23e958bd0b$var$CLONE_DEEP_FLAG, isFlat = bitmask & $7bfa3e23e958bd0b$var$CLONE_FLAT_FLAG, isFull = bitmask & $7bfa3e23e958bd0b$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$7jN5Q(value)) return value;
    var isArr = $epu4p(value);
    if (isArr) {
        result = $emPEU(value);
        if (!isDeep) return $c7nuc(value, result);
    } else {
        var tag = $iHlaM(value), isFunc = tag == $7bfa3e23e958bd0b$var$funcTag || tag == $7bfa3e23e958bd0b$var$genTag;
        if ($jageE(value)) return $ekHfp(value, isDeep);
        if (tag == $7bfa3e23e958bd0b$var$objectTag || tag == $7bfa3e23e958bd0b$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $2gQfZ(value);
            if (!isDeep) return isFlat ? $atZ4f(value, $a199s(result, value)) : $cAkgJ(value, $60TuD(result, value));
        } else {
            if (!$7bfa3e23e958bd0b$var$cloneableTags[tag]) return object ? value : {};
            result = $8kbiR(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $bcztx);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($dgn1L(value)) value.forEach(function(subValue) {
        result.add($7bfa3e23e958bd0b$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($02pdv(value)) value.forEach(function(subValue, key) {
        result.set(key, $7bfa3e23e958bd0b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $1COSs : $aN7pp : isFlat ? $kiLG8 : $ldH3d;
    var props = isArr ? undefined : keysFunc(value);
    $kCpJc(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $YhKXQ(result, key, $7bfa3e23e958bd0b$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $7bfa3e23e958bd0b$var$baseClone;

});
parcelRegister("kCpJc", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $f02b5048566dbe95$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $f02b5048566dbe95$var$arrayEach;

});

parcelRegister("60TuD", function(module, exports) {

var $3KWOe = parcelRequire("3KWOe");

var $ldH3d = parcelRequire("ldH3d");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $460dc9f10ee370e1$var$baseAssign(object, source) {
    return object && $3KWOe(source, $ldH3d(source), object);
}
module.exports = $460dc9f10ee370e1$var$baseAssign;

});

parcelRegister("a199s", function(module, exports) {

var $3KWOe = parcelRequire("3KWOe");

var $kiLG8 = parcelRequire("kiLG8");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $74b118afcc6a6745$var$baseAssignIn(object, source) {
    return object && $3KWOe(source, $kiLG8(source), object);
}
module.exports = $74b118afcc6a6745$var$baseAssignIn;

});

parcelRegister("cAkgJ", function(module, exports) {

var $3KWOe = parcelRequire("3KWOe");

var $kqsZv = parcelRequire("kqsZv");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $929891d0ae36d8c2$var$copySymbols(source, object) {
    return $3KWOe(source, $kqsZv(source), object);
}
module.exports = $929891d0ae36d8c2$var$copySymbols;

});

parcelRegister("atZ4f", function(module, exports) {

var $3KWOe = parcelRequire("3KWOe");

var $6nmtT = parcelRequire("6nmtT");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $7a1bfb8cd01ee897$var$copySymbolsIn(source, object) {
    return $3KWOe(source, $6nmtT(source), object);
}
module.exports = $7a1bfb8cd01ee897$var$copySymbolsIn;

});
parcelRegister("6nmtT", function(module, exports) {

var $1qvtu = parcelRequire("1qvtu");

var $i0aei = parcelRequire("i0aei");

var $kqsZv = parcelRequire("kqsZv");

var $g7VYj = parcelRequire("g7VYj");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4a46545e275e25a7$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $4a46545e275e25a7$var$getSymbolsIn = !$4a46545e275e25a7$var$nativeGetSymbols ? $g7VYj : function(object) {
    var result = [];
    while(object){
        $1qvtu(result, $kqsZv(object));
        object = $i0aei(object);
    }
    return result;
};
module.exports = $4a46545e275e25a7$var$getSymbolsIn;

});


parcelRegister("1COSs", function(module, exports) {

var $4OMfZ = parcelRequire("4OMfZ");

var $6nmtT = parcelRequire("6nmtT");

var $kiLG8 = parcelRequire("kiLG8");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $12f0ce35f3d0e57e$var$getAllKeysIn(object) {
    return $4OMfZ(object, $kiLG8, $6nmtT);
}
module.exports = $12f0ce35f3d0e57e$var$getAllKeysIn;

});

parcelRegister("emPEU", function(module, exports) {
/** Used for built-in method references. */ var $a75b311f7b229501$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a75b311f7b229501$var$hasOwnProperty = $a75b311f7b229501$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $a75b311f7b229501$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $a75b311f7b229501$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $a75b311f7b229501$var$initCloneArray;

});

parcelRegister("8kbiR", function(module, exports) {

var $bJUVy = parcelRequire("bJUVy");

var $48fqa = parcelRequire("48fqa");

var $6VqGn = parcelRequire("6VqGn");

var $ehHe3 = parcelRequire("ehHe3");

var $gFMRp = parcelRequire("gFMRp");
/** `Object#toString` result references. */ var $60f8f58b570643d8$var$boolTag = "[object Boolean]", $60f8f58b570643d8$var$dateTag = "[object Date]", $60f8f58b570643d8$var$mapTag = "[object Map]", $60f8f58b570643d8$var$numberTag = "[object Number]", $60f8f58b570643d8$var$regexpTag = "[object RegExp]", $60f8f58b570643d8$var$setTag = "[object Set]", $60f8f58b570643d8$var$stringTag = "[object String]", $60f8f58b570643d8$var$symbolTag = "[object Symbol]";
var $60f8f58b570643d8$var$arrayBufferTag = "[object ArrayBuffer]", $60f8f58b570643d8$var$dataViewTag = "[object DataView]", $60f8f58b570643d8$var$float32Tag = "[object Float32Array]", $60f8f58b570643d8$var$float64Tag = "[object Float64Array]", $60f8f58b570643d8$var$int8Tag = "[object Int8Array]", $60f8f58b570643d8$var$int16Tag = "[object Int16Array]", $60f8f58b570643d8$var$int32Tag = "[object Int32Array]", $60f8f58b570643d8$var$uint8Tag = "[object Uint8Array]", $60f8f58b570643d8$var$uint8ClampedTag = "[object Uint8ClampedArray]", $60f8f58b570643d8$var$uint16Tag = "[object Uint16Array]", $60f8f58b570643d8$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $60f8f58b570643d8$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $60f8f58b570643d8$var$arrayBufferTag:
            return $bJUVy(object);
        case $60f8f58b570643d8$var$boolTag:
        case $60f8f58b570643d8$var$dateTag:
            return new Ctor(+object);
        case $60f8f58b570643d8$var$dataViewTag:
            return $48fqa(object, isDeep);
        case $60f8f58b570643d8$var$float32Tag:
        case $60f8f58b570643d8$var$float64Tag:
        case $60f8f58b570643d8$var$int8Tag:
        case $60f8f58b570643d8$var$int16Tag:
        case $60f8f58b570643d8$var$int32Tag:
        case $60f8f58b570643d8$var$uint8Tag:
        case $60f8f58b570643d8$var$uint8ClampedTag:
        case $60f8f58b570643d8$var$uint16Tag:
        case $60f8f58b570643d8$var$uint32Tag:
            return $gFMRp(object, isDeep);
        case $60f8f58b570643d8$var$mapTag:
            return new Ctor;
        case $60f8f58b570643d8$var$numberTag:
        case $60f8f58b570643d8$var$stringTag:
            return new Ctor(object);
        case $60f8f58b570643d8$var$regexpTag:
            return $6VqGn(object);
        case $60f8f58b570643d8$var$setTag:
            return new Ctor;
        case $60f8f58b570643d8$var$symbolTag:
            return $ehHe3(object);
    }
}
module.exports = $60f8f58b570643d8$var$initCloneByTag;

});
parcelRegister("48fqa", function(module, exports) {

var $bJUVy = parcelRequire("bJUVy");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $3023df19752b275c$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $bJUVy(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $3023df19752b275c$var$cloneDataView;

});

parcelRegister("6VqGn", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $50acc38669db365f$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $50acc38669db365f$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $50acc38669db365f$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $50acc38669db365f$var$cloneRegExp;

});

parcelRegister("ehHe3", function(module, exports) {

var $56Gbz = parcelRequire("56Gbz");
/** Used to convert symbols to primitives and strings. */ var $a6642ef24ecc2bfa$var$symbolProto = $56Gbz ? $56Gbz.prototype : undefined, $a6642ef24ecc2bfa$var$symbolValueOf = $a6642ef24ecc2bfa$var$symbolProto ? $a6642ef24ecc2bfa$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $a6642ef24ecc2bfa$var$cloneSymbol(symbol) {
    return $a6642ef24ecc2bfa$var$symbolValueOf ? Object($a6642ef24ecc2bfa$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $a6642ef24ecc2bfa$var$cloneSymbol;

});


parcelRegister("02pdv", function(module, exports) {

var $lfZQV = parcelRequire("lfZQV");

var $67IYF = parcelRequire("67IYF");

var $fVNVp = parcelRequire("fVNVp");
/* Node.js helper references. */ var $0073bf8bda653bcf$var$nodeIsMap = $fVNVp && $fVNVp.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $0073bf8bda653bcf$var$isMap = $0073bf8bda653bcf$var$nodeIsMap ? $67IYF($0073bf8bda653bcf$var$nodeIsMap) : $lfZQV;
module.exports = $0073bf8bda653bcf$var$isMap;

});
parcelRegister("lfZQV", function(module, exports) {

var $iHlaM = parcelRequire("iHlaM");

var $8VKar = parcelRequire("8VKar");
/** `Object#toString` result references. */ var $f79afa5ada2e15e4$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $f79afa5ada2e15e4$var$baseIsMap(value) {
    return $8VKar(value) && $iHlaM(value) == $f79afa5ada2e15e4$var$mapTag;
}
module.exports = $f79afa5ada2e15e4$var$baseIsMap;

});


parcelRegister("dgn1L", function(module, exports) {

var $kelM3 = parcelRequire("kelM3");

var $67IYF = parcelRequire("67IYF");

var $fVNVp = parcelRequire("fVNVp");
/* Node.js helper references. */ var $9a7ea1c11d77bd28$var$nodeIsSet = $fVNVp && $fVNVp.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $9a7ea1c11d77bd28$var$isSet = $9a7ea1c11d77bd28$var$nodeIsSet ? $67IYF($9a7ea1c11d77bd28$var$nodeIsSet) : $kelM3;
module.exports = $9a7ea1c11d77bd28$var$isSet;

});
parcelRegister("kelM3", function(module, exports) {

var $iHlaM = parcelRequire("iHlaM");

var $8VKar = parcelRequire("8VKar");
/** `Object#toString` result references. */ var $eba6015764e97d19$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $eba6015764e97d19$var$baseIsSet(value) {
    return $8VKar(value) && $iHlaM(value) == $eba6015764e97d19$var$setTag;
}
module.exports = $eba6015764e97d19$var$baseIsSet;

});




parcelRegister("4TAbX", function(module, exports) {

$parcel$export(module.exports, "generateUuid", function () { return $82541f7aed6e37a2$export$1c3aefb711c3a4cc; });
function $82541f7aed6e37a2$export$1c3aefb711c3a4cc() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        const v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}

});



parcelRegister("gtUh9", function(module, exports) {

$parcel$export(module.exports, "useAppDispatch", function () { return $9bf8bb8be0b54542$export$f51d452c10d5b956; });
$parcel$export(module.exports, "useAppSelector", function () { return $9bf8bb8be0b54542$export$a7347740d65f620b; });

var $6gPV0 = parcelRequire("6gPV0");
const $9bf8bb8be0b54542$export$f51d452c10d5b956 = ()=>(0, $6gPV0.useDispatch)();
const $9bf8bb8be0b54542$export$a7347740d65f620b = (0, $6gPV0.useSelector);

});


parcelRegister("gx96J", function(module, exports) {

$parcel$export(module.exports, "RestartButton", function () { return $88c5c6417c33af2c$export$eedf0aae79e72f39; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $6IiXU = parcelRequire("6IiXU");

var $ixaDK = parcelRequire("ixaDK");

var $fIM1v = parcelRequire("fIM1v");

var $bb1RF = parcelRequire("bb1RF");

var $gtUh9 = parcelRequire("gtUh9");
const $88c5c6417c33af2c$export$eedf0aae79e72f39 = ()=>{
    const dispatch = (0, $gtUh9.useAppDispatch)();
    const [demoAttempt, setDemoAttempt] = (0, $iSvIT.useState)(0);
    const payload = (0, $iSvIT.useMemo)(()=>(0, $bb1RF.resetDemo)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const onRestartClick = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "interactiveRoadmapRestartDemo",
            eventType: "ui",
            demoAttempt: demoAttempt
        }).fire();
        setDemoAttempt(demoAttempt + 1);
        dispatch(payload);
        return;
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
        appearance: "subtle-link",
        iconAfter: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ixaDK))), {
            label: ""
        }),
        testId: "reset-demo-btn",
        onClick: onRestartClick,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, (0, $fIM1v.messages).restartButton))
    });
};

});

parcelRegister("5nZ1S", function(module, exports) {

$parcel$export(module.exports, "RoadmapColumn", function () { return $09a47639a838c36c$export$a45b1345cfa8f6a0; });
/* roadmap-column.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $09a47639a838c36c$export$a45b1345cfa8f6a0 = ({ columnIndex: columnIndex, headerId: headerId, children: children })=>{
    const isFirstColumn = columnIndex === 0;
    const isSecondColumn = columnIndex === 1;
    const isLastColumn = columnIndex === 3;
    const firstColHeader = null;
    const notFirstColHeader = null;
    const firstCol = null;
    const secondCol = null;
    const lastCol = null;
    const noCol = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            isFirstColumn && "_p12f12aa _1reo15vq _18m915vq _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _kqswh2mm _19it1ehm _1s1g14y2 _1yxn14y2 _5fbcidpf _1einidpf _t51zglyw _bfhku67f",
            isSecondColumn && "_p12f15o9 _1reo15vq _18m915vq _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _kqswh2mm _19it1ehm _1s1gidpf _1yxnidpf _5fbcidpf _1einidpf _t51zglyw _bfhk1hxd",
            isLastColumn && "_p12f15o9 _1reo15vq _18m915vq _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _kqswh2mm _19it1ehm _1s1gidpf _1yxnidpf _5fbc14y2 _1ein14y2 _t51z1ehm _bfhku67f",
            !isFirstColumn && !secondCol && !lastCol && "_p12f15o9 _1reo15vq _18m915vq _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx21bp4 _kqswh2mm _19it1ehm _1s1gidpf _1yxnidpf _5fbcidpf _1einidpf _t51zglyw _bfhku67f"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": headerId,
            className: (0, $esG4f.default)([
                isFirstColumn && "_1e0c1txw _1bahv2br _4cvr1h6o _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _bfhk1hxd _y3gn1h6o _4t3i1mcy _ect4a8o3 _k48pni7l _1wyb7vkz _179r1ehm",
                !isFirstColumn && "_1e0c1txw _1bah1h6o _4cvr1h6o _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _bfhk1hxd _y3gn1h6o _4t3i1mcy _ect4a8o3 _k48pni7l _1wyb7vkz _179r1ehm"
            ]),
            children: children
        })
    });
};

});

parcelRegister("bGWQ7", function(module, exports) {

$parcel$export(module.exports, "RoadmapGrid", function () { return $c0a667caa1bce31b$export$385c3064ef19a328; });
/* roadmap-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $g9kzu = parcelRequire("g9kzu");
parcelRequire("jdqkE");
var $bb1RF = parcelRequire("bb1RF");

var $gtUh9 = parcelRequire("gtUh9");

var $hTDEF = parcelRequire("hTDEF");

var $8MYK3 = parcelRequire("8MYK3");

var $8JdFJ = parcelRequire("8JdFJ");

var $dvUH3 = parcelRequire("dvUH3");
const $c0a667caa1bce31b$export$385c3064ef19a328 = ()=>{
    const dispatch = (0, $gtUh9.useAppDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const epics = (0, $gtUh9.useAppSelector)(({ epics: epics })=>epics);
    const [interactive_state, isDemoComplete, dependency_state] = (0, $gtUh9.useAppSelector)(({ interactive_state: interactive_state, isDemoComplete: isDemoComplete, dependency_state: dependency_state })=>[
            interactive_state,
            isDemoComplete,
            dependency_state
        ]);
    const [barElements, setBarElements] = (0, $iSvIT.useState)(new Array());
    (0, $iSvIT.useEffect)(()=>{
        const epicColumnElements = new Array();
        const roadmapBars = new Array();
        for (const epic of epics){
            const { id: epicId, name: name, children: children, canClickAddButton: canClickAddButton } = epic;
            epicColumnElements.push(/*#__PURE__*/ (0, $loA2J.jsx)($c0a667caa1bce31b$var$RoadmapCellContainer, {
                hideFromRoadmap: false,
                start: 1,
                end: 1,
                row: roadmapBars.length + 1,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8MYK3.EpicRowItem), {
                    id: epicId,
                    epicIndex: Number(epics.indexOf(epic)),
                    name: name,
                    canClickAddButton: canClickAddButton
                })
            }, `epic-row-item-${epicId}`));
            // this epic does not have a project timeline
            if (children.length === 0) continue;
            const epicStart = 2;
            const epicEnd = 5;
            roadmapBars.push(/*#__PURE__*/ (0, $loA2J.jsx)($c0a667caa1bce31b$var$RoadmapCellContainer, {
                hideFromRoadmap: false,
                start: epicStart,
                end: epicEnd,
                row: roadmapBars.length + 1,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8JdFJ.RoadmapBar), {
                    isDemoComplete: isDemoComplete,
                    epicId: epicId,
                    barHeight: 27,
                    childrenIds: children.map((x)=>`roadmap-cell-container-${x.id}`),
                    color: "#BF63F3"
                })
            }, `roadmap-bar-epic-${epicId}`)); // push all epic children with timeline
            for (const story of children){
                const { id: storyId, name: name, start: start, end: end, hideFromRoadmap: hideFromRoadmap, onClickPayloadAction: onClickPayloadAction, onMouseDownAndLeavePayloadAction: onMouseDownAndLeavePayloadAction, canAdjust: canAdjust, isVisible: isVisible } = story;
                let onClickProjectTimeline = undefined;
                if (onClickPayloadAction) onClickProjectTimeline = ()=>{
                    createAnalyticsEvent({
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "interactiveRoadmapSetProjectTimeline",
                        eventType: "ui"
                    }).fire();
                    dispatch(onClickPayloadAction);
                };
                let onAdjustTimeline = undefined;
                if (onMouseDownAndLeavePayloadAction) onAdjustTimeline = ()=>dispatch(onMouseDownAndLeavePayloadAction);
                epicColumnElements.push(/*#__PURE__*/ (0, $loA2J.jsx)($c0a667caa1bce31b$var$RoadmapCellContainer, {
                    hideFromRoadmap: false,
                    start: 1,
                    end: 1,
                    row: roadmapBars.length + 1,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dvUH3.StoryRowItem), {
                        id: storyId,
                        name: name,
                        epicIndex: Number(epics.indexOf(epic)),
                        storyIndex: Number(children.indexOf(story))
                    })
                }, `story-row-item-${storyId}`));
                roadmapBars.push(/*#__PURE__*/ (0, $loA2J.jsx)($c0a667caa1bce31b$var$RoadmapCellContainer, {
                    hideFromRoadmap: isDemoComplete ? false : hideFromRoadmap,
                    "data-testid": `roadmap-cell-container-${storyId}`,
                    id: `roadmap-cell-container-${storyId}`,
                    start: 2,
                    end: 5,
                    row: roadmapBars.length + 1,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8JdFJ.RoadmapBar), {
                        epicId: epicId,
                        storyId: storyId,
                        isDemoComplete: isDemoComplete,
                        "data-testid": `roadmap-bar-${storyId}`,
                        barHeight: 20,
                        onClickProjectTimeline: onClickProjectTimeline,
                        onAdjustProjectTimeline: onAdjustTimeline,
                        canAdjust: canAdjust,
                        isVisible: isVisible,
                        width: ((end !== null && end !== void 0 ? end : 2) - (start !== null && start !== void 0 ? start : 1)) * 206,
                        start: start !== null && start !== void 0 ? start : 2
                    })
                }, `roadmap-cell-container-${storyId}`));
            }
        }
        setBarElements(epicColumnElements.concat(roadmapBars));
    }, [
        interactive_state,
        epics,
        isDemoComplete,
        dependency_state,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1pfh8ved _kqswstnw _1e0c11p5 _yv0e1nns _2z051y97 _wij2vrvc"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hTDEF.DependencyLink), {
                interactiveState: interactive_state,
                isDemoComplete: isDemoComplete,
                onPress: ()=>{
                    createAnalyticsEvent({
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "interactiveRoadmapMapProjectDependencies",
                        eventType: "ui"
                    }).fire();
                    dispatch((0, $bb1RF.mapProjectDependicies)());
                },
                epics: epics
            }),
            barElements.filter((element)=>!element.props.hideFromRoadmap && element.props.start < Number.MAX_VALUE && element.props.end > Number.MIN_VALUE)
        ]
    });
};
const $c0a667caa1bce31b$var$RoadmapCellContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    const { row: row } = __cmplp, __cmpldp = (0, $akGnX._)(__cmplp, [
        "row"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmpldp), {
        style: (0, $6iHNw._)((0, $7Knp0._)({}, __cmpls), {
            "--_2zbg6a": (0, $43MIc.default)(`${__cmplp.start} / ${__cmplp.end}`),
            "--_167b937": (0, $43MIc.default)(`${__cmplp.row} / ${__cmplp.row}`)
        }),
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bsb1osq _4t3i1osq _yyhy3ya7 _1ii7vxwn _v564d2z6 _4cvr1h6o _1pbykb7n",
            __cmplp.className
        ])
    }));
});
const $c0a667caa1bce31b$var$jswRoadmapGridContainerStyles = null;

});
parcelRegister("hTDEF", function(module, exports) {

$parcel$export(module.exports, "DependencyLink", function () { return $0d7b67696b13c888$export$10140b8104c4a596; });
/* dependency-link.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $el1aS = parcelRequire("el1aS");

var $9AtaN = parcelRequire("9AtaN");

var $53kJW = parcelRequire("53kJW");

var $1Td3S = parcelRequire("1Td3S");

var $fIM1v = parcelRequire("fIM1v");
parcelRequire("jdqkE");
var $bb1RF = parcelRequire("bb1RF");

var $gtUh9 = parcelRequire("gtUh9");

var $dvUH3 = parcelRequire("dvUH3");
const $0d7b67696b13c888$export$10140b8104c4a596 = ({ interactiveState: interactiveState, onPress: onPress, isDemoComplete: isDemoComplete, epics: epics })=>{
    var _epics__children_, _epics_, _epics__children_1, _epics_1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const dispatch = (0, $gtUh9.useAppDispatch)();
    const [firstStory, setFirstStory] = (0, $iSvIT.useState)((_epics_ = epics[0]) === null || _epics_ === void 0 ? void 0 : (_epics__children_ = _epics_.children[1]) === null || _epics__children_ === void 0 ? void 0 : _epics__children_.name);
    const [secondStory, setSecondStory] = (0, $iSvIT.useState)((_epics_1 = epics[0]) === null || _epics_1 === void 0 ? void 0 : (_epics__children_1 = _epics_1.children[2]) === null || _epics__children_1 === void 0 ? void 0 : _epics__children_1.name);
    const [isDependencyExpanded, setIsDependencyExpanded] = (0, $iSvIT.useState)(true); // if user resets demo
    if (!isDemoComplete && !isDependencyExpanded) setIsDependencyExpanded(true);
    (0, $iSvIT.useEffect)(()=>{
        var _epics__children_, _epics_, _epics__children_1, _epics_1;
        setFirstStory((_epics_ = epics[0]) === null || _epics_ === void 0 ? void 0 : (_epics__children_ = _epics_.children[0]) === null || _epics__children_ === void 0 ? void 0 : _epics__children_.name);
        setSecondStory((_epics_1 = epics[0]) === null || _epics_1 === void 0 ? void 0 : (_epics__children_1 = _epics_1.children[2]) === null || _epics__children_1 === void 0 ? void 0 : _epics__children_1.name);
    }, [
        epics
    ]);
    // if user unlinks
    if (!isDependencyExpanded) return null;
    const dependencyUnLinkClick = ()=>{
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "interactiveRoadmapUnlinkDependency",
            eventType: "ui"
        }).fire();
        setIsDependencyExpanded(false);
        dispatch((0, $bb1RF.unlinkDependency)());
    };
    if (interactiveState === (0, $bb1RF.Actions).MAP_PROJECT_DEPENDENCIES) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "dependency-link-clickable",
        className: (0, $esG4f.default)([
            "_kqswstnw _152t1ylp _1e02zcml _1e0c1txw _2lx2vrvc _1bsb1ns9 _1bah1y6m _4cvr1y6m _1pbycs5v _hfyl1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $fIM1v.messages).linkStoriesButton), {
                children: (label)=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
                        className: (0, $esG4f.default)([
                            "_bfhk1j28 _19itglyw _12l21lpd _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _2rko1ssb _1pbycs5v _v5641doz _jomryq51 _irr3yq51",
                            "style-link-icon-hover"
                        ]),
                        "aria-label": label,
                        onClick: onPress,
                        "data-testid": "link-icon-clickable",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($el1aS))), {
                            size: "small",
                            label: "",
                            primaryColor: "#FFF"
                        })
                    })
            })),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $fIM1v.messages).linkStoriesButton), {
                children: (label)=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
                        "aria-label": label,
                        onClick: onPress,
                        className: (0, $esG4f.default)([
                            "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk1j28 _1pfhdlk8 _4t3i1ns9 _1bsb1ns9 _1pbyidpf _7ljxbfng _opj1bfng _y44v17bb _1ncq1bs3 _1k3s1jf7 _1tin1jf7"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                            id: "dependency-svg",
                            width: "25",
                            height: "70",
                            viewBox: "0 0 25 70",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M 10 1 V 1 C 24 8 21 22 12 34 V 34 C -1 49 1 62 10 69",
                                stroke: "#FF8B00",
                                strokeWidth: "2"
                            })
                        })
                    })
            }))
        ]
    });
    else if (isDemoComplete || interactiveState === (0, $bb1RF.Actions).COMPLETE_DEMO) return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "dependency-link-not-clickable",
        className: (0, $esG4f.default)([
            "_kqswstnw _152t1ylp _1e02zcml _1e0c1txw _2lx2vrvc _1bsb1ns9 _1bah1y6m _4cvr1y6m _1pbycs5v _hfyl1y44"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1pfh1l7b _1e0c1txw _12l216fl _4cvr1h6o _1bah1h6o _4t3if6fq _1bsbf6fq _2rko1osq _1pbycs5v _v5641doz"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($el1aS))), {
                    size: "small",
                    label: "",
                    primaryColor: "#FFF"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1pfhdlk8 _4t3i1ns9 _1bsb1ns9 _1pbyidpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    width: "25",
                    height: "70",
                    viewBox: "0 0 25 70",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M 10 1 V 1 C 24 8 21 22 12 34 V 34 C -1 49 1 62 10 69",
                        stroke: "#FF8B00",
                        strokeWidth: "2"
                    })
                })
            }),
            isDependencyExpanded && /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                "data-testid": "dependency-link-expanded",
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1y6m _bfhk4m1f _2rko1l7b _16qszodz _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1pfh10yn _ahbq14y2 _1pbycs5v"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_bfhku67f _2rko1y44 _1bsbuuw1 _ca0qyh40 _u5f319bv _n3tdyh40 _19bv19bv _1pbykb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dvUH3.StoryRowItem), {
                            id: "dependency-story-1",
                            epicIndex: 0,
                            name: firstStory,
                            storyIndex: 0,
                            isEpicCol: false
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _1bsbuuw1"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)($0d7b67696b13c888$var$DependencyLinkLine, {}),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $6iHNw._)((0, $7Knp0._)({}, (0, $fIM1v.messages).unlinkChildStoryButton), {
                                children: (label)=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                        "aria-label": label,
                                        onClick: dependencyUnLinkClick,
                                        "data-testid": "dependency-unlink-btn",
                                        id: "dependency-unlink-btn",
                                        className: (0, $esG4f.default)([
                                            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk19d5 _19it1tdf _2rko1ssb _19pk19bv _2hwx19bv _otyr19bv _18u019bv _16qsz7ca _y44v13zl"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Td3S))), {
                                            label: "",
                                            primaryColor: "#42526E"
                                        })
                                    })
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_bfhku67f _2rko1y44 _1bsbuuw1 _ca0qyh40 _u5f319bv _n3tdyh40 _19bv19bv _1pbykb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dvUH3.StoryRowItem), {
                            id: "dependency-story-2",
                            epicIndex: 0,
                            name: secondStory,
                            storyIndex: 2,
                            isEpicCol: false
                        })
                    })
                ]
            })
        ]
    });
    return null;
};
const $0d7b67696b13c888$var$StyleSvgHover = null;
const $0d7b67696b13c888$var$StyleSvg = null;
const $0d7b67696b13c888$var$StyleLinkIconHover = null;
const $0d7b67696b13c888$var$StyleLinkIcon = null;
const $0d7b67696b13c888$var$DependencyLinkContainer = null;
const $0d7b67696b13c888$var$VisualDepenedencyBoxContainer = null;
const $0d7b67696b13c888$var$StoryContainer = null;
const $0d7b67696b13c888$var$Line = null;
const $0d7b67696b13c888$var$LinkLineWrapper = null;
const $0d7b67696b13c888$var$LinkIconRow = null;
const $0d7b67696b13c888$var$baseShadow = `0 0 0 1px ${"var(--ds-border-focused, rgba(29, 122, 252, 1))"}`;
const $0d7b67696b13c888$var$UnlinkWrapper = null;
const $0d7b67696b13c888$var$DependencyLinkLine = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _ahbq1ul9"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_t9eczk8b _19pk1lpd _2hwxidpf _otyr1lpd _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53kJW))), {
                    label: "",
                    primaryColor: "#42526E"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9AtaN))), {
                label: "",
                primaryColor: "#42526E"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_t9eczk8b _19pk1lpd _2hwxidpf _otyr1lpd _18u0idpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53kJW))), {
                    label: "",
                    primaryColor: "#42526E"
                })
            })
        ]
    });
};

});
parcelRegister("9AtaN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fae1b07c4f4a56f$var$_react = $6fae1b07c4f4a56f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $6fae1b07c4f4a56f$var$_link = $6fae1b07c4f4a56f$var$_interopRequireDefault((parcelRequire("gLhLj")));
function $6fae1b07c4f4a56f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6fae1b07c4f4a56f$var$LinkFilledIcon = (props)=>/*#__PURE__*/ $6fae1b07c4f4a56f$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m11.75 16.15.548-.537a.585.585 0 0 0 0-.838.61.61 0 0 0-.854 0l-.574.564c-.564.553-1.483.662-2.101.168a1.482 1.482 0 0 1-.119-2.223l1.694-1.663a1.543 1.543 0 0 1 2.156 0l.647.635.853-.839-.646-.635a2.775 2.775 0 0 0-3.863 0l-1.694 1.664a2.66 2.66 0 0 0 .208 3.979c1.104.884 2.738.715 3.746-.275"/><path fill="inherit" d="m12.25 7.85-.547.537a.585.585 0 0 0 0 .838.61.61 0 0 0 .853 0l.574-.564c.564-.553 1.483-.662 2.101-.168.71.57.75 1.603.119 2.223l-1.694 1.663a1.543 1.543 0 0 1-2.156 0l-.647-.635-.853.839.646.635a2.775 2.775 0 0 0 3.863 0l1.695-1.664a2.66 2.66 0 0 0-.209-3.979c-1.104-.884-2.738-.715-3.746.275"/></g></svg>`
    }, props, {
        newIcon: $6fae1b07c4f4a56f$var$_link.default
    }));
$6fae1b07c4f4a56f$var$LinkFilledIcon.displayName = "LinkFilledIcon";
var $6fae1b07c4f4a56f$var$_default = module.exports.default = $6fae1b07c4f4a56f$var$LinkFilledIcon;

});

parcelRegister("53kJW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3add521c5e297ca9$var$_react = $3add521c5e297ca9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $3add521c5e297ca9$var$_strokeWeightSmall = $3add521c5e297ca9$var$_interopRequireDefault((parcelRequire("dumCo")));
function $3add521c5e297ca9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3add521c5e297ca9$var$MediaServicesLineIcon = (props)=>/*#__PURE__*/ $3add521c5e297ca9$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M4.36 17.904 17.904 4.36a1.228 1.228 0 1 1 1.736 1.736L6.096 19.64a1.228 1.228 0 1 1-1.736-1.736"/></svg>`
    }, props, {
        newIcon: $3add521c5e297ca9$var$_strokeWeightSmall.default
    }));
$3add521c5e297ca9$var$MediaServicesLineIcon.displayName = "MediaServicesLineIcon";
var $3add521c5e297ca9$var$_default = module.exports.default = $3add521c5e297ca9$var$MediaServicesLineIcon;

});
parcelRegister("dumCo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::712f92f8cb786621bb25f9094eb716f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d1f9f342dde019a$var$_react = $9d1f9f342dde019a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9d1f9f342dde019a$var$_baseNew = $9d1f9f342dde019a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9d1f9f342dde019a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StrokeWeightSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing thin border stroke widths.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9d1f9f342dde019a$var$StrokeWeightSmallIcon = (props)=>/*#__PURE__*/ $9d1f9f342dde019a$var$_react.default.createElement($9d1f9f342dde019a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 8a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0" clip-rule="evenodd"/>`
    }, props));
$9d1f9f342dde019a$var$StrokeWeightSmallIcon.displayName = "StrokeWeightSmallIcon";
var $9d1f9f342dde019a$var$_default = module.exports.default = $9d1f9f342dde019a$var$StrokeWeightSmallIcon;

});


parcelRegister("dvUH3", function(module, exports) {

$parcel$export(module.exports, "StoryRowItem", function () { return $0f346e8cc2eee78f$export$282034b55f96a3f2; });
/* story-row-item.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $7L1zQ = parcelRequire("7L1zQ");

var $g9kzu = parcelRequire("g9kzu");

var $48zDN = parcelRequire("48zDN");

var $fIM1v = parcelRequire("fIM1v");
parcelRequire("jdqkE");
var $bb1RF = parcelRequire("bb1RF");

var $gtUh9 = parcelRequire("gtUh9");

var $3ax6H = parcelRequire("3ax6H");

var $4E6Sf = parcelRequire("4E6Sf");

var $h2TDw = parcelRequire("h2TDw");
const $0f346e8cc2eee78f$export$282034b55f96a3f2 = ({ id: id, name: name, storyIndex: storyIndex, epicIndex: epicIndex, isEpicCol: isEpicCol = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const dispatch = (0, $gtUh9.useAppDispatch)();
    const isDemoComplete = (0, $gtUh9.useAppSelector)(({ isDemoComplete: isDemoComplete })=>isDemoComplete);
    const editModeItemId = (0, $gtUh9.useAppSelector)(({ editModeItemId: editModeItemId })=>editModeItemId);
    const [storyNameInputValue, setStoryInputName] = (0, $iSvIT.useState)("");
    const [storyName, setStoryName] = (0, $iSvIT.useState)(name);
    const [rowMode, setRowMode] = (0, $iSvIT.useState)("UNKNOWN");
    const storyLabelText = (0, $iSvIT.useMemo)(()=>intl.formatMessage((0, $fIM1v.messages).story), []);
    const readOnlyTextValue = (0, $iSvIT.useMemo)(()=>typeof storyName === "object" ? intl.formatMessage(storyName) : storyName, [
        storyName
    ]);
    const activateToEditTextDescription = (0, $iSvIT.useMemo)(()=>intl.formatMessage((0, $fIM1v.messages).activateToEditTextDescription), []);
    const activateToToggleMessageId = (0, $iSvIT.useMemo)(()=>`activateToToggleMessage-${id}`, [
        id
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(()=>setStoryName(name), [
        name
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(()=>setRowMode(editModeItemId === id ? "EDIT" : "VIEW"), [
        editModeItemId
    ]);
    const updateStoryName = (name)=>{
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "interactiveRoadmapUpdateStory",
            eventType: "ui"
        }).fire();
        dispatch((0, $bb1RF.updateStory)({
            storyIndex: storyIndex,
            epicIndex: epicIndex,
            storyName: name
        }));
        dispatch((0, $bb1RF.setEditModeItem)({
            id: undefined
        }));
        setStoryName(name);
        setStoryInputName("");
        setRowMode("VIEW");
    };
    const toggleEditMode = ()=>{
        // this story row can only be edited if it is on the epic column.
        if (!isEpicCol) return;
         // the demo has not been complete so the user cannot edit any story / epic, skip.
        if (!isDemoComplete) return;
         // there is another item in edit mode, skip.
        if (editModeItemId) return;
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "interactiveRoadmapSetEditModeItem",
            eventType: "ui",
            attributes: {
                itemEditId: id
            }
        }).fire();
        dispatch((0, $bb1RF.setEditModeItem)({
            id: id
        }));
        setRowMode("EDIT");
        if (typeof storyName === "object") setStoryInputName(intl.formatMessage(storyName));
        else setStoryInputName(storyName);
    };
    // auto focus on input element
    const containerRef = (0, $iSvIT.useRef)(null);
    const inputRef = (0, $iSvIT.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useEffect(()=>{
        if (inputRef.current) {
            inputRef.current.onfocus = ()=>{
                if (containerRef.current) containerRef.current.style.borderColor = (0, $48zDN.B100);
            };
            inputRef.current.onblur = ()=>{
                if (containerRef.current) containerRef.current.style.borderColor = (0, $48zDN.N50);
            };
            inputRef.current.focus();
        }
    }, [
        rowMode,
        inputRef,
        containerRef
    ]);
    const readOnlyContainerStyles = [
        isEpicCol && null,
        !isEpicCol && null
    ];
    const readOnlyContent = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3ax6H.HiddenAriaDescription), {
                id: activateToToggleMessageId,
                message: activateToEditTextDescription
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                onClick: toggleEditMode,
                "data-testid": "read-only-story-row-item",
                "aria-describedby": activateToToggleMessageId,
                "aria-disabled": !isDemoComplete || editModeItemId != null,
                className: (0, $esG4f.default)([
                    isEpicCol && "_bfhk1j28 _19itglyw _1e0c1txw _1bah1y6m _4cvr1h6o _1bsb1osq _2rko1y44 _ahbq1mcy _v5642uhh _p12fajgb _zulpftgi",
                    !isEpicCol && "_bfhk1j28 _19itglyw _1e0c1txw _1bah1y6m _4cvr1h6o _1bsb1osq _2rko1y44 _v5642uhh _p12fajgb _zulpftgi"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $h2TDw.Story16IconCustom), {
                        primaryColor: "#82B536",
                        label: storyLabelText
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4E6Sf.Name), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($7L1zQ)))(readOnlyTextValue)
                            }
                        })
                    })
                ]
            })
        ]
    });
    const editContent = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4E6Sf.EditContainer), {
        "data-testid": "edit-story-row-item",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4E6Sf.IconBlock), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $h2TDw.Story16IconCustom), {
                    primaryColor: "#82B536",
                    label: storyLabelText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4E6Sf.Input), {
                "data-testid": "edit-input-story-row-item",
                ref: inputRef,
                value: storyNameInputValue,
                onChange: (changeEvent)=>setStoryInputName(changeEvent.target.value),
                placeholder: intl.formatMessage((0, $fIM1v.messages).updateStoryPlaceholder),
                onKeyDown: (keyEvent)=>{
                    if (keyEvent.key === "Enter" && storyNameInputValue.length > 0) {
                        updateStoryName(storyNameInputValue);
                        keyEvent.preventDefault();
                    }
                },
                onBlur: ()=>{
                    if (storyNameInputValue.length > 0) updateStoryName(storyNameInputValue);
                }
            })
        ]
    });
    return rowMode === "EDIT" ? editContent : readOnlyContent;
};

});
parcelRegister("3ax6H", function(module, exports) {

$parcel$export(module.exports, "HiddenAriaDescription", function () { return $8d4ff11033f0b769$export$b8e433d4069179d6; });
/**
 * Represents a JSX Element for a hidden aria description.
 * @returns
 */ 
var $loA2J = parcelRequire("loA2J");
const $8d4ff11033f0b769$export$b8e433d4069179d6 = ({ id: id, message: message })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        id: id,
        hidden: true,
        children: message
    });
};

});

parcelRegister("4E6Sf", function(module, exports) {

$parcel$export(module.exports, "EditContainer", function () { return $0aa21a035e40afa3$export$91fd92e540193153; });
$parcel$export(module.exports, "IconBlock", function () { return $0aa21a035e40afa3$export$9b35fd7cc410c4b0; });
$parcel$export(module.exports, "Input", function () { return $0aa21a035e40afa3$export$f5b8910cec6cf069; });
$parcel$export(module.exports, "Name", function () { return $0aa21a035e40afa3$export$c7bd411105e2dec3; });
/* shared.styles.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $0aa21a035e40afa3$export$91fd92e540193153 = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq _2rko1y44 _19pkidpf _2hwxftgi _otyridpf _18u0ftgi _v5642uhh _p12fajgb _zulprdoj _19ittorw _4t3izwfg _ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.className
        ])
    }));
});
const $0aa21a035e40afa3$export$9b35fd7cc410c4b0 = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $0aa21a035e40afa3$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "input", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _19itglyw _1wybdlk8 _ect41bvl _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    }));
});
const $0aa21a035e40afa3$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "span", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_syazalr3 _1wybdlk8 _vwz4gktf _zg8l4jg8 _1bto1l2s _1reo15vq _18m915vq _o5721q9c _4t3igktf _p12fmgvx _ect41bvl",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("h2TDw", function(module, exports) {

$parcel$export(module.exports, "Story16IconCustom", function () { return $710ed913e111fab7$export$813b7d07089f6cc7; });
/* story-16-icon-custom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $h6XJS = parcelRequire("h6XJS");
const $710ed913e111fab7$export$813b7d07089f6cc7 = ({ primaryColor: primaryColor, label: label })=>{
    const colorOverride = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1axp1y71"
        ]),
        style: {
            "--_12rxvm": (0, $43MIc.default)(primaryColor)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6XJS))), {
            label: label
        })
    });
};

});



parcelRegister("8MYK3", function(module, exports) {

$parcel$export(module.exports, "EpicRowItem", function () { return $bdf6265b068ba49c$export$c241a036e2360515; });
/* epic-row-item.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable  jsx-a11y/no-autofocus */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $7L1zQ = parcelRequire("7L1zQ");

var $g9kzu = parcelRequire("g9kzu");

var $h6aNO = parcelRequire("h6aNO");

var $35baK = parcelRequire("35baK");

var $48zDN = parcelRequire("48zDN");

var $fIM1v = parcelRequire("fIM1v");
parcelRequire("jdqkE");
var $bb1RF = parcelRequire("bb1RF");

var $gtUh9 = parcelRequire("gtUh9");

var $f5YxX = parcelRequire("f5YxX");

var $3ax6H = parcelRequire("3ax6H");

var $4E6Sf = parcelRequire("4E6Sf");
const $bdf6265b068ba49c$export$c241a036e2360515 = ({ id: id, name: name, epicIndex: epicIndex, canClickAddButton: canClickAddButton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const dispatch = (0, $gtUh9.useAppDispatch)();
    const isDemoComplete = (0, $gtUh9.useAppSelector)(({ isDemoComplete: isDemoComplete })=>isDemoComplete);
    const editModeItemId = (0, $gtUh9.useAppSelector)(({ editModeItemId: editModeItemId })=>editModeItemId);
    const [epicNameInputValue, setEpicNameInputValue] = (0, $iSvIT.useState)("");
    const [epicName, setEpicName] = (0, $iSvIT.useState)(name);
    const epics = (0, $gtUh9.useAppSelector)(({ epics: epics })=>epics);
    const [rowMode, setRowMode] = (0, $iSvIT.useState)("UNKNOWN");
    const epicLabelText = (0, $iSvIT.useMemo)(()=>intl.formatMessage((0, $fIM1v.messages).epic), []);
    const readOnlyTextValue = (0, $iSvIT.useMemo)(()=>typeof epicName === "object" ? intl.formatMessage(epicName) : epicName, [
        epicName
    ]);
    const activateToEditTextDescription = (0, $iSvIT.useMemo)(()=>intl.formatMessage((0, $fIM1v.messages).activateToEditTextDescription), []);
    const activateToToggleMessageId = (0, $iSvIT.useMemo)(()=>`activateToToggleMessage-${id}`, [
        id
    ]);
    (0, $iSvIT.useEffect)(()=>setEpicName(name), [
        name
    ]);
    (0, $iSvIT.useEffect)(()=>setRowMode(editModeItemId === id ? "EDIT" : "VIEW"), [
        editModeItemId
    ]);
    const updateEpicName = (updatedName)=>{
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "interactiveRoadmapUpdateEpic",
            eventType: "ui"
        }).fire();
        dispatch((0, $bb1RF.updateEpic)({
            epicName: updatedName,
            epicIndex: epicIndex
        }));
        dispatch((0, $bb1RF.setEditModeItem)({
            id: undefined
        }));
        setEpicName(updatedName);
        setEpicNameInputValue("");
        setRowMode("VIEW");
    };
    const toggleEditMode = ()=>{
        // the demo has not been complete so the user cannot edit any story / epic, skip.
        if (!isDemoComplete) return;
         // there is another item in edit mode, skip.
        if (editModeItemId) return;
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: "interactiveRoadmapSetEditModeItem",
            eventType: "ui",
            attributes: {
                itemEditId: id
            }
        }).fire();
        dispatch((0, $bb1RF.setEditModeItem)({
            id: id
        }));
        setRowMode("EDIT");
        if (typeof epicName === "object") setEpicNameInputValue(intl.formatMessage(epicName));
        else setEpicNameInputValue(epicName);
    };
    // auto focus on input element
    const containerRef = (0, $iSvIT.useRef)(null);
    const inputRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (inputRef.current) {
            inputRef.current.onfocus = ()=>{
                if (containerRef.current) containerRef.current.style.borderColor = (0, $48zDN.B100);
            };
            inputRef.current.onblur = ()=>{
                if (containerRef.current) containerRef.current.style.borderColor = (0, $48zDN.N50);
            };
            inputRef.current.focus({
                preventScroll: true
            });
        }
    }, [
        rowMode,
        inputRef,
        containerRef
    ]);
    const readOnlyContent = /*#__PURE__*/ (0, $loA2J.jsxs)($bdf6265b068ba49c$var$ReadOnlyContainer, {
        "data-testid": "read-only-epic-row-item",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $3ax6H.HiddenAriaDescription), {
                id: activateToToggleMessageId,
                message: activateToEditTextDescription
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)($bdf6265b068ba49c$var$Block, {
                type: "button",
                "data-testid": "read-only-epic-row-item-block",
                onClick: toggleEditMode,
                "aria-describedby": activateToToggleMessageId,
                "aria-disabled": !isDemoComplete || editModeItemId != null,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4E6Sf.IconBlock), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($h6aNO))), {
                                label: ""
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $f5YxX.Epic16IconCustom), {
                                primaryColor: "#BF63F3",
                                label: epicLabelText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4E6Sf.Name), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: (0, (/*@__PURE__*/$parcel$interopDefault($7L1zQ)))(readOnlyTextValue)
                            }
                        })
                    })
                ]
            }),
            canClickAddButton && !editModeItemId && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4E6Sf.IconBlock), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($bdf6265b068ba49c$var$AddButton, {
                    autoFocus: true,
                    "aria-label": intl.formatMessage((0, $fIM1v.messages).addChild),
                    "data-testid": "add-epic-child-button",
                    onClick: ()=>{
                        var _epics__children;
                        createAnalyticsEvent({
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "interactiveRoadmapAddStoryToEpic",
                            eventType: "ui",
                            attributes: {
                                numOfChildStories: ((_epics__children = epics[1].children) === null || _epics__children === void 0 ? void 0 : _epics__children.length) + 1
                            }
                        }).fire();
                        dispatch((0, $bb1RF.addStory)());
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($35baK))), {
                        size: "medium",
                        secondaryColor: "rgba(255, 255, 255, 0.0001)",
                        label: ""
                    })
                })
            })
        ]
    });
    const editContent = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4E6Sf.EditContainer), {
        "data-testid": "edit-epic-row-item",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4E6Sf.IconBlock), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f5YxX.Epic16IconCustom), {
                    primaryColor: "#BF63F3",
                    label: epicLabelText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4E6Sf.Input), {
                "data-testid": "edit-input-epic-row-item",
                ref: inputRef,
                value: epicNameInputValue,
                onChange: (changeEvent)=>setEpicNameInputValue(changeEvent.target.value),
                placeholder: intl.formatMessage((0, $fIM1v.messages).updateEpicPlaceholder),
                onKeyDown: (keyEvent)=>{
                    if (keyEvent.key === "Enter" && epicNameInputValue.length > 0) {
                        updateEpicName(epicNameInputValue); // prevents key event from drilling down to addStory button, causing the addStory action to dispatch.
                        keyEvent.preventDefault();
                    }
                },
                onBlur: ()=>{
                    if (epicNameInputValue.length > 0) updateEpicName(epicNameInputValue);
                }
            })
        ]
    });
    return rowMode === "EDIT" ? editContent : readOnlyContent;
};
const $bdf6265b068ba49c$var$Block = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "button", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_bfhk1j28 _19itglyw _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1y6m _4cvr1h6o _zulpftgi",
            __cmplp.className
        ])
    }));
});
const $bdf6265b068ba49c$var$AddButton = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "button", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1tcg _4t3i1tcg _bfhktvgq _2rko1l7b _2hwx10yn _19itglyw",
            __cmplp.className
        ])
    }));
});
const $bdf6265b068ba49c$var$ReadOnlyContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq _2rko1y44 _19pkidpf _2hwxftgi _otyridpf _18u0ftgi _v5642uhh _p12fajgb _zulprdoj",
            __cmplp.className
        ])
    }));
});

});
parcelRegister("35baK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23ea8152052e3f2b$var$_react = $23ea8152052e3f2b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $23ea8152052e3f2b$var$_add = $23ea8152052e3f2b$var$_interopRequireDefault((parcelRequire("ayjUl")));
function $23ea8152052e3f2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $23ea8152052e3f2b$var$EditorAddIcon = (props)=>/*#__PURE__*/ $23ea8152052e3f2b$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        newIcon: $23ea8152052e3f2b$var$_add.default
    }));
$23ea8152052e3f2b$var$EditorAddIcon.displayName = "EditorAddIcon";
var $23ea8152052e3f2b$var$_default = module.exports.default = $23ea8152052e3f2b$var$EditorAddIcon;

});

parcelRegister("f5YxX", function(module, exports) {

$parcel$export(module.exports, "Epic16IconCustom", function () { return $6a89ee8e83a86aac$export$8435b138038c7aa4; });
/* epic-16-icon-custom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $2zLMT = parcelRequire("2zLMT");
const $6a89ee8e83a86aac$export$8435b138038c7aa4 = ({ primaryColor: primaryColor, label: label })=>{
    const colorOverride = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1axp1y71"
        ]),
        style: {
            "--_12rxvm": (0, $43MIc.default)(primaryColor)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2zLMT))), {
            label: label
        })
    });
};

});
parcelRegister("2zLMT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e03eb4b88cc3a7c$var$_react = $1e03eb4b88cc3a7c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aq08R = parcelRequire("aq08R");
function $1e03eb4b88cc3a7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1e03eb4b88cc3a7c$var$Epic16Icon = (props)=>/*#__PURE__*/ $1e03eb4b88cc3a7c$var$_react.default.createElement($aq08R.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554C0" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm9.912 7.767A.486.486 0 0012 7.5a.5.5 0 00-.5-.5H9V3.5a.495.495 0 00-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.487.487 0 004 8.5a.5.5 0 00.5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 00.5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033-.002-.003z"/></svg>`
    }, props, {
        size: "small"
    }));
$1e03eb4b88cc3a7c$var$Epic16Icon.displayName = "Epic16Icon";
var $1e03eb4b88cc3a7c$var$_default = $1e03eb4b88cc3a7c$var$Epic16Icon;
module.exports.default = $1e03eb4b88cc3a7c$var$_default;

});



parcelRegister("8JdFJ", function(module, exports) {

$parcel$export(module.exports, "RoadmapBar", function () { return $96293bb78d73bab2$export$9335a0f7fb12b232; });
/* roadmap-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable jsx-a11y/aria-role */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $aJi6x = parcelRequire("aJi6x");

var $jUM44 = parcelRequire("jUM44");

var $fIM1v = parcelRequire("fIM1v");
parcelRequire("jdqkE");
var $bb1RF = parcelRequire("bb1RF");
const $96293bb78d73bab2$var$roadmapBarWidth = 206;
const $96293bb78d73bab2$var$maxRoadmapBarSize = 616; /**
                                * The minimum roadmap bar width.
                                */ 
const $96293bb78d73bab2$var$minimumRoadmapBarWidth = 80; /**
                                    * The custom adjust roadmap bar event.
                                    */ 
const $96293bb78d73bab2$var$CUSTOM_ADJUST_ROADMAP_BAR_EVENT = "CUSTOM_ADJUST_ROADMAP_BAR"; /**
                                                                      * Key codes for keyboard event handling
                                                                      */ 
const $96293bb78d73bab2$var$SPACEBAR_KEY = " ";
const $96293bb78d73bab2$var$ENTER_KEY = "enter";
const $96293bb78d73bab2$var$LEFT_ARROW_KEY = "arrowleft";
const $96293bb78d73bab2$var$RIGHT_ARROW_KEY = "arrowright";
const $96293bb78d73bab2$var$A_KEY = "a";
const $96293bb78d73bab2$var$D_KEY = "d"; /**
                    * Gets the jsw interactive roadmap container offset.
                    */ 
const $96293bb78d73bab2$var$getJswInteractiveRoadmapContainerOffset = ()=>{
    const element = document.getElementById("main-content-wrapper-jsw-interactive-roadmap");
    var _element_getBoundingClientRect;
    const { left: offsetLeft, width: offsetWidth } = (_element_getBoundingClientRect = element === null || element === void 0 ? void 0 : element.getBoundingClientRect()) !== null && _element_getBoundingClientRect !== void 0 ? _element_getBoundingClientRect : {
        left: 0,
        width: 0
    };
    return {
        offsetLeft: offsetLeft,
        offsetWidth: offsetWidth
    };
};
const $96293bb78d73bab2$export$9335a0f7fb12b232 = ({ epicId: epicId, storyId: storyId, color: color, lineColor: lineColor, onClickProjectTimeline: onClickProjectTimeline, onAdjustProjectTimeline: onAdjustProjectTimeline, canAdjust: canAdjust, isDemoComplete: isDemoComplete, width: width = 80, start: start = 2, isVisible: isVisible = true, barHeight: barHeight = 20, childrenIds: childrenIds = [] })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)();
    const barRef = (0, $iSvIT.useRef)(null);
    const [showAdjustmentLines, setShowAdjustmentLines] = (0, $iSvIT.useState)(false);
    const [mouseDown, setMouseDown] = (0, $iSvIT.useState)(false);
    const [barWidth, setBarWidth] = (0, $iSvIT.useState)(width);
    const [barWidthOnDrag, setBarWidthOnDrag] = (0, $iSvIT.useState)(barWidth);
    const [marginLeft, setMarginLeft] = (0, $iSvIT.useState)(Math.max((start - 2) * $96293bb78d73bab2$var$roadmapBarWidth, 1));
    const [initialBarOffset, setInitialBarOffset] = (0, $iSvIT.useState)(0);
    const [leftAdjustment, setLeftAdjustment] = (0, $iSvIT.useState)(marginLeft);
    const [isKeyboardEditMode, setKeyboardEditMode] = (0, $iSvIT.useState)(false);
    const ariaLiveContainerId = "roadmap-bar-aria-live";
    var _usePrevious;
    const prevLeftAdjustment = (_usePrevious = (0, $jUM44.default)(leftAdjustment)) !== null && _usePrevious !== void 0 ? _usePrevious : 0;
    const hideVertivalLinesOnRoadmapBar = ()=>{
        if (!mouseDown) setShowAdjustmentLines(false);
        setMouseDown(false);
    }; // if there is no story id, this is an epic. listen to children changes to calculate bar width.
    (0, $iSvIT.useLayoutEffect)(()=>{
        if (!!storyId) return;
        if (!childrenIds || childrenIds.length === 0) {
            console.info("This epic has no children/stories.");
            return;
        }
        const adjustEpicLength = ()=>{
            let minOffset = Number.MAX_SAFE_INTEGER;
            let longestRoadmapBarWidth = Number.MIN_SAFE_INTEGER; // calculate min offset
            for (const childId of childrenIds){
                var _document_getElementById;
                const roadmapBar = (_document_getElementById = document.getElementById(childId)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.firstElementChild;
                if (!roadmapBar) return;
                minOffset = Math.max(Math.min(minOffset, roadmapBar.offsetLeft - 290), 1);
            } // calculate longest roadmapbar width
            for (const childId of childrenIds){
                var _document_getElementById1;
                const roadmapBar = (_document_getElementById1 = document.getElementById(childId)) === null || _document_getElementById1 === void 0 ? void 0 : _document_getElementById1.firstElementChild;
                if (!roadmapBar) return;
                longestRoadmapBarWidth = Math.max(longestRoadmapBarWidth, roadmapBar.offsetLeft + roadmapBar.offsetWidth - 290 - minOffset);
            }
            if (barRef.current) barRef.current.style.width = `${longestRoadmapBarWidth}px`;
            setMarginLeft(minOffset);
            setBarWidth(longestRoadmapBarWidth);
        };
        addEventListener($96293bb78d73bab2$var$CUSTOM_ADJUST_ROADMAP_BAR_EVENT, adjustEpicLength);
        adjustEpicLength();
    }, [
        childrenIds
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // if a11y mode
        if (isKeyboardEditMode && barRef.current) {
            barRef.current.style.width = `${barWidth}px`;
            setMarginLeft(leftAdjustment);
            return;
        }
        if (barRef.current) {
            let width = barWidthOnDrag;
            if (leftAdjustment > prevLeftAdjustment) width = barWidthOnDrag - Math.abs(leftAdjustment - prevLeftAdjustment);
            else width = barWidthOnDrag + Math.abs(leftAdjustment - prevLeftAdjustment);
             // width not allowed
            if (width < $96293bb78d73bab2$var$minimumRoadmapBarWidth || isNaN(width)) return;
            barRef.current.style.width = `${width}px`;
            setBarWidth(width);
            setBarWidthOnDrag(width);
            setMarginLeft(leftAdjustment);
        }
    }, [
        leftAdjustment
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (barRef.current) setInitialBarOffset(barRef.current.offsetLeft - leftAdjustment);
    }, [
        barRef
    ]);
    const opacity = isVisible ? 1 : 0;
    const hoverOpacity = isVisible ? 1 : 0.5;
    let onClick = undefined;
    let onMouseUp = undefined;
    let onMouseDown = undefined;
    let onMouseEnter = undefined;
    let onMouseLeave = undefined;
    let onDragStartLeft = undefined;
    let onDragStartRight = undefined;
    let onDragLeft = undefined;
    let onDragLeftEnd = undefined;
    let onDragRight = undefined;
    let onDragRightEnd = undefined;
    let onFocus = undefined;
    let onBlur = undefined;
    let onKeyDownLeft = undefined;
    let onKeyDownRight = undefined;
    if (onClickProjectTimeline && !isVisible) onClick = ()=>onClickProjectTimeline();
    const dispatchWindowEventProjectTimelineAdjusted = ()=>{
        // dispatch window event to listen to changes
        const adjustRoadmapEvent = new CustomEvent($96293bb78d73bab2$var$CUSTOM_ADJUST_ROADMAP_BAR_EVENT, {
            detail: {
                epicId: epicId
            }
        });
        dispatchEvent(adjustRoadmapEvent);
    };
    if (canAdjust) {
        onMouseDown = ()=>setMouseDown(true);
        onMouseUp = ()=>setMouseDown(false);
        onFocus = ()=>setShowAdjustmentLines(true);
        onBlur = ()=>setShowAdjustmentLines(false);
        onDragStartLeft = ({ dataTransfer: dataTransfer })=>{
            setMouseDown(true);
            setShowAdjustmentLines(true);
            setBarWidthOnDrag(barWidth); // hide ghost image
            const blankCanvas = document.createElement("canvas");
            blankCanvas.style.opacity = "0";
            dataTransfer.setDragImage(blankCanvas, 0, 0);
            document.body.appendChild(blankCanvas);
        };
        onDragStartRight = ({ dataTransfer: dataTransfer })=>{
            setMouseDown(true);
            setShowAdjustmentLines(true);
            setBarWidthOnDrag(barWidth); // hide ghost image
            const blankCanvas = document.createElement("canvas");
            blankCanvas.style.opacity = "0";
            dataTransfer.setDragImage(blankCanvas, 0, 0);
            document.body.appendChild(blankCanvas); // fire window event for spotlight component.
            const windowEvent = new Event((0, $bb1RF.Actions).ADJUST_PROJECT_TIMELINE);
            createAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "interactiveRoadmapAdjustProjectTimeline",
                eventType: "ui"
            }).fire();
            dispatchEvent(windowEvent);
        };
        onDragRight = ({ clientX: clientX })=>{
            if (clientX <= 0 || !isVisible) return;
            const { offsetLeft: offsetLeft, offsetWidth: offsetWidth } = $96293bb78d73bab2$var$getJswInteractiveRoadmapContainerOffset();
            const maxAdjustment = Math.min(clientX, offsetLeft + offsetWidth);
            const barOffset = initialBarOffset + leftAdjustment + offsetLeft + 12;
            let width = Math.max(isDemoComplete ? $96293bb78d73bab2$var$minimumRoadmapBarWidth : $96293bb78d73bab2$var$roadmapBarWidth, maxAdjustment - barOffset);
            width = Math.floor(width / 10) * 10; // skip update if bar width did not change
            if (barWidth === width) return;
            setBarWidth(width);
            if (barRef.current) barRef.current.style.width = `${width}px`;
            dispatchWindowEventProjectTimelineAdjusted();
        };
        onDragLeft = ({ clientX: clientX })=>{
            if (!isDemoComplete) return;
            if (clientX <= 0 || !isVisible) return;
            const { offsetLeft: offsetLeft } = $96293bb78d73bab2$var$getJswInteractiveRoadmapContainerOffset();
            const updatedClientX = Math.floor(clientX / 10) * 10;
            const barOffset = initialBarOffset + offsetLeft + 15;
            const updatedLeftAdjustment = updatedClientX - (barOffset !== null && barOffset !== void 0 ? barOffset : 0); // check if width is allowed
            let width = 0;
            if (updatedLeftAdjustment > prevLeftAdjustment) width = barWidthOnDrag - Math.abs(updatedLeftAdjustment - prevLeftAdjustment);
            else width = barWidthOnDrag + Math.abs(updatedLeftAdjustment - prevLeftAdjustment);
             // adjustment was passed roadmap bar min width
            if (width < $96293bb78d73bab2$var$minimumRoadmapBarWidth) return;
            setLeftAdjustment(Math.max(updatedLeftAdjustment, 1));
            dispatchWindowEventProjectTimelineAdjusted();
        };
        onDragRightEnd = ()=>{
            // the user did not leave the first column.
            if (barRef.current && barRef.current.offsetWidth < 205) {
                setShowAdjustmentLines(false); // dispatch event for the spotlight so instructions can be viewed again.
                const windowEvent = new Event(`${(0, $bb1RF.Actions).ADJUST_PROJECT_TIMELINE}_REWIND`);
                createAnalyticsEvent({
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "interactiveRoadmapAdjustProjectTimeline",
                    eventType: "ui"
                }).fire();
                dispatchEvent(windowEvent);
                return;
            }
            setShowAdjustmentLines(false);
            if (onAdjustProjectTimeline) onAdjustProjectTimeline();
            hideVertivalLinesOnRoadmapBar();
        };
        onDragLeftEnd = ()=>{
            if (barRef.current) setBarWidth(barRef.current.offsetWidth);
            hideVertivalLinesOnRoadmapBar();
        };
        onMouseEnter = ()=>setShowAdjustmentLines(true);
        onMouseLeave = hideVertivalLinesOnRoadmapBar; // eslint-disable-next-line complexity
        onKeyDownRight = (event)=>{
            switch(event.key.toLowerCase()){
                case $96293bb78d73bab2$var$ENTER_KEY:
                case $96293bb78d73bab2$var$SPACEBAR_KEY:
                    event.preventDefault();
                    if (!isKeyboardEditMode) {
                        // enter keyboard edit mode; message box disappear
                        const windowEvent = new Event((0, $bb1RF.Actions).ADJUST_PROJECT_TIMELINE);
                        createAnalyticsEvent({
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "interactiveRoadmapAdjustProjectTimeline",
                            eventType: "ui"
                        }).fire();
                        dispatchEvent(windowEvent);
                        updateAriaLiveText(intl.formatMessage((0, $fIM1v.messages).ariaLabelSpacebarToEditKeyPress));
                    } else {
                        // if bar didn't change size make spotlight appear
                        if (barRef.current && barRef.current.offsetWidth < 206) {
                            const windowEvent = new Event(`${(0, $bb1RF.Actions).ADJUST_PROJECT_TIMELINE}_REWIND`);
                            createAnalyticsEvent({
                                action: "clicked",
                                actionSubject: "button",
                                actionSubjectId: "interactiveRoadmapAdjustProjectTimeline",
                                eventType: "ui"
                            }).fire();
                            dispatchEvent(windowEvent);
                        } else {
                            if (onAdjustProjectTimeline) onAdjustProjectTimeline();
                            dispatchWindowEventProjectTimelineAdjusted();
                        }
                        updateAriaLiveText(intl.formatMessage((0, $fIM1v.messages).ariaLabelSpacebarToPlaceKeyPress));
                    }
                    setKeyboardEditMode(!isKeyboardEditMode);
                    return;
                case $96293bb78d73bab2$var$A_KEY:
                case $96293bb78d73bab2$var$LEFT_ARROW_KEY:
                    // if not in edit mode
                    if (!isKeyboardEditMode) return;
                    event.preventDefault(); // if roadmap bar is already min size
                    if (isDemoComplete && barWidth - 10 < $96293bb78d73bab2$var$minimumRoadmapBarWidth) return;
                    else if (!isDemoComplete && barWidth - 9 < $96293bb78d73bab2$var$roadmapBarWidth) return;
                    if (barRef.current) barRef.current.style.width = `${barWidth - 10}px`;
                    setBarWidth(barWidth - 10);
                    updateAriaLiveText(intl.formatMessage((0, $fIM1v.messages).ariaLabelLeftArrowPress));
                    return;
                case $96293bb78d73bab2$var$D_KEY:
                case $96293bb78d73bab2$var$RIGHT_ARROW_KEY:
                    // if not in edit mode
                    if (!isKeyboardEditMode) return;
                    event.preventDefault(); // if bar is max size
                    if (barWidth + leftAdjustment + 10 > $96293bb78d73bab2$var$maxRoadmapBarSize) return;
                    if (barRef.current) barRef.current.style.width = `${barWidth + 10}px`;
                    setBarWidth(barWidth + 10);
                    updateAriaLiveText(intl.formatMessage((0, $fIM1v.messages).ariaLabelRightArrowPress));
            }
        };
        onKeyDownLeft = (event)=>{
            // if demo not complete
            if (!isDemoComplete) return;
            switch(event.key.toLowerCase()){
                case $96293bb78d73bab2$var$ENTER_KEY:
                case $96293bb78d73bab2$var$SPACEBAR_KEY:
                    event.preventDefault();
                    if (!isKeyboardEditMode) updateAriaLiveText(intl.formatMessage((0, $fIM1v.messages).ariaLabelSpacebarToEditKeyPress));
                     // on exit keyboard edit mode adjust epic bar
                    if (isKeyboardEditMode) {
                        dispatchWindowEventProjectTimelineAdjusted();
                        updateAriaLiveText(intl.formatMessage((0, $fIM1v.messages).ariaLabelSpacebarToPlaceKeyPress));
                    }
                    setKeyboardEditMode(!isKeyboardEditMode);
                    return;
                case $96293bb78d73bab2$var$A_KEY:
                case $96293bb78d73bab2$var$LEFT_ARROW_KEY:
                    // if not in edit mode
                    if (!isKeyboardEditMode) return;
                    event.preventDefault();
                    if (leftAdjustment > 1) {
                        setLeftAdjustment(leftAdjustment - 10);
                        setBarWidth(barWidth + 10);
                        updateAriaLiveText(intl.formatMessage((0, $fIM1v.messages).ariaLabelLeftArrowPress));
                    }
                    return;
                case $96293bb78d73bab2$var$D_KEY:
                case $96293bb78d73bab2$var$RIGHT_ARROW_KEY:
                    // if not in edit mode
                    if (!isKeyboardEditMode) return;
                    event.preventDefault();
                    if (barWidth + 10 > $96293bb78d73bab2$var$minimumRoadmapBarWidth) {
                        setLeftAdjustment(leftAdjustment + 10);
                        setBarWidth(barWidth - 10);
                        updateAriaLiveText(intl.formatMessage((0, $fIM1v.messages).ariaLabelRightArrowPress));
                    }
            }
        };
    }
    const verticalLineOpacity = isVisible && canAdjust && showAdjustmentLines ? "1" : "0";
    const showChildControls = !!(isVisible && canAdjust && onClick === undefined);
    const updateAriaLiveText = (text)=>{
        const ariaLiveContainer = document.getElementById(ariaLiveContainerId);
        if (ariaLiveContainer) {
            ariaLiveContainer.innerText = "";
            setTimeout(()=>{
                ariaLiveContainer.innerText = text;
            }, 300);
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)($96293bb78d73bab2$var$Container, {
        as: onClick === undefined ? "div" : "button",
        ref: barRef,
        "data-testid": "roadmap-bar",
        opacity: opacity,
        barWidth: `${barWidth}px`,
        marginLeft: `${marginLeft}px`,
        hoverOpacity: hoverOpacity,
        barHeight: barHeight,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onClick: onClick,
        color: color,
        children: [
            showChildControls && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($96293bb78d73bab2$var$VerticalLineContainer, {
                        "aria-label": intl.formatMessage((0, $fIM1v.messages).ariaLabelLeftVerticalRoadmapBar),
                        role: "input",
                        "data-testid": "left-vertical-line-container",
                        draggable: canAdjust,
                        onDragStart: onDragStartLeft,
                        onDrag: onDragLeft,
                        onDragEnd: onDragLeftEnd,
                        onFocus: onFocus,
                        onBlur: onBlur,
                        onKeyDown: onKeyDownLeft,
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($96293bb78d73bab2$var$VerticalLine, {
                            opacity: verticalLineOpacity,
                            lineColor: lineColor
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($96293bb78d73bab2$var$VerticalLineContainer, {
                        "aria-label": intl.formatMessage((0, $fIM1v.messages).ariaLabelRightVerticalRoadmapBar),
                        role: "input",
                        "data-testid": "right-vertical-line-container",
                        draggable: canAdjust,
                        onDragStart: onDragStartRight,
                        onDrag: onDragRight,
                        onDragEnd: onDragRightEnd,
                        onFocus: onFocus,
                        onBlur: onBlur,
                        onKeyDown: onKeyDownRight,
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($96293bb78d73bab2$var$VerticalLine, {
                            opacity: verticalLineOpacity,
                            lineColor: lineColor
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aJi6x.default), {
                role: "status",
                id: ariaLiveContainerId,
                children: ""
            })
        ]
    });
};
const $96293bb78d73bab2$var$Container = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    const { barWidth: barWidth, barHeight: barHeight, marginLeft: marginLeft, hoverOpacity: hoverOpacity } = __cmplp, __cmpldp = (0, $akGnX._)(__cmplp, [
        "barWidth",
        "barHeight",
        "marginLeft",
        "hoverOpacity"
    ]);
    var __cmplp_color;
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmpldp), {
        style: (0, $6iHNw._)((0, $7Knp0._)({}, __cmpls), {
            "--_19wov0t": (0, $43MIc.default)(__cmplp.opacity),
            "--_iupzmk": (0, $43MIc.default)(__cmplp.barWidth),
            "--_zwhg00": (0, $43MIc.default)((__cmplp_color = __cmplp.color) !== null && __cmplp_color !== void 0 ? __cmplp_color : "#82B536"),
            "--_zesoq2": (0, $43MIc.default)(`${__cmplp.barHeight}px`),
            "--_t612a1": (0, $43MIc.default)(__cmplp.marginLeft),
            "--_1at6e1q": (0, $43MIc.default)(__cmplp.hoverOpacity)
        }),
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_tzy4jlcp _1e0c1txw _19itglyw _1bah1yb4 _4cvr1h6o _1bsb1ptz _bfhkkoiu _2rko1y44 _4t3i1gop _18u0p4f8 _v5642uhh _1h7h9zci _16l49zci",
            __cmplp.className
        ])
    }));
});
const $96293bb78d73bab2$var$VerticalLineContainer = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_4t3igktf _1e0c1txw _1bah1h6o _4cvr1h6o _bfhk1j28 _d0aluf7j",
            __cmplp.className
        ])
    }));
});
const $96293bb78d73bab2$var$VerticalLine = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    const { lineColor: lineColor } = __cmplp, __cmpldp = (0, $akGnX._)(__cmplp, [
        "lineColor"
    ]);
    var __cmplp_lineColor;
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmpldp), {
        style: (0, $6iHNw._)((0, $7Knp0._)({}, __cmpls), {
            "--_ky2ldm": (0, $43MIc.default)((__cmplp_lineColor = __cmplp.lineColor) !== null && __cmplp_lineColor !== void 0 ? __cmplp_lineColor : "var(--ds-chart-lime-bolder, #5B7F24)"),
            "--_19wov0t": (0, $43MIc.default)(__cmplp.opacity)
        }),
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1bsb1y44 _4t3i1w8u _2rko1y44 _bfhkzurl _19pkidpf _2hwx14y2 _otyridpf _18u014y2 _v5641v24 _tzy4jlcp",
            __cmplp.className
        ])
    }));
});

});
parcelRegister("jUM44", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82bfbf7ed9307fed$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
function $82bfbf7ed9307fed$var$usePrevious(value) {
    const ref = (0, $iSvIT.useRef)();
    (0, $iSvIT.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
var $82bfbf7ed9307fed$export$2e2bcd8739ae039 = $82bfbf7ed9307fed$var$usePrevious;

});



parcelRegister("jUUP7", function(module, exports) {

$parcel$export(module.exports, "SpotlightView", function () { return $29fbfc1e59c7aae7$export$ab7b148ce46c18c; });
/* spotlight.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $aJi6x = parcelRequire("aJi6x");

var $fIM1v = parcelRequire("fIM1v");
parcelRequire("jdqkE");
var $bb1RF = parcelRequire("bb1RF");

var $gtUh9 = parcelRequire("gtUh9");

var $f5YxX = parcelRequire("f5YxX");
const $29fbfc1e59c7aae7$var$SpotlightWrapper = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    const { posY: posY, posX: posX } = __cmplp, __cmpldp = (0, $akGnX._)(__cmplp, [
        "posY",
        "posX"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmpldp), {
        style: (0, $6iHNw._)((0, $7Knp0._)({}, __cmpls), {
            "--_12ntnhn": (0, $43MIc.default)(__cmplp.posY, "px"),
            "--_11rieij": (0, $43MIc.default)(__cmplp.posX, "px")
        }),
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_kqswstnw _152trajn _1e021451 _1e0c1txw _2lx2vrvc _1bah1y6m _4cvr1y6m _v5641kr1 _lcxvglyw _1pbycs5v",
            __cmplp.className
        ])
    }));
});
const $29fbfc1e59c7aae7$var$baseShadow = `0 0 0 1px ${"var(--ds-border-focused, rgba(29, 122, 252, 1))"}`;
const $29fbfc1e59c7aae7$var$pulseBlob = null;
const $29fbfc1e59c7aae7$var$TextWrapper = null;
const $29fbfc1e59c7aae7$var$HeaderText = null;
const $29fbfc1e59c7aae7$var$SubheaderText = null;
const $29fbfc1e59c7aae7$var$MessageBox = ({ header: header, body: body, icon: icon })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1bsbg8x7 _4t3i1wug _1e0c1txw _2lx21bp4 _ca0q7vkz _u5f3gktf _n3td7vkz _19bvgktf _2rko7vkz _19it1tdf _bfhku67f _16qsjojz"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc _zulp19bv _1pfhidpf _1wybgktf _k48p1fw0 _6rth19bv"
                ]),
                children: [
                    icon && icon,
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, header))
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_syazr3uz _1wyb7vkz _k48p1nn1 _1v71idpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, body))
            })
        ]
    });
};
const $29fbfc1e59c7aae7$var$ScreenReaderMessageBox = ({ header: header, body: body })=>{
    // Unsophisticated way to prevent the aria-live screen reader announcement on first render
    const isFirstMessage = (id)=>id.endsWith("Stage1");
    if (isFirstMessage(header.id) || isFirstMessage(body.id)) return null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, header)),
            " ",
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), (0, $7Knp0._)({}, body))
        ]
    });
};
const $29fbfc1e59c7aae7$export$ab7b148ce46c18c = ()=>{
    const { header: header, body: body, posX: posX = 0, posY: posY = 0 } = (0, $gtUh9.useAppSelector)(({ spotlight: spotlight })=>spotlight || {});
    const intl = (0, $f6qj2.default)();
    const epicLabelText = (0, $iSvIT.useMemo)(()=>intl.formatMessage((0, $fIM1v.messages).epic), [
        intl
    ]);
    const isDemoComplete = (0, $gtUh9.useAppSelector)(({ isDemoComplete: isDemoComplete })=>isDemoComplete); /**
                          * custom event listener to detect when project timeline is adjusted.
                          * This will transition the spotlight opacity to ZERO until the next
                          * interactive state is dispatched.
                          * */ 
    (0, $iSvIT.useEffect)(()=>{
        addEventListener((0, $bb1RF.Actions).ADJUST_PROJECT_TIMELINE, ()=>{
            const element = document.getElementById("spotlight-wrapper");
            if (element) element.style.opacity = "0";
        });
        addEventListener(`${(0, $bb1RF.Actions).ADJUST_PROJECT_TIMELINE}_REWIND`, ()=>{
            const element = document.getElementById("spotlight-wrapper");
            if (element) element.style.opacity = "1";
        });
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        const element = document.getElementById("spotlight-wrapper");
        if (element) element.style.opacity = "1";
    }, [
        header,
        body,
        posX,
        posY
    ]);
    if (isDemoComplete || header === undefined) return null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)($29fbfc1e59c7aae7$var$SpotlightWrapper, {
                id: "spotlight-wrapper",
                "data-testid": "spotlight-wrapper",
                posX: posX,
                posY: posY,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_bfhk161p _19it1tdf _2rko1ssb _4t3i14no _1bsb14no _19pk14y2 _2hwx19bv _otyr19bv _18u019bv _y44vofvf"
                        ])
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($29fbfc1e59c7aae7$var$MessageBox, {
                        header: header,
                        body: body,
                        icon: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f5YxX.Epic16IconCustom), {
                            primaryColor: "#BF63F3",
                            label: epicLabelText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aJi6x.default), {
                role: "status",
                children: /*#__PURE__*/ (0, $loA2J.jsx)($29fbfc1e59c7aae7$var$ScreenReaderMessageBox, {
                    header: header,
                    body: body
                })
            })
        ]
    });
};

});

parcelRegister("lz6rS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde83e04c03c7c8c$export$2e2bcd8739ae039; });

var $4m2lj = parcelRequire("4m2lj");

var $aeFQk = parcelRequire("aeFQk");
const $fde83e04c03c7c8c$var$store = (0, $4m2lj.configureStore)({
    reducer: (0, $aeFQk.reducer)((0, $aeFQk.initialState)),
    devTools: {
        name: "jsw-interactive-roadmap/global"
    }
});
var $fde83e04c03c7c8c$export$2e2bcd8739ae039 = $fde83e04c03c7c8c$var$store;

});




parcelRegister("h3koM", function(module, exports) {

$parcel$export(module.exports, "JSWFeaturesPageBanner", function () { return $1aa494704d1acc6b$export$8ab830e7fb51d52c; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $fovuc = parcelRequire("fovuc");

var $3FBn4 = parcelRequire("3FBn4");
const $1aa494704d1acc6b$export$8ab830e7fb51d52c = ()=>{
    const intl = (0, $f6qj2.default)();
    const aiBannerMessages = {
        identifier: "JiraSoftwareFeaturesPageTemplate.atlassian-intelligence_exp",
        text: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageTemplate.banner-alert.atlassian-intelligence_exp",
            defaultMessage: "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageTemplate.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: (0, $3FBn4.useLocalizedHref)("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "jiraSoftware",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fovuc.default), (0, $7Knp0._)({}, aiBannerMessages));
};

});

parcelRegister("4j5uS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e4421cdcdad731d$export$2e2bcd8739ae039; });
/* cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bQawl = parcelRequire("bQawl");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");
const $9e4421cdcdad731d$var$jiraFeatureCTASectionStyle = null;
const $9e4421cdcdad731d$var$ctaSectionTextStyle = null;
const $9e4421cdcdad731d$var$ctaSectionTextStyleHeading = null;
const $9e4421cdcdad731d$var$ctaSectionTextStyleButton = null;
const $9e4421cdcdad731d$var$ctaSectionlinkStyle = null;
const $9e4421cdcdad731d$var$CTASection = ()=>{
    const intl = (0, $f6qj2.default)();
    const getItFreeText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.heroCTA",
        defaultMessage: "Get it free"
    });
    const linkDataEventProps = {
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-product-key": "jiraSoftware"
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_ca0q7vkz _u5f3idpf _n3tdvbgk _19bvidpf _kqswh2mm _12l21wug _ahbq1wug _1ul91osq _11rm1hrf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _1pfho7ao _1yt41fpc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_s7n41q9y _6rth7vkz _vwz411ph _syaz1bqd _1pfhidpf _1dyznl7k _k48pbfng _1cqs1k92 _1s181k8s"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "JiraSoftwareFeaturesPage.ctaSection.header",
                            defaultMessage: "Get started with Jira Software"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                        text: getItFreeText,
                        "aria-label": getItFreeText,
                        color: "darkblue",
                        url: (0, $3FBn4.useLocalizedHref)("/software/jira/free"),
                        dataEventProps: {
                            "data-product-key": "jiraSoftwareFeature",
                            "data-event-component": "linkButton",
                            "data-event-container": "ctaSection",
                            "data-event": "clicked",
                            "data-label": getItFreeText
                        },
                        className: (0, $esG4f.default)([
                            "_18s81ag2 _k48pbfng _1tke1ylp _3fcw1g80 _s7n41q9y _d5ymcfaq"
                        ])
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        type: "anchor",
                        href: (0, $3FBn4.useLocalizedHref)("/software/jira/pricing"),
                        text: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPage.ctaSection.seePricing",
                            defaultMessage: "See pricing"
                        }),
                        bgColor: "bgWhite",
                        dataEventProps: linkDataEventProps,
                        className: (0, $esG4f.default)([
                            "_vwz47vkz _1wyb7vkz"
                        ])
                    })
                ]
            })
        })
    });
};
var $9e4421cdcdad731d$export$2e2bcd8739ae039 = $9e4421cdcdad731d$var$CTASection;

});

parcelRegister("lw58d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6534d897061f3ee7$export$2e2bcd8739ae039; });
/* dev-ops.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $ix9oc = parcelRequire("ix9oc");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $lnhFK = parcelRequire("lnhFK");
const $6534d897061f3ee7$var$devOpsSectionStyle = null;
const $6534d897061f3ee7$var$DevOpsSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_bfhk1mpp _ouxl1ssb _12vemgnk _1lrw1dfr _syazu67f _ca0q16xz _u5f316xz _n3td16xz _19bvidpf _ai3d7vkz _fglvidpf _y5sa7vkz _1a4pidpf _1qj84jg8 _3skuahaf _1lcr1k8s _5c641ule _1o2r1bp4 _1von1h6o _1ufw7vkz _qaroidpf _3ogj7vkz _1r46idpf _1fwdglyw _1khm1bp4 _1vh71h6o _5cwf7vkz _uok1idpf _15x77vkz _1l1jidpf _yerozwfg _235vidpf _ugxvzwfg _1v4xidpf _eapqidpf _9r7v53f4 _q4m21tcg _9n8y12am _wo9dgrf3 _1cyfgrf3 _1si0grf3 _az43grf3 _1em61fra _n1ju1wug _1sly1wug _exgw1wug _ow8r1wug _jss411p5 _1p0whdqu _17euidpf _1gey1h6o _15txpxbi _ofslglyw _1lhl1ule"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: "section-container",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "desktop-img",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($6534d897061f3ee7$var$DevOpsImage, {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: "content-container",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "dev-ops-content",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                                headerType: "h2",
                                headerText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "JiraSoftwareFeaturesPageTemplate.devOpsSection.header",
                                    defaultMessage: "Open DevOps",
                                    values: (0, $3FBn4.DEFAULT_VALUES)
                                }),
                                bodyText: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    id: "JiraSoftwareFeaturesPageTemplate.devOpsSection.body",
                                    defaultMessage: "No single vendor can deliver everything your team needs to do DevOps. But using multiple tools can be messy. With Atlassian Open DevOps - you don\u2019t need to choose.{br}{br}Using Jira as the central source of truth for your DevOps practices, unlock the extensibility of an open, diverse toolchain while keeping the ease and coordination of an all-in-one.",
                                    values: (0, $3FBn4.DEFAULT_VALUES)
                                }),
                                ctaProps: {
                                    buttonProps: {
                                        text: intl.formatMessage({
                                            id: "JiraSoftwareFeaturesPageTemplate.devOpsSection.cta",
                                            defaultMessage: "Learn more"
                                        }),
                                        url: "https://www.atlassian.com/solutions/devops",
                                        type: "secondary",
                                        color: "white",
                                        size: "small",
                                        dataEventProps: {
                                            "data-event-component": "linkButton",
                                            "data-event-container": "devOpsSection",
                                            "data-event": "clicked",
                                            "data-product-key": "jiraSoftware"
                                        }
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "mobile-img",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($6534d897061f3ee7$var$DevOpsImage, {})
                        })
                    ]
                })
            ]
        })
    });
};
const $6534d897061f3ee7$var$DevOpsImage = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedImageSrc = (0, $lnhFK.getDevOpsSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
        image: {
            src: localizedImageSrc,
            alt: intl.formatMessage({
                id: "JiraSoftwareFeaturePageTemplate.devOpsSection.imageAlt",
                defaultMessage: "DevOps diagram: Plan, code, deploy, operate, collaborate"
            })
        }
    });
};
var $6534d897061f3ee7$export$2e2bcd8739ae039 = $6534d897061f3ee7$var$DevOpsSection;

});

parcelRegister("6hIOc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8852b2ec34ebc959$export$2e2bcd8739ae039; });
/* drag-and-drop.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $bQawl = parcelRequire("bQawl");

var $bhreu = parcelRequire("bhreu");

var $3FBn4 = parcelRequire("3FBn4");

var $lnhFK = parcelRequire("lnhFK");
const $8852b2ec34ebc959$var$sectionWrapperStyle = null;
const $8852b2ec34ebc959$var$outerContainerStyle = null;
const $8852b2ec34ebc959$var$dragAndDropSectionStyle = null;
const $8852b2ec34ebc959$var$headers = null;
const $8852b2ec34ebc959$var$containerStyles = null;
const $8852b2ec34ebc959$var$h2Styles = null;
const $8852b2ec34ebc959$var$pStyle = null;
const $8852b2ec34ebc959$var$imageStyles = null;
const $8852b2ec34ebc959$var$buttonStyles = null;
const $8852b2ec34ebc959$var$DragAndDropImage = ()=>{
    const intl = (0, $f6qj2.default)();
    const localizedImageSrc = (0, $lnhFK.getDragAndDropSectionImage)(intl.locale);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _y3gn1h6o _1bah1h6o _1bsb1osq _kiya1tcg _mezj1kdj _1jtn7vkz"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
            image: {
                src: localizedImageSrc,
                alt: intl.formatMessage({
                    id: "JiraSoftwareFeaturePageTemplate.dragAndDropSection.icons",
                    defaultMessage: "dragAndDrop icons: When, If, Then, Add"
                })
            }
        })
    });
};
const $8852b2ec34ebc959$var$DragAndDropSection = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bah1h6o _y3gn1h6o _1q517vkz _xlt1zwfg _1yd3vbgk"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _1e0c1txw _1bah1h6o _y3gn1h6o"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o _4t3i1osq _1tke1osq _1ywgzbi8 _17m61ssb _16nzmgnk _1mva1f51 _1kmx7vkz _1ggmidpf _1ykz7vkz _1maeidpf _1rfm1osq _gkko1vpa _13hp17hf _74gkrvsl _b2g06pq2 _i6jxvbgk _1lh7idpf _z3ncvbgk _wpaiidpf _12rr1are _1gnk5ngq _p17a1l7j _1u5rrvsl _rb2g6pq2 _3vshvbgk _op2cidpf _gos3vbgk _50abidpf _1hr21are _ij145ngq _1odrbypc _18xu1lp1 _1o606pq2 _2tdevbgk _1a87idpf _uwpcvbgk _3r7oidpf _6ru51are _2rko19bv _wehcs1dt"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1rfm1osq _12rr1ssb _gltef2ck"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_y3gn1h6o _1e0c1txw _2lx21bp4 _4cvr1h6o _ca0q1j6v _u5f31j6v _n3td1j6v _19bv1j6v"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _y3gn1h6o _syaz1bqd _1dyzidpf _k48pbfng _s7n4nkob _1gw8ahaf _1pah11ph _e4kmnkob _1pfhgrf3 _1eglwk7l _1tnta982"
                                ]),
                                children: intl.formatMessage({
                                    id: "JiraSoftwareFeaturesPageTemplate.drag-and-drop.title",
                                    defaultMessage: "Drag and drop automation"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: (0, $esG4f.default)([
                                        "_1wyb1j6v _vwz4bs82 _y3gn1h6o _ae4v1h6o _syaz1mpp _6rth1tcg _1pfhidpf"
                                    ]),
                                    children: intl.formatMessage({
                                        id: "JiraSoftwareFeaturesPageTemplate.drag-and-drop.description",
                                        defaultMessage: "Focus on the important things. Let automation do the rest. Powerful, yet simple - Jira automation is actually fun to use."
                                    }, (0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)))
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.Button), {
                                    text: intl.formatMessage({
                                        id: "JiraSoftwareFeaturesPageTemplate.drag-and-drop.learnMore",
                                        defaultMessage: "Learn more"
                                    }),
                                    url: (0, $3FBn4.useLocalizedHref)("/software/jira/automation-template-library"),
                                    size: "small",
                                    type: "primary",
                                    color: "darkblue",
                                    dataEventProps: {
                                        "data-product-key": "jiraSoftwareFeature",
                                        "data-event": "clicked",
                                        "data-event-component": "linkButton",
                                        "data-event-container": "dragAndDropSection"
                                    },
                                    className: (0, $esG4f.default)([
                                        "_1e0c116y _k48pbfng _19it36id _v564p9y3 _6rth1tcg _ca0q1y44 _u5f319bv _n3td1y44 _19bv19bv"
                                    ])
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)($8852b2ec34ebc959$var$DragAndDropImage, {})
                        ]
                    })
                })
            })
        })
    });
};
var $8852b2ec34ebc959$export$2e2bcd8739ae039 = $8852b2ec34ebc959$var$DragAndDropSection;

});

parcelRegister("89fr1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e7384ea7be54109$export$2e2bcd8739ae039; });
/* features.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $mH57S = parcelRequire("mH57S");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $lnhFK = parcelRequire("lnhFK");
const $2e7384ea7be54109$var$containerStyles = null;
const $2e7384ea7be54109$var$FeaturesSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const header = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageTemplate.FeaturesSection.header",
        defaultMessage: "See code and deployment status at a glance in Jira "
    }, (0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)));
    const subtitle = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageTemplate.FeaturesSection.subtitle",
        defaultMessage: "Let developers focus on code"
    }, (0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)));
    const viewRepositoriesLocalizedImageSrc = (0, $lnhFK.getViewRepositoriesSectionImage)(intl.locale);
    const featureCoordinateLocalizedImageSrc = (0, $lnhFK.getFeatureCoordinateSectionImage)(intl.locale);
    const featureConnectWorkLocalizedImageSrc = (0, $lnhFK.getFeatureConnectWorkSectionImage)(intl.locale);
    const featureCards = [
        {
            title: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageTemplate.FeaturesSection.view-repositories-title",
                defaultMessage: "View repositories"
            }),
            body: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageTemplate.FeaturesSection.view-repositories-body",
                defaultMessage: "Include an issue key in a commit, branch name, or PR and it will automatically update in Jira."
            }),
            contentSrc: viewRepositoriesLocalizedImageSrc
        },
        {
            title: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageTemplate.FeaturesSection.coordinate-title",
                defaultMessage: "See development status"
            }),
            body: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageTemplate.FeaturesSection.coordinate-body",
                defaultMessage: "View and create branches, pull requests and view commits right inside the Jira issue development panel. "
            }),
            contentSrc: featureCoordinateLocalizedImageSrc
        },
        {
            title: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageTemplate.FeaturesSection.connect-work-title",
                defaultMessage: "Get DevOps visibility"
            }),
            body: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageTemplate.FeaturesSection.connect-work-body",
                defaultMessage: "Visualize and measure progress from idea through to production across all tools. "
            }),
            contentSrc: featureConnectWorkLocalizedImageSrc
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1q517vkz _11q7vejh _1xj8idpf _1n46idpf _if5y1wug _1gnpidpf _7e5b1wug _1kll1k8s _dxb61osq _1x1pahaf _fc8qf2ck _j269ahaf _1d3r1ssb _1p6ooqnp _ukz1idpf _q8x27vkz _1w9midpf _1v7didpf _1r21idpf _12it19bv _dg377vkz"
        ]),
        style: {
            "--_nl5by5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue1000"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $mH57S.default), {
            subtitle: subtitle,
            header: header,
            background: "darkblue",
            mediaType: "image",
            transparentActiveBackground: true,
            cards: featureCards
        })
    });
};
var $2e7384ea7be54109$export$2e2bcd8739ae039 = $2e7384ea7be54109$var$FeaturesSection;

});
parcelRegister("mH57S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d06996ace38595$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $64d06996ace38595$var$IMAGE_CYCLE_TIME = 7000;
const $64d06996ace38595$var$hexAlpha30 = "4D"; // 30% alpha as hex
const $64d06996ace38595$var$FeatureHighlightStyles = {
    lightblue: {
        // eslint-disable-next-line local/ensure-wac-token-usage
        backgroundColor: "#deebff",
        cardActiveBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        cardHoverBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        // eslint-disable-next-line local/ensure-wac-token-usage
        headerColor: "#253858",
        // eslint-disable-next-line local/ensure-wac-token-usage
        subtitleColor: "#253858",
        // eslint-disable-next-line local/ensure-wac-token-usage
        textColor: "#091e42",
        // eslint-disable-next-line local/ensure-wac-token-usage
        labelColor: "#505f79"
    },
    white: {
        backgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        cardActiveBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        cardHoverBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        // eslint-disable-next-line local/ensure-wac-token-usage
        headerColor: "#253858",
        // eslint-disable-next-line local/ensure-wac-token-usage
        subtitleColor: "#253858",
        // eslint-disable-next-line local/ensure-wac-token-usage
        textColor: "#091e42",
        // eslint-disable-next-line local/ensure-wac-token-usage
        labelColor: "#505f79"
    },
    darkblue: {
        // eslint-disable-next-line local/ensure-wac-token-usage
        backgroundColor: "#091e42",
        cardActiveBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        cardHoverBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        headerColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        subtitleColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        textColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        labelColor: (0, $5ohHq.wacToken)("color.neutral.light0")
    },
    blue: {
        // eslint-disable-next-line local/ensure-wac-token-usage
        backgroundColor: "#0049b0",
        cardActiveBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        cardHoverBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        headerColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        subtitleColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        textColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        labelColor: (0, $5ohHq.wacToken)("color.neutral.light0")
    },
    purple: {
        // eslint-disable-next-line local/ensure-wac-token-usage
        backgroundColor: "#403294",
        cardActiveBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        cardHoverBackgroundColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        headerColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        subtitleColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        textColor: (0, $5ohHq.wacToken)("color.neutral.light0"),
        labelColor: (0, $5ohHq.wacToken)("color.neutral.light0")
    }
};
const $64d06996ace38595$var$wrapperCss = null;
const $64d06996ace38595$var$rowCss = null;
const $64d06996ace38595$var$columnReverseCss = null;
const $64d06996ace38595$var$contentsWrapperCss = null;
const $64d06996ace38595$export$952d389b2ff24f75 = (props)=>{
    const { card: card } = props;
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        src: card.contentSrc,
        alt: card.title,
        width: "100%",
        height: "auto"
    }));
};
const $64d06996ace38595$var$isMutableRef = (val)=>{
    return val && val.current;
};
const $64d06996ace38595$export$46bdf721bf05c591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef((props, ref)=>{
    const { key: key, index: index, card: card, onEnded: onEnded } = props;
    return /*#__PURE__*/ (0, $loA2J.jsx)("video", {
        ref: (element)=>{
            if (ref && $64d06996ace38595$var$isMutableRef(ref) && element) ref.current[index] = element;
        },
        width: "100%",
        height: "100%",
        muted: true,
        "object-fit": "fill",
        preload: "auto",
        tabIndex: -1,
        onEnded: onEnded,
        playsInline: true,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("source", {
            src: card.contentSrc
        })
    }, key);
});
const $64d06996ace38595$var$isFeatureHighlightColor = (color)=>{
    return color === "lightblue" || color === "white" || color === "darkblue" || color === "blue" || color === "purple";
};
const $64d06996ace38595$var$getFeatureHighlightColor = (color)=>{
    const featureHighlightColor = color === null || color === void 0 ? void 0 : color.toLowerCase();
    if (featureHighlightColor && $64d06996ace38595$var$isFeatureHighlightColor(featureHighlightColor)) return featureHighlightColor;
    return "darkblue";
};
const $64d06996ace38595$var$getFeatureHighlightStyle = (color)=>{
    const featureHighlightColor = $64d06996ace38595$var$getFeatureHighlightColor(color);
    return $64d06996ace38595$var$FeatureHighlightStyles[featureHighlightColor];
}; // eslint-disable-next-line complexity
const $64d06996ace38595$var$FeatureHighlight = (props)=>{
    const { transparentBackground: transparentBackground, background: background, barColor: barColor, mediaType: mediaType = "video", transparentActiveBackground: transparentActiveBackground } = props;
    const [selectedIndex, setSelectedIndex] = (0, $iSvIT.useState)(0);
    const [isVideoInView, setIsVideoInView] = (0, $iSvIT.useState)(false);
    const timeoutRef = (0, $iSvIT.useRef)(null);
    const { backgroundColor: backgroundColor, textColor: textColor, labelColor: labelColor, headerColor: headerColor, subtitleColor: subtitleColor, cardActiveBackgroundColor: cardActiveBackgroundColor, cardHoverBackgroundColor: cardHoverBackgroundColor } = $64d06996ace38595$var$getFeatureHighlightStyle(background);
    const videoRefMap = (0, $iSvIT.useRef)(Array(props.cards.length).fill(null));
    const videoWrapperRef = (0, $iSvIT.useRef)(null);
    const sectionCss = null;
    const subtitleCss = null;
    const headerCss = null;
    const cardsWrapperCss = null;
    const cardCss = null;
    const selectedCardCss = null;
    const contentsSliderCss = null;
    const mobileDotsCss = null;
    const resetSelectedIndexVideo = (0, $iSvIT.useCallback)(()=>{
        const video = videoRefMap.current[selectedIndex];
        if (video) video.currentTime = 0;
    }, [
        selectedIndex,
        videoRefMap
    ]);
    const resetVideoAndSetSelectedIndex = (index)=>{
        resetSelectedIndexVideo();
        setSelectedIndex(index);
    };
    const nextCard = ()=>{
        const nextIndex = selectedIndex + 1;
        if (nextIndex === cards.length) return;
        resetVideoAndSetSelectedIndex(nextIndex);
    };
    const previousCard = ()=>{
        const nextIndex = selectedIndex - 1;
        if (nextIndex === -1) return;
        resetVideoAndSetSelectedIndex(nextIndex);
    };
    const cards = props.cards.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("button", {
            className: (0, $esG4f.default)([
                "_1e0c116y _2lx21bp4 _16jlkb7n _r06hglyw _19itidpf _bfhk1j28 _191wh83n _syaz1u00 _80omtlke _ect4lnmy _6rthu2gc _1yt4pxbi _y3gn1e5h _1bsb1osq _1bz3glyw _26we4jg8 _12b61osq _1hueh83n _imzuglyw _ruuhh83n _lg5ridpf _d97midpf _1b7eidpf _1252idpf _irr35ir3 _14rmvp1x _dcu3glyw _7h6zvp1x _wkrh6aqr _xafy1ule _n8n4utpp _xn9u1nn1 _zqxcf6fq _1ak5pxbi _10smidpf _1j7jidpf _6r6pidpf _19vxidpf _1fhlangw _1eiubzd7 _93eev47k _gvjubfng _1ebbv47k _jo54nl7k _12k8idpf _1w1midpf _193ridpf _17z3idpf _1eo9u2gc _177zpxbi _12lepxbi _1upc1nn1 _12qh1ejb _1whzidpf _chjpidpf _8j83idpf _1cs1idpf",
                selectedIndex === index && "_bfhkjg8v _191wvp1x _xvbnglyw _196gvp1x",
                "button-class"
            ]),
            onClick: ()=>{
                if (index !== selectedIndex) resetVideoAndSetSelectedIndex(index);
            },
            tabIndex: 0,
            style: {
                "--_142tt2c": (0, $43MIc.default)(barColor ? `${"var(--ds-space-100, 8px)"} solid transparent` : "none"),
                "--_srel9g": (0, $43MIc.default)(textColor),
                "--_1ob9m4q": (0, $43MIc.default)(cardHoverBackgroundColor + $64d06996ace38595$var$hexAlpha30),
                "--_1xwywyj": (0, $43MIc.default)(barColor ? `${"var(--ds-space-100, 8px)"} solid ${barColor}` : "none"),
                "--_x3o4l8": (0, $43MIc.default)(labelColor),
                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
                "--_v4x3sr": (0, $43MIc.default)(transparentActiveBackground ? `${cardActiveBackgroundColor + $64d06996ace38595$var$hexAlpha30}` : `${cardActiveBackgroundColor}`)
            },
            children: [
                card.label && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                    children: card.label
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                    children: card.title
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    children: card.body
                })
            ]
        }, `${card.title}-${index}-button`));
    const contents = ()=>{
        if (mediaType === "image") return props.cards.map((card, index)=>{
            return /*#__PURE__*/ (0, $loA2J.jsx)($64d06996ace38595$export$952d389b2ff24f75, {
                card: card
            }, `${card.title}-${index}-content`);
        });
        return props.cards.map((card, index)=>{
            return /*#__PURE__*/ (0, $loA2J.jsx)($64d06996ace38595$export$46bdf721bf05c591, {
                index: index,
                card: card,
                ref: videoRefMap,
                onEnded: ()=>{
                    selectedIndex + 1 === cards.length ? resetVideoAndSetSelectedIndex(0) : nextCard();
                }
            }, `${card.title}-${index}-content`);
        });
    };
    const [isDragging, setIsDragging] = (0, $iSvIT.useState)(false);
    const [startX, setStartX] = (0, $iSvIT.useState)(0);
    const startDrag = (touchEvent, mouseEvent)=>{
        setIsDragging(true);
        setStartX((touchEvent && touchEvent.touches[0] ? touchEvent === null || touchEvent === void 0 ? void 0 : touchEvent.touches[0].clientX : mouseEvent === null || mouseEvent === void 0 ? void 0 : mouseEvent.clientX) || 0);
    };
    const stopDrag = (touchEvent, mouseEvent)=>{
        if (isDragging) {
            setIsDragging(false);
            let dragAmount = 0;
            if (touchEvent && touchEvent.changedTouches[0]) dragAmount = touchEvent.changedTouches[0].clientX - startX;
            else if (mouseEvent) dragAmount = mouseEvent.clientX - startX;
            if (Math.abs(dragAmount) > 100) {
                if (dragAmount < 0) nextCard(); // Swipe left
                else previousCard(); // Swipe right
            }
        }
    };
    (0, $iSvIT.useEffect)(()=>{
        const handleIntersect = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) setIsVideoInView(true);
                else {
                    setIsVideoInView(false);
                    resetSelectedIndexVideo();
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersect, {
            threshold: 0.3
        });
        const ref = videoWrapperRef.current;
        if (ref) observer.observe(ref);
        return ()=>{
            if (ref) observer.unobserve(ref);
        };
    }, [
        videoWrapperRef,
        resetSelectedIndexVideo
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (isDragging) return;
         // The below logic handles auto playing/pausing videos when they are in/out of view
        // and also handles auto cycling for images
        if (mediaType === "image") {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (!isVideoInView) return;
            timeoutRef.current = window.setTimeout(()=>{
                if (selectedIndex + 1 === cards.length) resetVideoAndSetSelectedIndex(0);
                else nextCard();
            }, $64d06996ace38595$var$IMAGE_CYCLE_TIME);
        } else if (mediaType === "video") videoRefMap.current.forEach((video, videoId)=>{
            if (!video || !video.play) return;
            if (videoId === selectedIndex && isVideoInView) video.play().catch(()=>{});
            else video.pause();
        });
    }, [
        selectedIndex,
        isVideoInView,
        isDragging,
        videoRefMap
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_bfhkdjzn _1reo15vq _18m915vq"
        ]),
        style: {
            "--_zwla6u": (0, $43MIc.default)(transparentBackground ? "transparent" : `${backgroundColor}`)
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_4t3i1ns9 _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1fra _1yt4119w",
                "wrapper-class"
            ]),
            children: [
                props.subtitle && /*#__PURE__*/ (0, $loA2J.jsx)("h6", {
                    className: (0, $esG4f.default)([
                        "_y3gn1h6o _1e0c1txw _2lx21bp4 _1bah1h6o _syaz1pfe _1dyzt94y _19pkidpf _2hwx1wug _otyridpf _18u01wug _6rth19bv _1p1dangw _k48p1nn1 _i6jx1j6v _1lh71j6v _z3nc1j6v _wpai1j6v _13vsxy5q _1lzooqnp _119zcs5v _1kmx1j6v _1ggm1j6v _1ykz1j6v _1mae1j6v _1u2qxy5q _1cqs1ejb _1bysxy5q _1rkb1ris"
                    ]),
                    style: {
                        "--_1jtrf1b": (0, $43MIc.default)(subtitleColor)
                    },
                    children: props.subtitle
                }),
                props.header && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_syaz1p4k _1wyb14no _k48pbfng _vwz41ady _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1oo8 _85i5xy5q _1q51xncg _y3gn1h6o _xc2ixy5q _1cqs1ejb _1bysxy5q _1rkb1ris _1u2qxy5q"
                    ]),
                    style: {
                        "--_1e9fgy7": (0, $43MIc.default)(headerColor)
                    },
                    children: props.header
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    onTouchStart: (e)=>startDrag(e),
                    onMouseDown: (e)=>startDrag(undefined, e),
                    onTouchEnd: (e)=>stopDrag(e),
                    onMouseUp: (e)=>stopDrag(undefined, e),
                    className: (0, $esG4f.default)([
                        props.cardVerticalLayout !== "below" && "_1e0c1txw _zulppxbi _na0i1bp4",
                        props.cardVerticalLayout === "below" && "_1e0c1txw _zulppxbi _na0i1sxn"
                    ]),
                    children: [
                        props.cardLayout !== "right" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_16jlkb7n _1o9zkb7n _i0dlf1ug _kzvi1txw _1gzvxy5q _suga116y _1o83ewfl _98bkewfl _1xacbf4l _95u5gsom _26we1q9c"
                            ]),
                            style: {
                                "--_1j9d7jw-": (0, $43MIc.default)(selectedIndex * 100, "%", "-")
                            },
                            children: cards
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_16jlcs5v _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq",
                                "image-container"
                            ]),
                            ref: videoWrapperRef,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_t9ecgsom _o5721q9c _1xacbf4l"
                                ]),
                                style: {
                                    "--_1j9d7jw-": (0, $43MIc.default)(selectedIndex * 100, "%", "-")
                                },
                                children: contents()
                            })
                        }),
                        props.cardLayout === "right" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_16jlkb7n _1o9zkb7n _i0dlf1ug _kzvi1txw _1gzvxy5q _suga116y _1o83ewfl _98bkewfl _1xacbf4l _95u5gsom _26we1q9c"
                            ]),
                            style: {
                                "--_1j9d7jw-": (0, $43MIc.default)(selectedIndex * 100)
                            },
                            children: cards
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1yt41jx0"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0cglyw _suga1txw _8164utpp _nssp1h6o _460pglyw _l55qbib7 _tpntidpf _qtjq1ssb _m1dtidpf _1hz4idpf _77tyidpf _du85idpf _70xeu2gc _10mru2gc _1hro1u00"
                        ]),
                        style: {
                            "--_1gst4sd": (0, $43MIc.default)(transparentBackground ? "#a5adba" : `${cardActiveBackgroundColor}`),
                            "--_srel9g": (0, $43MIc.default)(textColor)
                        },
                        children: props.cards.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                onClick: ()=>{
                                    if (index !== selectedIndex) resetVideoAndSetSelectedIndex(index);
                                },
                                className: index === selectedIndex ? "active" : ""
                            }, `${card.title}-${index}-mobile-dot`))
                    })
                })
            ]
        })
    });
};
var $64d06996ace38595$export$2e2bcd8739ae039 = $64d06996ace38595$var$FeatureHighlight;

});


parcelRegister("9OQpd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ecbab252f0da070$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $bQawl = parcelRequire("bQawl");

var $3FBn4 = parcelRequire("3FBn4");
const $7ecbab252f0da070$var$jirafeatureHeroSectionStyle = null;
const $7ecbab252f0da070$var$heroSectionTextStyle = null;
const $7ecbab252f0da070$var$heroSectionTextStyleHeading = null;
const $7ecbab252f0da070$var$heroSectionTextStyleText = null;
const $7ecbab252f0da070$var$heroSectionTextStyleButton = null;
const $7ecbab252f0da070$var$HeroSection = ()=>{
    const intl = (0, $f6qj2.default)();
    const getItFreeText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.heroCTA",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _p12f1fra _2lx21bp4 _18s81fk4"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _1pfho7ao _1yt41ue2"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                            className: (0, $esG4f.default)([
                                "_syaz1bqd _1dyzze3t _18s81b95 _vwz410nf _k48pbfng _1cqsxy5q _1s18oahv"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraFeatureSoftwarePageTemplate.heroHeader",
                                defaultMessage: "Jira Software features"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_syazvwuj _18s8a503 _1wybv47k _vwz419ii _1dyzpm5d"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "JiraFeatureSoftwarePageTemplate.heroBody",
                                defaultMessage: "How agile teams build and support world class software",
                                values: (0, $3FBn4.DEFAULT_VALUES)
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                            text: getItFreeText,
                            "aria-label": getItFreeText,
                            color: "darkblue",
                            url: (0, $3FBn4.useLocalizedHref)("/software/jira/free"),
                            dataEventProps: {
                                "data-product-key": "jiraSoftwareFeature",
                                "data-event-component": "linkButton",
                                "data-event-container": "heroSection",
                                "data-event": "clicked",
                                "data-label": getItFreeText
                            },
                            className: (0, $esG4f.default)([
                                "_18s8a503 _k48pbfng"
                            ])
                        })
                    ]
                })
            })
        })
    });
};
var $7ecbab252f0da070$export$2e2bcd8739ae039 = $7ecbab252f0da070$var$HeroSection;

});

parcelRegister("ifJka", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3076f2d3d47c250$export$2e2bcd8739ae039; });
/* project-flexibility.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $9HFEq = parcelRequire("9HFEq");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $e3076f2d3d47c250$var$ProjectFlexibilitySection = ()=>{
    const intl = (0, $f6qj2.default)();
    const body = intl.formatMessage({
        id: "JiraSoftwareFeaturePageTemplate.additional-resources.atlassian-community.body",
        defaultMessage: "Choose from team or company-managed projects. Jira fits around your workflows."
    }, (0, $7Knp0._)({}, (0, $3FBn4.DEFAULT_VALUES)));
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_ca0qzwfg _u5f3idpf _n3td7vkz _19bvidpf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_syaz1tj6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q7vkz _u5f37vkz _n3td14no _19bv7vkz _y3gn1h6o _k48pbfng _1cqs1ejb _xlt11ul9 _1s18ahaf"
                ]),
                style: {
                    "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900"))
                },
                children: intl.formatMessage({
                    id: "JiraSoftwareFeaturePageTemplate.additional-resources.header",
                    defaultMessage: "Project flexibility"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1n261g80 _p12f1fra _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($e3076f2d3d47c250$var$ProjectFlexibilityCard, {
                        headerText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.additional-resources.atlassian-community.header",
                            defaultMessage: "Autonomy and structure"
                        }),
                        bodyText: body,
                        imageLink: "https://wac-cdn.atlassian.com/dam/jcr:b6be290e-c637-4462-9013-b5d17e6920c7/illustrations-spot-Simplify.svg?cdnVersion=1398",
                        imageAltText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.additional-resources.atlassian-community.image-alt-text",
                            defaultMessage: "Simplify illustration"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($e3076f2d3d47c250$var$ProjectFlexibilityCard, {
                        headerText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.additional-resources.atlassian-university.header",
                            defaultMessage: "Customizable workflows"
                        }),
                        bodyText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.additional-resources.atlassian-university.body",
                            defaultMessage: "Create customizable workflows that map to any style of work."
                        }),
                        imageLink: "https://wac-cdn.atlassian.com/dam/jcr:78d20ac0-6ac0-4b58-961a-7d853b3c14dc/illustrations-spot-Complex%20Workflow.svg?cdnVersion=1398",
                        imageAltText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.additional-resources.atlassian-university.image-alt-text",
                            defaultMessage: "Complex workflow illustration"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($e3076f2d3d47c250$var$ProjectFlexibilityCard, {
                        headerText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.additional-resources.support.header",
                            defaultMessage: "Extend with apps and integrations"
                        }),
                        bodyText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.additional-resources.support.body",
                            defaultMessage: "Extend the power of Jira Software. 3000+ apps and integrations available. <a>Learn More</a>"
                        }, {
                            // eslint-disable-next-line react/no-unstable-nested-components
                            a: (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "imageHeadingTextBlock",
                                    "data-product-key": "jiraSoftwareFeature",
                                    "data-label": "Learn more",
                                    href: "https://marketplace.atlassian.com/",
                                    children: node
                                })
                        }),
                        imageLink: "https://wac-cdn.atlassian.com/dam/jcr:76e94ebd-d71e-4991-9008-7b2e838090c8/illustrations-spot-Integrations.svg?cdnVersion=1398",
                        imageAltText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.additional-resources.support.image-alt-text",
                            defaultMessage: "Integrations illustration"
                        })
                    })
                ]
            })
        ]
    });
};
const $e3076f2d3d47c250$var$ProjectFlexibilityCard = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1q517vkz _1bsbx683 _im19n7od _1grg1j28 _31ku1h6o _q7gqpxbi _zcqxv47k _bna7ucft _1jpx1f51 _13mw1h6o _1p94idpf _d47fidpf _1qv9idpf _d600idpf _12rr1ssb _1rfm1osq _1u2qidpf _l5dj7vkz _1k3z7vkz _r8ce7vkz _c2967vkz _1grpidpf _9gn0t94y _1wpnpxbi _1uo7i2wt _156n1h6o _12zm1tj6 _1viz10nf _3hxqnl7k _olikv47k _17q1i2wt _hkjg1h6o _1rcf1tj6 _nb061ep1 _x7ah1q9y _tkz71nn1 _13tl1r31 _12498stv _133knqa1 _ely21r31 _157vglyw _a8kbnqa1"
        ]),
        style: {
            "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
            "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9HFEq.default), {
            headerType: "h4",
            headerText: props.headerText,
            bodyText: props.bodyText,
            imageLink: props.imageLink,
            imageAltText: props.imageAltText,
            aspectRatio: "none"
        })
    });
};
var $e3076f2d3d47c250$export$2e2bcd8739ae039 = $e3076f2d3d47c250$var$ProjectFlexibilitySection;

});

parcelRegister("1N2Ld", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc36be4b3b3260e2$export$2e2bcd8739ae039; });
/* scrum-kanban-board.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $gkV6l = parcelRequire("gkV6l");

var $bQawl = parcelRequire("bQawl");

var $ix9oc = parcelRequire("ix9oc");

var $bhreu = parcelRequire("bhreu");

var $gXzhc = parcelRequire("gXzhc");

var $4XrxY = parcelRequire("4XrxY");

var $lnhFK = parcelRequire("lnhFK");
const $fc36be4b3b3260e2$var$sectionStyle = null;
const $fc36be4b3b3260e2$var$imageLogoStyle = null;
const $fc36be4b3b3260e2$export$68e11e232eb5355a = ({ headerText: headerText, headerType: headerType = "h2", bodyText: bodyText, linkText: linkText, boardLogoImage: boardLogoImage, boardLogoImageAltText: boardLogoImageAltText, imageLink: imageLink, imageAltText: imageAltText, className: className = "", linkClassName: linkClassName = "", tabName: tabName })=>{
    const { openModalForTemplate: openModalForTemplate } = (0, $gkV6l.useSiteSelectorContext)();
    const handleLinkClick = (event)=>{
        event.preventDefault();
        openModalForTemplate({
            templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum",
            templateName: tabName,
            productKey: (0, $i8kxh.ProductKeys).JIRA_SOFTWARE
        });
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ca0qys9h _u5f3idpf _n3tdys9h _19bvidpf _1ks0vbgk _mhvtidpf _1hy8vbgk _v82zidpf _6pejvbgk _11pxidpf _1eeovbgk _e8a8idpf _bpspbfng _7bp51319",
            className
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
            layout: "4-8",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_mezjhwvj _x5atglyw"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                            image: {
                                src: boardLogoImage,
                                alt: boardLogoImageAltText
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.ContentBlock), {
                            headerText: headerText,
                            headerType: headerType,
                            bodyText: bodyText
                        }),
                        linkText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                            type: "secondary",
                            text: linkText,
                            size: "small",
                            className: linkClassName,
                            onClick: handleLinkClick,
                            dataEventProps: {
                                "data-product-key": "jiraSoftwareFeature",
                                "data-event-component": "linkButton",
                                "data-event-container": "featuresSection",
                                "data-event": "clicked",
                                "data-label": linkText,
                                "data-label-english": `Start ${tabName.toLowerCase()} project`
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "board-image",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                        image: {
                            src: imageLink,
                            alt: imageAltText
                        }
                    })
                })
            ]
        })
    });
};
/* Tabs */ const $fc36be4b3b3260e2$var$ScrumBoard = ()=>{
    const intl = (0, $f6qj2.default)();
    const scrumBoardImgSrc = (0, $lnhFK.getScrumSectionImage)(intl.locale);
    const title = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.tabs.scrum.heading",
        defaultMessage: "Scrum boards"
    });
    const bodyText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.tabs.scrum.bodyText",
        defaultMessage: "Scrum boards help agile teams break large, complex projects into manageable pieces of work so focused teams, working in sprints, ship faster."
    });
    const scrumLinkText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.tabs.scrum.linkText",
        defaultMessage: "Start scrum project"
    });
    const scrumLogoImgSrc = "https://wac-cdn.atlassian.com/dam/jcr:9567a40e-6541-4905-bf08-dfe201aa80e7/illustrations-spot-Agile.svg";
    const scrumLogoImgAltText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.tabs.scrum.logo.altText",
        defaultMessage: "Scrum logo"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)($fc36be4b3b3260e2$export$68e11e232eb5355a, {
        headerText: title,
        headerType: "h2",
        bodyText: bodyText,
        linkText: scrumLinkText,
        boardLogoImage: scrumLogoImgSrc,
        boardLogoImageAltText: scrumLogoImgAltText,
        imageLink: scrumBoardImgSrc,
        imageAltText: "scrum",
        className: "scrum-tab",
        linkClassName: "scrum-tab-link",
        tabName: "Scrum"
    });
};
const $fc36be4b3b3260e2$var$KanbanBoard = ()=>{
    const intl = (0, $f6qj2.default)();
    const kanbanBoardImgSrc = (0, $lnhFK.getKanbanSectionImage)(intl.locale);
    const title = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.tabs.kanban.heading",
        defaultMessage: "Kanban boards"
    });
    const bodyText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.tabs.kanban.bodyText",
        defaultMessage: "Flexible kanban boards help teams visualize their workflow, limit work-in-progress, and maximize efficiency as a team. Commonly used by agile and DevOps teams to drive continuous delivery and improvement, get started quickly with a template and customize as you go."
    });
    const kanbanLinkText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.tabs.kanban.linkText",
        defaultMessage: "Start kanban project"
    });
    const kanbanLogoImgSrc = "https://wac-cdn.atlassian.com/dam/jcr:7d0e6516-361d-4ec3-bd0f-22d7c7d105b4/illustrations-spot-JIRA%20Board.svg?cdnVersion=1403";
    const kanbanLogoImgAltText = intl.formatMessage({
        id: "JiraFeatureSoftwarePageTemplate.tabs.kanban.logo.altText",
        defaultMessage: "Kanban logo"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)($fc36be4b3b3260e2$export$68e11e232eb5355a, {
        headerText: title,
        headerType: "h2",
        bodyText: bodyText,
        linkText: kanbanLinkText,
        boardLogoImage: kanbanLogoImgSrc,
        boardLogoImageAltText: kanbanLogoImgAltText,
        imageLink: kanbanBoardImgSrc,
        imageAltText: "kanban",
        className: "kanban-tab",
        linkClassName: "kanban-tab-link",
        tabName: "Kanban"
    });
};
const $fc36be4b3b3260e2$var$scrumKanbanBoardContainerStyle = null;
const $fc36be4b3b3260e2$var$tabSectionTitleStyles = null;
const $fc36be4b3b3260e2$var$tabPillsOverride = null;
const $fc36be4b3b3260e2$export$a18f9d603dcb1d44 = ()=>{
    const intl = (0, $f6qj2.default)();
    const tabsProps = {
        dataProductKey: "jiraSoftwareFeature",
        headerText: intl.formatMessage({
            id: "JiraFeatureSoftwarePageTemplate.tabs.heading",
            defaultMessage: "Manage your work with powerful agile boards"
        }),
        tabStyles: {
            // eslint-disable-next-line local/ensure-wac-token-usage
            defaultBG: "#f4f5f7",
            // eslint-disable-next-line local/ensure-wac-token-usage
            defaultText: "#5e6c84",
            // eslint-disable-next-line local/ensure-wac-token-usage
            hoverBG: "#f4f5f7",
            // eslint-disable-next-line local/ensure-wac-token-usage
            hoverText: "#5e6c84",
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeBG: "#fff",
            // eslint-disable-next-line local/ensure-wac-token-usage
            activeText: "#091e42"
        },
        styles: {
            "--lp-tabs-hover": "#deebff",
            "--lp-tabs-unselected": "#6b778c"
        },
        tabs: [
            {
                textLabel: intl.formatMessage({
                    id: "JiraFeatureSoftwarePageTemplate.label.scrum",
                    defaultMessage: "Scrum"
                }),
                id: "scrum",
                component: $fc36be4b3b3260e2$var$ScrumBoard()
            },
            {
                textLabel: intl.formatMessage({
                    id: "JiraFeatureSoftwarePageTemplate.label.kanban",
                    defaultMessage: "Kanban"
                }),
                id: "kanban",
                component: $fc36be4b3b3260e2$var$KanbanBoard()
            }
        ]
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1itk7f3u _ouxl1ssb _1jqbmgnk _1lrw1dfr"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "8",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_y3gn1h6o _1wyb1k8s _6rth10yn _k48pbfng _syaz1bqd _1gw8ahaf"
                    ]),
                    children: tabsProps.headerText
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1ju91kby _zpmmt94y _pba21k92 _7dyet94y"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gXzhc.default), {
                    tabContentType: "custom",
                    tabs: tabsProps.tabs,
                    id: "tabs",
                    label: "tabs",
                    colors: tabsProps.tabStyles,
                    dataProductKey: tabsProps.dataProductKey
                })
            })
        ]
    });
};
var $fc36be4b3b3260e2$export$2e2bcd8739ae039 = $fc36be4b3b3260e2$export$a18f9d603dcb1d44;

});

parcelRegister("jCsS3", function(module, exports) {

$parcel$export(module.exports, "SecurityScaleSection", function () { return $dd495bc2bbfa4733$export$a14609fab4d6e934; });
/* security-scale.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $ix9oc = parcelRequire("ix9oc");

var $1UUq1 = parcelRequire("1UUq1");

var $3FBn4 = parcelRequire("3FBn4");

var $j9l4D = parcelRequire("j9l4D");
const $dd495bc2bbfa4733$var$contentBlockStyles = null;
const $dd495bc2bbfa4733$var$contianerStyles = null;
const $dd495bc2bbfa4733$var$contentGridStyles = null;
const $dd495bc2bbfa4733$var$iconStyles = null;
const $dd495bc2bbfa4733$var$h3Styles = null;
const $dd495bc2bbfa4733$var$pStyles = null;
const $dd495bc2bbfa4733$export$a14609fab4d6e934 = ()=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_syazygwz _1wyb1ejb _k48pbfng _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _y3gn1h6o _ca0q1ul9 _u5f37vkz _n3td1ul9 _19bv7vkz _1s18ahaf _1akovbgk _c7s77vkz _4puvvbgk _1r3v7vkz"
                ]),
                children: intl.formatMessage({
                    id: "JiraSoftwareFeaturePageTemplate.security-scale.header",
                    defaultMessage: "Designed for security and scale"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1n261g80 _p12f1fra _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.default), {
                        pictureProps: {
                            image: {
                                src: "https://wac-cdn.atlassian.com/dam/jcr:fd487e90-1e57-4412-9c23-5fb20f30ae07/Access%20module%20image-01.svg?cdnVersion=ece",
                                alt: intl.formatMessage({
                                    id: "JiraSoftwareFeaturePageTemplate.security-scale.atlassian-access.image.alt",
                                    defaultMessage: "Control tower illustration"
                                })
                            }
                        },
                        headerType: "h2",
                        headerText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.security-scale.atlassian-access.header",
                            defaultMessage: "Atlassian Access"
                        }),
                        bodyText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.security-scale.atlassian-access.body",
                            defaultMessage: "Sleep soundly with enhanced administration and security backed by SAML SSO, enforced 2-step verification, automated user provisioning, and more."
                        }),
                        ctaProps: {
                            primaryLinkProps: {
                                text: intl.formatMessage({
                                    id: "JiraSoftwareFeaturePageTemplate.security-scale.learn-more.link",
                                    defaultMessage: "Learn more"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("/software/guard"),
                                dataEventProps: {
                                    "data-product-key": "jiraSoftwareFeature",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "cardSection",
                                    "data-event": "clicked",
                                    "data-label": intl.formatMessage({
                                        id: "JiraSoftwareFeaturePageTemplate.security-scale.learn-more.link",
                                        defaultMessage: "Learn more"
                                    }),
                                    "data-label-english": "Learn more"
                                }
                            }
                        },
                        className: (0, $esG4f.default)([
                            "_ca0qidpf _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _5j9z1osq _chtc1wug _17xwygwz _vuss1ejb _1b6rbfng _12rr1ssb _1x46ahaf _gltex683 _58geahaf"
                        ])
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.default), {
                        pictureProps: {
                            image: {
                                src: "https://wac-cdn.atlassian.com/dam/jcr:8ebe2a91-8722-4bb9-8b36-07b0177bdf88/Premium%20Cloud%20module%20image.svg?cdnVersion=ece",
                                alt: intl.formatMessage({
                                    id: "JiraSoftwareFeaturePageTemplate.security-scale.jsw-premium.image.alt",
                                    defaultMessage: "Atlassian Premium illustration"
                                })
                            }
                        },
                        headerType: "h2",
                        headerText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.security-scale.jsw-premium.header",
                            defaultMessage: "Jira Software Premium"
                        }),
                        bodyText: intl.formatMessage({
                            id: "JiraSoftwareFeaturePageTemplate.security-scale.jsw-premium.body",
                            defaultMessage: "Ensure your team and organization are ready to scale with 99.9% uptime SLAs, unlimited storage, 24x7 Premium Support, and more."
                        }),
                        ctaProps: {
                            primaryLinkProps: {
                                text: intl.formatMessage({
                                    id: "JiraSoftwareFeaturePageTemplate.security-scale.learn-more.link",
                                    defaultMessage: "Learn more"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("/software/jira/premium"),
                                dataEventProps: {
                                    "data-product-key": "jiraSoftwareFeature",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "cardSection",
                                    "data-event": "clicked",
                                    "data-label": intl.formatMessage({
                                        id: "JiraSoftwareFeaturePageTemplate.security-scale.learn-more.link",
                                        defaultMessage: "Learn more"
                                    }),
                                    "data-label-english": "Learn more"
                                }
                            }
                        },
                        className: (0, $esG4f.default)([
                            "_ca0qidpf _u5f37vkz _n3td7vkz _19bv7vkz _1bsb1osq _5j9z1osq _chtc1wug _17xwygwz _vuss1ejb _1b6rbfng _12rr1ssb _1x46ahaf _gltex683 _58geahaf"
                        ])
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _ca0qidpf _u5f37vkz _n3tdidpf _19bv7vkz _gltex683 _1tnt1ylp"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_bfhk1hxd _1e0c1txw _2lx21bp4 _7cca15wb _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _oqiczwfg _1rmj1tcg _cjbtckbl _pnmbzwfg"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c11p5 _ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _yv0e3ufk _1da71crj _oqicn7od _1rmjn7od _cjbtn7od _pnmbn7od _40tu7vkz _1rqt1crj"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_s22w1j2z _18eo1j2z"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $j9l4D.Icon), {
                                                name: "securitycheckmark",
                                                size: "medium"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                                    className: (0, $esG4f.default)([
                                                        "_syazygwz _1wyb1k92 _k48pbfng _vwz43ei5 _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _1s181k8s"
                                                    ]),
                                                    children: intl.formatMessage({
                                                        id: "JiraSoftwareFeaturePageTemplate.security-scale.privacy.header",
                                                        defaultMessage: "Privacy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_vwz419ii"
                                                    ]),
                                                    children: intl.formatMessage({
                                                        id: "JiraSoftwareFeaturePageTemplate.security-scale.privacy.body",
                                                        defaultMessage: "Investments in <Link>GDPR and Privacy Shield</Link> ensure all data is handled with care."
                                                    }, {
                                                        Link: (node)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                                type: "inline",
                                                                bgColor: "bgWhite",
                                                                href: (0, $3FBn4.useLocalizedHref)("/trust/privacy"),
                                                                text: node,
                                                                dataEventProps: {
                                                                    "data-product-key": "jiraSoftwareFeature",
                                                                    "data-event-component": "linkButton",
                                                                    "data-event-container": "cardSection",
                                                                    "data-event": "clicked",
                                                                    "data-label": intl.formatMessage({
                                                                        id: "JiraSoftwareFeaturePageTemplate.security-scale.privacy.body.link",
                                                                        defaultMessage: "GDPR and Privacy Shield"
                                                                    }),
                                                                    "data-label-english": "GDPR and Privacy Shield"
                                                                }
                                                            })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c11p5 _ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _yv0e3ufk _1da71crj _oqicn7od _1rmjn7od _cjbtn7od _pnmbn7od _40tu7vkz _1rqt1crj"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_s22w1j2z _18eo1j2z"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $j9l4D.Icon), {
                                                name: "id",
                                                size: "medium"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: "text-section",
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                                    className: (0, $esG4f.default)([
                                                        "_syazygwz _1wyb1k92 _k48pbfng _vwz43ei5 _19pkn7od _2hwxn7od _otyrn7od _18u0n7od _1s181k8s"
                                                    ]),
                                                    children: intl.formatMessage({
                                                        id: "JiraSoftwareFeaturePageTemplate.security-scale.security-compliance.header",
                                                        defaultMessage: "Security and Compliance"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_vwz419ii"
                                                    ]),
                                                    children: intl.formatMessage({
                                                        id: "JiraSoftwareFeaturePageTemplate.security-scale.security-compliance.body",
                                                        defaultMessage: "Rest easy with Atlassian\u2019s world-class <Link1>security</Link1> and <Link2>compliance</Link2>."
                                                    }, {
                                                        Link1: (node)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                                type: "inline",
                                                                bgColor: "bgWhite",
                                                                href: (0, $3FBn4.useLocalizedHref)("/software/jira/security"),
                                                                text: node,
                                                                dataEventProps: {
                                                                    "data-product-key": "jiraSoftwareFeature",
                                                                    "data-event-component": "linkButton",
                                                                    "data-event-container": "cardSection",
                                                                    "data-event": "clicked",
                                                                    "data-label": intl.formatMessage({
                                                                        id: "JiraSoftwareFeaturePageTemplate.security-scale.security-compliance.security.link",
                                                                        defaultMessage: "security"
                                                                    }),
                                                                    "data-label-english": "security"
                                                                }
                                                            }),
                                                        Link2: (node)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                                type: "inline",
                                                                bgColor: "bgWhite",
                                                                href: (0, $3FBn4.useLocalizedHref)("/trust/compliance"),
                                                                text: node,
                                                                dataEventProps: {
                                                                    "data-product-key": "jiraSoftwareFeature",
                                                                    "data-event-component": "linkButton",
                                                                    "data-event-container": "cardSection",
                                                                    "data-event": "clicked",
                                                                    "data-label": intl.formatMessage({
                                                                        id: "JiraSoftwareFeaturePageTemplate.security-scale.security-compliance.compliance.link",
                                                                        defaultMessage: "compliance"
                                                                    }),
                                                                    "data-label-english": "compliance"
                                                                }
                                                            })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("8TCRB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $766fb4a210f04b0a$export$2e2bcd8739ae039; });
/* social-proof.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $2pEWv = parcelRequire("2pEWv");
const $766fb4a210f04b0a$var$inlineLogosProp = [
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:0f7f3935-7ef2-410c-ada8-0dc5e1d7dbf7/logo-square%201.svg",
        alt: "Square",
        width: "175px"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:f48ddf79-0d0d-46b2-98de-7c76ca00d467/logo-ebay%201.svg",
        alt: "ebay",
        width: "119px"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:428e0f0e-5159-4e06-b33b-e701bfb9836f/logo-visa%201.svg",
        alt: "Visa",
        width: "100px"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:1959f97f-9732-430c-8472-d66e620d544d/logo-cisco%201.svg",
        alt: "Cisco",
        width: "107px"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:d0b8a591-bb0f-45c6-95e5-7b7fa18eb1fd/logo-pfizer%201.svg",
        alt: "Pfizer",
        width: "108px"
    }
];
const $766fb4a210f04b0a$var$patternLogosJiraFeaturesPageStyle = null;
const $766fb4a210f04b0a$var$SocialProof = ()=>{
    const intl = (0, $f6qj2.default)();
    const patternLogoBodyText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageTemplate.socialProof.headerText",
        defaultMessage: "Trusted by over 100,000 customers worldwide"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_ca0q7vkz _u5f3idpf _n3td7vkz _19bvidpf _kqswh2mm _1ul91osq"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2pEWv.PatternLogos), {
                headerText: patternLogoBodyText,
                inlineLogos: $766fb4a210f04b0a$var$inlineLogosProp,
                className: (0, $esG4f.default)([
                    "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _z5uk7vkz _1boa7vkz _16it7vkz _ad5c7vkz _1j2u1h6o _17xwvwuj _vussoqnp _wg8ct94y _18m2cs5v _sab9angw _1b6r1nn1 _j4oxidpf _npe41q9y _slcnusvi _3vz07vkz _gkn87vkz _1vbc7vkz _10e87vkz _19i01txw _rf0b1g80 _r6wszwfg _18eb1ylp _1rx11h6o _1dnz1g1g _w8b9vrvc _9gf31h6o _18m21wug _o9ht1wug _pcm31wug _1ryj1wug _1h4o4xhq _1xozidpf _ym9h1wug _1nowidpf _ukb81wug _17hc1q9y _1kxwyfq0 _1vw7glyw _1tgj1osq"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ca0q16xe _u5f31gpt _n3td1gpt _19bv1gpt"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                    className: (0, $esG4f.default)([
                        "_4t3iyh40 _1h6dj1oc _bfhkj1oc _1bsb1osq _19itidpf _1gun1fra _19pkidpf _2hwx1wug _otyridpf _18u01wug _1rfm1osq _12rr4xhq _glte1ssb"
                    ])
                })
            })
        ]
    });
};
const $766fb4a210f04b0a$var$containerStyles = null;
const $766fb4a210f04b0a$var$dividerStyles = null;
const $766fb4a210f04b0a$var$divider = null;
var $766fb4a210f04b0a$export$2e2bcd8739ae039 = $766fb4a210f04b0a$var$SocialProof;

});


parcelRegister("fLHev", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareFeaturesPageTemplate", function () { return $b148c80c49866ee7$export$eda29bf8e53b5034; });
/* jira-software-features-page-v2.template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $kex29 = parcelRequire("kex29");

var $dJVgs = parcelRequire("dJVgs");

var $gAJUc = parcelRequire("gAJUc");

var $yOuGR = parcelRequire("yOuGR");

var $k40Kw = parcelRequire("k40Kw");

var $383oO = parcelRequire("383oO");

var $7IqCa = parcelRequire("7IqCa");

var $4OMsc = parcelRequire("4OMsc");

var $h03Vd = parcelRequire("h03Vd");

var $5OR9G = parcelRequire("5OR9G");

var $dnFkf = parcelRequire("dnFkf");

var $6V1Wm = parcelRequire("6V1Wm");

var $kYPcD = parcelRequire("kYPcD");

var $KxTXe = parcelRequire("KxTXe");
const $b148c80c49866ee7$var$cardsCSS = null;
const $b148c80c49866ee7$export$eda29bf8e53b5034 = ()=>{
    const showGwp7999JiraFeaturesUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7999JiraFeatures);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJVgs.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)("main", {
                id: "content",
                className: (0, $esG4f.default)([
                    "_1a331cd0 _kungiti9",
                    showGwp7999JiraFeaturesUpdates ? "gwp7999-jira-features-updates" : ""
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dnFkf.HeroSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $KxTXe.TabsSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7IqCa.PlanSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $h03Vd.TrackSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $383oO.LaunchSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $4OMsc.ReportSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $yOuGR.AISection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $kYPcD.ManageSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6V1Wm.IntegrationsSection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $k40Kw.CommunitySection), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5OR9G.FinalCTASection), {})
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("yOuGR", function(module, exports) {

$parcel$export(module.exports, "AISection", function () { return $9e8c67261cce7ffb$export$f5cfdae51cfc6704; });
/* ai.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $10R19 = parcelRequire("10R19");
const $9e8c67261cce7ffb$var$ArrowLeft = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "57",
        height: "19",
        viewBox: "0 0 57 19",
        fill: "none",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M47.5975 10.9419C46.8433 10.6448 46.1387 10.6263 45.439 10.5798C44.6789 10.5288 43.9461 10.6263 43.2126 10.8445C42.5674 11.0394 41.8906 11.0301 41.2469 10.9002C40.0427 10.6541 38.8418 10.7191 37.6313 10.8398C36.8754 10.9141 36.1057 10.9559 35.3502 10.9187C34.8265 10.8909 34.3128 10.7005 33.771 10.5798C33.5183 11.0951 33.05 11.123 32.5499 10.993C31.5174 10.7237 30.4881 10.7609 29.4399 10.8909C28.8694 10.9605 28.2902 10.8862 27.7818 10.5659C27.717 10.5288 27.6383 10.5148 27.5642 10.4963C27.14 11.0116 26.5836 11.0394 25.9952 10.9698C25.05 10.863 24.1001 10.7748 23.1549 10.668C22.5155 10.5938 21.8762 10.5056 21.2369 10.422C20.6022 10.3338 19.9864 10.1759 19.3271 10.4034C18.5099 10.6866 17.6482 10.5705 16.8001 10.5241C15.8315 10.4684 14.8633 10.3199 13.9036 10.3524C12.2623 10.4034 10.6311 10.2827 8.99497 10.227C8.21167 10.1992 7.42824 10.1992 6.64972 10.1388C5.8573 10.0785 5.06505 9.98096 4.28215 9.8649C3.44828 9.7442 2.6146 9.58171 1.78549 9.43315C1.24818 9.34031 0.906913 8.95034 0.630633 8.54181C0.552356 8.42575 0.697626 8.08221 0.828186 7.91508C1.23853 7.38584 1.80078 7.09337 2.46423 6.97267C3.95353 6.69876 5.45586 6.6152 6.95788 6.60127C8.30693 6.58734 9.65548 6.68019 10.9994 6.77768C12.5518 6.88446 14.1047 6.89839 15.6625 6.86125C16.8772 6.82875 18.0961 6.87982 19.3107 6.87053C20.4465 6.86589 21.5824 6.82411 22.7228 6.81482C23.9838 6.80554 25.2447 6.79161 26.5101 6.81482C28.304 6.84268 30.0931 6.90767 31.8869 6.94017C33.1616 6.96338 34.4364 6.98195 35.7121 6.77304C36.4358 6.65234 37.1958 6.71733 37.9326 6.77304C38.9938 6.85196 40.0465 6.77304 41.1037 6.71733C42.3927 6.6477 43.6817 6.57342 44.9754 6.50842C45.3463 6.48985 45.7171 6.50842 46.088 6.48985C46.19 6.48985 46.2923 6.4295 46.3944 6.40165C46.3438 6.3088 46.3166 6.17881 46.238 6.12774C45.7712 5.82134 45.2904 5.5428 44.8236 5.2364C43.5849 4.41933 42.3463 3.60226 41.1123 2.77591C40.6363 2.45558 40.3326 1.97741 40.0148 1.51317C39.8214 1.22998 39.9385 0.965363 40.0601 0.723957C40.1771 0.491836 40.2388 0.176151 40.5635 0.115799C40.7862 0.0740171 41.009 0.0322353 41.2362 0.0136655C42.3631 -0.0838255 43.4093 0.23186 44.446 0.607896C45.1865 0.877157 45.9175 1.17892 46.6674 1.42961C46.9821 1.53638 47.1853 1.71279 47.3416 1.99134C47.452 2.18632 47.5482 2.43237 47.8415 2.15383C47.9719 2.03312 48.1479 2.05169 48.2956 2.20489C48.5125 2.42773 48.7619 2.62735 48.9787 2.85483C49.1263 3.01267 49.2792 3.04053 49.4924 3.03589C50.2946 3.00339 50.9606 3.333 51.4771 3.93188C51.8091 4.3172 52.2252 4.5586 52.6834 4.70716C53.2158 4.87893 53.7014 5.12034 54.103 5.48709C54.8417 6.16024 55.5477 6.86589 56.2491 7.57618C56.549 7.88258 56.5415 8.52324 56.271 8.87142C55.7861 9.49815 55.278 10.1017 54.8069 10.7377C54.555 11.0812 54.3678 11.4758 54.139 11.8426C54.0456 11.9911 53.952 12.1861 53.808 12.2511C53.2459 12.5111 52.9145 12.9985 52.5185 13.4349C52.3555 13.616 52.183 13.8156 51.9739 13.927C51.2954 14.2938 50.6078 14.642 49.9064 14.9576C49.702 15.0505 49.4334 14.9855 49.1968 15.0134C49.0902 15.0273 48.9324 15.0644 48.8949 15.1387C48.5674 15.8026 48.0141 16.1693 47.3183 16.2807C46.2559 16.4525 45.285 16.8982 44.2775 17.2371C43.1168 17.627 41.9562 18.0124 40.8 18.4209C39.9086 18.7366 38.9945 18.913 38.0578 18.9873C37.659 19.0198 37.3491 18.8526 37.1744 18.5509C36.7973 17.887 36.723 17.9102 37.1433 17.2324C37.2227 17.1024 37.3159 16.9817 37.3768 16.8425C37.6111 16.2947 38.1124 16.1461 38.6002 15.9279C39.4363 15.5565 40.2495 15.1341 41.058 14.707C42.1175 14.1452 43.1586 13.5556 44.2088 12.9846C44.7758 12.6736 45.3565 12.395 45.9097 12.0654C46.4628 11.7358 46.9883 11.3644 47.5881 10.9698L47.5975 10.9419Z",
            fill: "currentcolor"
        })
    });
const $9e8c67261cce7ffb$var$ArrowRight = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "63",
        height: "22",
        viewBox: "0 0 63 22",
        fill: "none",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M52.8512 9.42084C52.0061 9.75593 51.2171 9.77688 50.4335 9.82924C49.5823 9.88683 48.7618 9.77688 47.9409 9.53079C47.2187 9.31089 46.4608 9.32136 45.7397 9.46796C44.391 9.74546 43.0463 9.67216 41.691 9.53603C40.8446 9.45225 39.9828 9.40513 39.1368 9.44702C38.5503 9.47843 37.9748 9.6931 37.3679 9.82924C37.0858 9.24806 36.5614 9.21664 36.0012 9.36324C34.8446 9.66692 33.692 9.62504 32.5184 9.47843C31.8797 9.3999 31.2311 9.48367 30.6612 9.84494C30.5887 9.88683 30.5005 9.90254 30.4175 9.92348C29.9433 9.3423 29.3203 9.31089 28.6613 9.38942C27.6027 9.50985 26.5389 9.60933 25.4803 9.72975C24.7642 9.81353 24.0482 9.91301 23.3321 10.0073C22.6213 10.1067 21.9314 10.2848 21.1935 10.0282C20.2789 9.70881 19.3138 9.83971 18.364 9.89207C17.2793 9.9549 16.1949 10.1224 15.1203 10.0858C13.2825 10.0282 11.4557 10.1643 9.62351 10.2272C8.74634 10.2586 7.86907 10.2586 6.9972 10.3266C6.10976 10.3947 5.22245 10.5047 4.34559 10.6356C3.41164 10.7717 2.47784 10.9549 1.54918 11.1225C0.947357 11.2272 0.564592 11.667 0.254565 12.1278C0.166725 12.2587 0.328847 12.6461 0.474778 12.8346C0.933433 13.4315 1.56256 13.7614 2.30529 13.8975C3.97254 14.2064 5.6547 14.3007 7.33661 14.3164C8.84723 14.3321 10.3575 14.2274 11.8625 14.1174C13.6011 13.997 15.34 13.9813 17.0843 14.0232C18.4444 14.0598 19.8095 14.0022 21.1695 14.0127C22.4413 14.0179 23.7133 14.065 24.9903 14.0755C26.4022 14.086 27.8142 14.1017 29.2313 14.0755C31.2401 14.0441 33.2435 13.9708 35.2523 13.9341C36.6797 13.908 38.1072 13.887 39.5354 14.1226C40.3456 14.2588 41.1967 14.1855 42.0219 14.1226C43.2103 14.0336 44.389 14.1226 45.5727 14.1855C47.016 14.264 48.4594 14.3478 49.9079 14.4211C50.3232 14.442 50.7384 14.4211 51.1538 14.442C51.268 14.442 51.3824 14.5101 51.4967 14.5415C51.4399 14.6462 51.4092 14.7928 51.3211 14.8504C50.7979 15.196 50.259 15.5101 49.7358 15.8557C48.3475 16.7772 46.9592 17.6987 45.5761 18.6307C45.0426 18.992 44.7016 19.5313 44.3451 20.0549C44.1281 20.3743 44.2588 20.6727 44.3946 20.945C44.5251 21.2068 44.5937 21.5628 44.9573 21.6309C45.2066 21.678 45.4559 21.7251 45.7104 21.7461C46.9721 21.856 48.1441 21.5 49.3056 21.0759C50.1352 20.7722 50.9543 20.4319 51.7944 20.1491C52.147 20.0287 52.3748 19.8297 52.5503 19.5156C52.6742 19.2957 52.7823 19.0182 53.1103 19.3323C53.2561 19.4685 53.4533 19.4475 53.6189 19.2747C53.8621 19.0234 54.1417 18.7983 54.3849 18.5417C54.5504 18.3637 54.7216 18.3323 54.9604 18.3375C55.8586 18.3742 56.6049 18.0024 57.1842 17.327C57.5566 16.8924 58.0229 16.6201 58.5363 16.4526C59.1327 16.2589 59.6769 15.9866 60.1272 15.573C60.9554 14.8138 61.7472 14.0179 62.5337 13.2168C62.87 12.8713 62.8626 12.1487 62.5603 11.756C62.0183 11.0492 61.4503 10.3685 60.9238 9.65122C60.6423 9.26376 60.4333 8.81872 60.1776 8.40508C60.0733 8.23753 59.9688 8.01763 59.8077 7.94433C59.1786 7.65112 58.8084 7.10135 58.3656 6.60918C58.1833 6.40498 57.9905 6.17984 57.7566 6.05418C56.9974 5.64055 56.2279 5.24786 55.443 4.89182C55.2143 4.7871 54.9134 4.86041 54.6486 4.82899C54.5291 4.81328 54.3525 4.7714 54.3107 4.68762C53.945 3.9389 53.326 3.52526 52.547 3.3996C51.3577 3.20588 50.2712 2.70323 49.1436 2.32101C47.8445 1.8812 46.5454 1.44663 45.2514 0.985871C44.2537 0.629832 43.2304 0.430869 42.1816 0.347095C41.7351 0.310444 41.3879 0.498936 41.1917 0.839267C40.7683 1.588 40.6852 1.56182 41.1547 2.32625C41.2434 2.47286 41.3477 2.60899 41.4157 2.76606C41.6771 3.38389 42.2383 3.55144 42.7841 3.79753C43.7197 4.2164 44.6296 4.69286 45.5344 5.17456C46.7199 5.8081 47.8847 6.47305 49.0598 7.11706C49.6942 7.46786 50.3441 7.78202 50.9629 8.15376C51.5818 8.52551 52.1697 8.94438 52.8407 9.38942L52.8512 9.42084Z",
            fill: "currentcolor"
        })
    });
const $9e8c67261cce7ffb$var$AiIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 44 43",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M42.5503 18.9399H33.6003V23.9399H42.5503V18.9399Z",
                fill: "url(#paint0_linear_8535_22452)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24.4253 0.814941H19.4253V9.76494H24.4253V0.814941Z",
                fill: "url(#paint1_linear_8535_22452)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.2503 18.9399H1.30029V23.9399H10.2503V18.9399Z",
                fill: "url(#paint2_linear_8535_22452)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24.4253 33.115H19.4253V42.065H24.4253V33.115Z",
                fill: "url(#paint3_linear_8535_22452)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.8798 25.8055L26.2913 29.394L39.5053 42.6081L43.0939 39.0195L29.8798 25.8055Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M39.5054 0.268255L26.2937 13.4846L29.8829 17.0726L43.0946 3.8562L39.5054 0.268255Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M4.3393 0.268122L0.750732 3.85669L13.9648 17.0707L17.5534 13.4822L4.3393 0.268122Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.9618 25.7963L0.75 39.0127L4.33919 42.6006L17.5509 29.3843L13.9618 25.7963Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint0_linear_8535_22452",
                        x1: "33.6003",
                        y1: "21.4399",
                        x2: "42.5503",
                        y2: "21.4399",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.8",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint1_linear_8535_22452",
                        x1: "21.9253",
                        y1: "9.76494",
                        x2: "21.9253",
                        y2: "0.814941",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.8",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint2_linear_8535_22452",
                        x1: "10.2503",
                        y1: "-8.56007",
                        x2: "1.30029",
                        y2: "-8.56007",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.8",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint3_linear_8535_22452",
                        x1: "21.9253",
                        y1: "33.115",
                        x2: "21.9253",
                        y2: "42.065",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.8",
                                stopColor: "#2684FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $9e8c67261cce7ffb$var$sectionStyles = null;
const $9e8c67261cce7ffb$var$containerStyles = null;
const $9e8c67261cce7ffb$var$arrowsStyles = null;
const $9e8c67261cce7ffb$var$arrowsLeftStyles = null;
const $9e8c67261cce7ffb$var$arrowsRightStyles = null;
const $9e8c67261cce7ffb$var$contentContainerStyles = null;
const $9e8c67261cce7ffb$var$imageContainerStyles = null;
const $9e8c67261cce7ffb$var$imageStyles = null;
const $9e8c67261cce7ffb$export$9a489f073b25beec = ()=>{
    const showGwp7999JiraFeaturesUpdates = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7999JiraFeatures);
    const videoRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        const video = videoRef.current;
        if (!video || !showGwp7999JiraFeaturesUpdates) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) video.play().catch(()=>{});
            });
        }, {
            threshold: 0.5
        });
        observer.observe(video);
        return ()=>{
            observer.disconnect();
        };
    }, [
        showGwp7999JiraFeaturesUpdates
    ]);
    const localizedImage = (0, $10R19.useLocalizedImage)("artificialIntelligenceImage");
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_p12f1nxv _19pkzwfg _2hwxidpf _otyridpf _18u0idpf _vwz4idpf _b8yq17ul"
        ]),
        children: showGwp7999JiraFeaturesUpdates ? /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
            ref: videoRef,
            playsInline: true,
            controls: true,
            muted: true,
            className: (0, $esG4f.default)([
                "_1bsb1osq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ho7s02tnb11qo23023b240eh4467cm5i.mp4",
                    type: "video/mp4"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("track", {
                    kind: "captions",
                    srcLang: "en",
                    label: "English"
                })
            ]
        }) : /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            alt: "",
            src: localizedImage,
            loading: "lazy",
            className: (0, $esG4f.default)([
                "_1bsb1osq"
            ])
        })
    });
};
const $9e8c67261cce7ffb$var$ctaContainerStyles = null;
const $9e8c67261cce7ffb$export$f5cfdae51cfc6704 = ()=>{
    const intl = (0, $f6qj2.default)();
    const showGwp7999JiraFeaturesUpdates = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7999JiraFeatures);
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        className: (0, $esG4f.default)([
            "_11q7ki2g _oqicckbl _1rmjidpf _cjbtzwfg _pnmbidpf"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswh2mm _1e0c1txw _2lx21bp4 _4cvr1h6o _p12fhg2u _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qvbgk _u5f3idpf _n3tdidpf _19bvidpf _1pbyidpf _bfhk6kkz _4ap3n7od _1kt9b3bt _1cs8stnw _cfu1glyw _dsq4glyw _1tesidpf _tgsmv3js _1rus6kkz _1g0v1mrw _1twg1ule"
                    ]),
                    style: {
                        "--_1qa6cp7": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue200"))
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_kqswstnw _1pby1mrw _lcxvglyw _1bsbauwl _p12f1git _4t3i1to9 _1r041qy5 _t9eczr6s _1e0cglyw _dm251ule"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_kqswstnw _1bsb1dhz _4t3i1to9 _1r041wqi _jutrstnw _19f91hlo _skdl1has _1wkx1wxw _1m7mjk2v _10qv161l _kdwsjyd4 _1frfjk2v _zvkf45j5 _wh7glf3p _1yu31w2a _pfala0wv _9mdlrre3 _11bk1hlo _1csf1rns _162b1382"
                                    ]),
                                    style: {
                                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                        "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700")),
                                        "--_e0fbx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.purple500"))
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$ArrowLeft, {}),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$ArrowLeft, {}),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$ArrowLeft, {}),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$ArrowLeft, {}),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$ArrowLeft, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                    className: (0, $esG4f.default)([
                                        "_kqswstnw _1bsb1w8k _4t3i1to9 _1r041e30 _jutrstnw _19f91hlo _skdlgnmi _1wkx1uyi _1m7mjk2v _10qv1t42 _kdws1578 _1frfjk2v _zvkfrjm0 _wh7g1uyi _1yu31ddo _pfal1tih _9mdlzzka"
                                    ]),
                                    style: {
                                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                        "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700")),
                                        "--_236ja5": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.lime500"))
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$ArrowRight, {}),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$ArrowRight, {}),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$ArrowRight, {}),
                                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$ArrowRight, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulpftgi _y3gn1h6o _p12f1nxv _1c58idpf _1fexidpf _1mh0idpf _av1ridpf _6y0kidpf _14nridpf _rv9yidpf _1s48idpf _b8yq17ul"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$var$AiIcon, {
                                    size: "42"
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                    className: "h2",
                                    children: showGwp7999JiraFeaturesUpdates ? intl.formatMessage({
                                        id: "JiraSoftwareFeaturesPageV2.AISection.Gwp7999Header",
                                        defaultMessage: "Let Rovo AI handle the busywork of project management"
                                    }) : intl.formatMessage({
                                        id: "JiraSoftwareFeaturesPageV2.AISection.Header",
                                        defaultMessage: "Get work across the finish line faster with Atlassian Intelligence"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: "body",
                                    children: showGwp7999JiraFeaturesUpdates ? intl.formatMessage({
                                        id: "JiraSoftwareFeaturesPageV2.AISection.Gwp7999Description",
                                        defaultMessage: "Get organized faster, make decisions with complete context, and keep every team in sync so you can focus on the work that matters."
                                    }) : intl.formatMessage({
                                        id: "JiraSoftwareFeaturesPageV2.AISection.Description",
                                        defaultMessage: "Use AI to accelerate productivity, improve collaboration, and make the most of your data to drive forward the work that matters most."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($9e8c67261cce7ffb$export$9a489f073b25beec, {})
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _ca0qzwfg _u5f3idpf _n3tdzwfg _19bvidpf _bfhk6kkz _4ap3n7od"
                    ]),
                    style: {
                        "--_1qa6cp7": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue200"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                        variant: "secondary",
                        color: "black",
                        href: (0, $3FBn4.useLocalizedHref)("/software/jira/ai"),
                        dataEventProps: {
                            "data-product-key": "jiraSoftware",
                            "data-event": "clicked",
                            "data-event-container": "jiraFeaturesAiSection",
                            "data-event-component": "linkButton"
                        },
                        children: showGwp7999JiraFeaturesUpdates ? intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.AISection.Gwp7999Cta",
                            defaultMessage: "Explore Rovo AI in Jira"
                        }) : intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.AISection.Cta",
                            defaultMessage: "Explore Atlassian Intelligence"
                        })
                    })
                })
            ]
        })
    });
};

});

parcelRegister("k40Kw", function(module, exports) {

$parcel$export(module.exports, "CommunitySection", function () { return $b6254839d6a9e852$export$fb5a1f1ec82b2674; });
/* community.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $ix9oc = parcelRequire("ix9oc");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
const $b6254839d6a9e852$var$heroContainerStyles = null;
const $b6254839d6a9e852$var$imageContainerStyles = null;
const $b6254839d6a9e852$var$imageStyles = null;
const $b6254839d6a9e852$export$9d9b32209662bd46 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            alt: "",
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-feature-v2-community-globe.webp",
            loading: "lazy",
            className: (0, $esG4f.default)([
                "_1bsbi4q4 _4t3i1juu _16jlidpf _1o9zidpf _i0dl1wug _kzvi1txw _19vu1h6o _1os2kb7n _8os5kb7n _16xtf1ug _12rrn7od _1vkhn7od _14b51feq _1xlo1dhz"
            ])
        })
    });
};
const $b6254839d6a9e852$export$fb5a1f1ec82b2674 = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.Header",
        defaultMessage: "Connect with our 4.5M+ community members"
    });
    const descriptionText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.Description",
        defaultMessage: "Ask questions, give product feedback, and connect with our team and other users to learn best practices. From events and forums, to curated learning paths, you\u2019re never alone when you are an Atlassian customer."
    });
    const buttonText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CommunityGraphic.Cta",
        defaultMessage: "Check out community"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "hero",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1itk12ya"
            ]),
            style: {
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_bfhkdoyu _1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _1bsb1osq _p12f17kt _19pkidpf _2hwx1wug _otyridpf _18u01wug _zulpzwfg _kqswh2mm _ca0q1oqx _u5f3idpf _n3td7ynd _19bvidpf _19itidpf _mkrz15bb _tl28vbgk _axwi1wqb _1hwcvbgk _sp8t1wqb _1gde1bp4 _1kmxvbgk _1ggmzwfg _1ykzpzf8 _1maezwfg _1p94idpf _d47fidpf _1qv9idpf _d600idpf _1lnb1osq _1t7v1feq _rpgfkb7n _eivrkb7n _qbuof1ug _1pmeftgi _1r02cd5j _1m151tcg _161y4jg8 _1fdl1fw0 _1is11ul9 _v280nl7k _lr5t1osq _1pa81feq _1k67idpf _1qp1idpf _1jrpidpf _19ehidpf _1g2pqslr _1q2n1f4h _yhtsgktf _7t621ou6 _140l4jg8 _s0881nn1 _1i4z1tcg _1owlidpf _1pqeidpf _1l3yidpf _7s4pidpf _ftgm1j6v _sf191osq _12ps1feq _1xcocd5j _1mx7ftgi _phqogrf3 _nlorgrf3 _1qvngrf3 _19qpgrf3 _1f7t1h6o _1cxy1h6o"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.default), {
                        headerText: headerText,
                        headerType: "h2",
                        bodyText: descriptionText,
                        className: "textContainerStyles",
                        ctaProps: {
                            primaryLinkProps: {
                                text: buttonText,
                                href: (0, $3FBn4.useLocalizedHref)("/community"),
                                className: "jiraLinkStyling",
                                dataEventProps: {
                                    "data-product-key": "jiraSoftware",
                                    "data-event": "clicked",
                                    "data-event-container": "communityCtaSection",
                                    "data-event-component": "link"
                                },
                                bgColor: "bgBlackBlue"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($b6254839d6a9e852$export$9d9b32209662bd46, {})
                ]
            })
        })
    });
};

});

parcelRegister("7IqCa", function(module, exports) {

$parcel$export(module.exports, "PlanSection", function () { return $cd9a64033ced17c5$export$e54a275ff26e0fe3; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dTlTl = parcelRequire("dTlTl");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $10R19 = parcelRequire("10R19");

var $6MUoN = parcelRequire("6MUoN");
const $cd9a64033ced17c5$var$ArrowUpRightIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.3995 3.61928L2.89918 24.1196L0 21.2204L20.5003 0.720098L23.3995 3.61928Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.8999 4.21969L10.3533 4.21969V0.119629L24 0.119629V13.7664H19.8999V4.21969Z",
                fill: "#1868DB"
            })
        ]
    });
const $cd9a64033ced17c5$var$CheckmarkIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 0.119629H17.6V17.7196H0V0.119629ZM14.7313 6.05093L7.19992 13.5823L2.86855 9.25093L5.1313 6.98818L7.19992 9.05681L12.4686 3.78818L14.7313 6.05093Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.8 7.31963V20.1196H8V23.3196H24V7.31963H20.8Z",
                fill: "#1868DB"
            })
        ]
    });
const $cd9a64033ced17c5$var$ListIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 6.5482L0 6.5482V3.11963L24 3.11963V6.5482Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.2857 21.9768H7.71429V18.5482H16.2857V21.9768Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M4.28571 14.2625L19.7143 14.2625V10.8339L4.28571 10.8339L4.28571 14.2625Z",
                fill: "#1868DB"
            })
        ]
    });
const $cd9a64033ced17c5$var$WorkflowIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M16.4284 0.119629H7.85693V6.97677H10.4286V10.4053H3.57143V17.2625H1V24.1196H9.57143V17.2625H7V13.8339H17.2857V17.2625H14.7143V24.1196H23.2857V17.2625H20.7143V10.4053H13.8571V6.97677H16.4284V0.119629Z",
            fill: "#1868DB"
        })
    });
const $cd9a64033ced17c5$export$e54a275ff26e0fe3 = ()=>{
    const intl = (0, $f6qj2.default)();
    const showGwp7999JiraFeaturesUpdates = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7999JiraFeatures);
    const planListViewImage = (0, $10R19.useLocalizedImage)("planListViewImage");
    const planCalendarImage = (0, $10R19.useLocalizedImage)("planCalendarImage");
    const planSprintsBacklogImage = (0, $10R19.useLocalizedImage)("planSprintsBacklogImage");
    const planTimelineImage = (0, $10R19.useLocalizedImage)("planTimelineImage");
    if (showGwp7999JiraFeaturesUpdates) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6MUoN.FeaturedInfoSection), {
            variant: (0, $6MUoN.PLAN),
            eyebrow: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageV2.TabsSection.Plan.Label",
                defaultMessage: "Plan"
            }),
            header: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Header",
                defaultMessage: "Kick-off your next project"
            }),
            description: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Description",
                defaultMessage: "Prioritize high-impact work, break down big projects into clear tasks, and cultivate ownership."
            }),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                    image: {
                        image: {
                            src: (0, $6MUoN.FeaturedImages).planAlignWorkToGoals,
                            alt: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.AlignWork.Alt",
                                defaultMessage: "Tie work to goals in Jira"
                            })
                        }
                    },
                    Icon: $cd9a64033ced17c5$var$ArrowUpRightIcon,
                    title: intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.AlignWork.Header",
                        defaultMessage: "Align work to goals"
                    }),
                    body: intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.AlignWork.Description",
                        defaultMessage: "Focus on work that will deliver impact and find cross-functional partners working towards the same goal"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                    image: {
                        image: {
                            src: (0, $6MUoN.FeaturedImages).planPlanAndAssignWork,
                            alt: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.PlanAssign.Alt",
                                defaultMessage: "Plan and assign work to the right person in Jira"
                            })
                        }
                    },
                    Icon: $cd9a64033ced17c5$var$CheckmarkIcon,
                    title: intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.PlanAssign.Header",
                        defaultMessage: "Plan and Assign Work"
                    }),
                    body: intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.PlanAssign.Description",
                        defaultMessage: "Breakdown big ideas into actionable tasks and automatically assign them to the right person with Rovo AI."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                    image: {
                        image: {
                            src: (0, $6MUoN.FeaturedImages).planGetTheBigPicture,
                            alt: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.BigPicture.Alt",
                                defaultMessage: "3rd party integrations in Jira"
                            })
                        }
                    },
                    Icon: $cd9a64033ced17c5$var$ListIcon,
                    title: intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.BigPicture.Header",
                        defaultMessage: "Get the big picture"
                    }),
                    body: intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.BigPicture.Description",
                        defaultMessage: "Plan with all the context you need. Rovo AI connects relevant assets and rich data from Confluence, Figma, and your 3rd party apps to your work."
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                    image: {
                        image: {
                            src: (0, $6MUoN.FeaturedImages).planJumpstartWithExpertTemplates,
                            alt: intl.formatMessage({
                                id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.Templates.Alt",
                                defaultMessage: "Board view in Jira"
                            })
                        }
                    },
                    Icon: $cd9a64033ced17c5$var$WorkflowIcon,
                    title: intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.Templates.Header",
                        defaultMessage: "Jumpstart with expert templates"
                    }),
                    body: intl.formatMessage({
                        id: "JiraSoftwareFeaturesPageV2.Gwp7999PlanSection.Card.Templates.Description",
                        defaultMessage: "Start fast with pre-built and customizable templates for any project, from agile sprints to marketing campaigns."
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6MUoN.FeaturedInfoSection), {
        variant: (0, $6MUoN.PLAN),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.TabsSection.Plan.Label",
            defaultMessage: "Plan"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Header",
            defaultMessage: "Start your next project off right"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Description",
            defaultMessage: "Structure and align goals across teams, break work down into manageable tasks, and know who\u2019s working on what."
        }),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: planListViewImage,
                        alt: ""
                    }
                },
                Icon: $cd9a64033ced17c5$var$ArrowUpRightIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Card.ListView.Header",
                    defaultMessage: "List view"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Card.ListView.Description",
                    defaultMessage: "Swap out the spreadsheets. Organize work into a single list view and update, sort, and prioritize on the fly with in-line editing."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: planCalendarImage,
                        alt: ""
                    }
                },
                Icon: $cd9a64033ced17c5$var$CheckmarkIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Card.Calendar.Header",
                    defaultMessage: "Calendar"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Card.Calendar.Description",
                    defaultMessage: "Use Jira\u2019s calendar view to easily visualize work over time and teams to hit every deadline, together."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: planSprintsBacklogImage,
                        alt: ""
                    }
                },
                Icon: $cd9a64033ced17c5$var$ListIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Card.SprintsBacklog.Header",
                    defaultMessage: "Sprints & backlog"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Card.SprintsBacklog.Description",
                    defaultMessage: "Agile teams can utilize Jira\u2019s backlog to prioritize all their work, and tackle a subset of the work in their next sprint."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: planTimelineImage,
                        alt: ""
                    }
                },
                Icon: $cd9a64033ced17c5$var$WorkflowIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Card.Timeline.Header",
                    defaultMessage: "Timeline"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightPlanSection.Card.Timeline.Description",
                    defaultMessage: "See how all work rolls up to the big picture. Understand timing, duration, and dependencies in a single project or across multiple."
                })
            })
        ]
    });
};

});

parcelRegister("4OMsc", function(module, exports) {

$parcel$export(module.exports, "ReportSection", function () { return $1aa7d4808711a645$export$9dde7de4525aade1; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dTlTl = parcelRequire("dTlTl");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $10R19 = parcelRequire("10R19");

var $6MUoN = parcelRequire("6MUoN");
const $1aa7d4808711a645$var$BarChartIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.1429 0.518066V18.5181H23.1429V0.518066H17.1429Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 24.5181H23.1429V21.0895H0V24.5181Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 18.5181V9.08949H6L6 18.5181H0Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.57143 5.66092V18.5181H14.5714V5.66092L8.57143 5.66092Z",
                fill: "#1868DB"
            })
        ]
    });
const $1aa7d4808711a645$var$PauseIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 0.518066H7.86207V18.725H0V0.518066Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.3448 18.725V0.518066H18.2069V18.725H10.3448Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.6897 7.96634V21.2077H7.44828V24.5181H24V7.96634H20.6897Z",
                fill: "#1868DB"
            })
        ]
    });
const $1aa7d4808711a645$var$TargetIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 9.94669L8.2428e-07 0.518066L9.42863 0.518066V3.94663L3.42856 3.94663L3.42856 9.94669H0Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.1429 12.5181C17.1429 15.3584 14.8404 17.661 12 17.661C9.15973 17.661 6.8572 15.3584 6.8572 12.5181C6.8572 9.6778 9.15973 7.37528 12 7.37528C14.8404 7.37528 17.1429 9.6778 17.1429 12.5181Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 24.5181V15.0895H20.5714V21.0895H14.5715V24.5181H24Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M14.5715 0.518068L24 0.518068V9.94669H20.5714V3.94663H14.5715V0.518068Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.66478e-05 24.5181H9.42862L9.42862 21.0895H3.42865V15.0895H8.66478e-05V24.5181Z",
                fill: "#1868DB"
            })
        ]
    });
const $1aa7d4808711a645$var$LayoutIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M6.75 3.51807H0V10.2681L6.75 10.2681V3.51807Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9 3.51807V10.2681L24 10.2681V3.51807H9Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 12.5181L0 12.5181V21.5181H24V12.5181Z",
                fill: "#1868DB"
            })
        ]
    });
const $1aa7d4808711a645$export$9dde7de4525aade1 = ()=>{
    const intl = (0, $f6qj2.default)();
    const showGwp7999JiraFeaturesUpdates = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7999JiraFeatures);
    const reportPlanYourWorkImage = (0, $10R19.useLocalizedImage)("reportPlanYourWorkImage");
    const reportDuringYourProjectImage = (0, $10R19.useLocalizedImage)("reportDuringYourProjectImage");
    const reportWhenYouLaunchImage = (0, $10R19.useLocalizedImage)("reportWhenYouLaunchImage");
    const reportBringItAllTogetherImage = (0, $10R19.useLocalizedImage)("reportBringItAllTogetherImage");
    if (showGwp7999JiraFeaturesUpdates) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6MUoN.FeaturedInfoSection), {
        variant: (0, $6MUoN.REPORT),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.TabsSection.Report.Label",
            defaultMessage: "Report"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Header",
            defaultMessage: "Make better decisions, deliver stronger results"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Description",
            defaultMessage: "Out-of-the-box reports and Rovo AI turns your company's work history into insights you can act on\u2014so you can proactively make better decisions, faster."
        }),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).reportTrackYourProgressToGoals,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.TrackProgress.Alt",
                            defaultMessage: "Measure progress with Goals"
                        })
                    }
                },
                Icon: $1aa7d4808711a645$var$BarChartIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.TrackProgress.Header",
                    defaultMessage: "Track your progress to Goals"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.TrackProgress.Description",
                    defaultMessage: "Get visibility on your company's progress towards top priorities as projects advance"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).reportShareRealTimeUpdates,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.ShareUpdates.Alt",
                            defaultMessage: "Chat with Rovo AI for status updates"
                        })
                    }
                },
                Icon: $1aa7d4808711a645$var$PauseIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.ShareUpdates.Header",
                    defaultMessage: "Share real-time updates"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.ShareUpdates.Description",
                    defaultMessage: "Keep stakeholders up-to-date on the current status and use AI-agents to proactively identify risks as work items progress."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).reportUnderstandTeamPerformance,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.TeamPerformance.Alt",
                            defaultMessage: "Measure status in Jira"
                        })
                    }
                },
                Icon: $1aa7d4808711a645$var$TargetIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.TeamPerformance.Header",
                    defaultMessage: "Understand team performance"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.TeamPerformance.Description",
                    defaultMessage: "Keep work on track whether you're measuring engineering cycle time, burn down charts, or managing capacity."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).reportLearnAsYouDeliver,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.LearnDeliver.Alt",
                            defaultMessage: "Rovo AI analyzes themes across Jira work items"
                        })
                    }
                },
                Icon: $1aa7d4808711a645$var$LayoutIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.LearnDeliver.Header",
                    defaultMessage: "Learn as you deliver"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999ReportSection.Card.LearnDeliver.Description",
                    defaultMessage: "Use Rovo AI to identify trends to surface new opportunities and remove bottle necks."
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6MUoN.FeaturedInfoSection), {
        variant: (0, $6MUoN.REPORT),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.TabsSection.Report.Label",
            defaultMessage: "Report"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Header",
            defaultMessage: "Results, not roadblocks"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Description",
            defaultMessage: "Out-of-the-box reports, real-time dashboards, and contextual insights make data-driven decisions your team\u2019s new normal."
        }),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: reportPlanYourWorkImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.AsYouPlan.ImageAlt",
                            defaultMessage: "Team capacity planning in Jira"
                        })
                    }
                },
                Icon: $1aa7d4808711a645$var$BarChartIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.AsYouPlan.Header",
                    defaultMessage: "As you plan your work"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.AsYouPlan.Description",
                    defaultMessage: "Get a real-time view into the team\u2019s workload and balance the work to keep plans on track."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: reportDuringYourProjectImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.Project.ImageAlt",
                            defaultMessage: "Sprint progress contextual insight on the Jira board"
                        })
                    }
                },
                Icon: $1aa7d4808711a645$var$PauseIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.Project.Header",
                    defaultMessage: "During your project"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.Project.Description",
                    defaultMessage: "Stay on target to meet your goals with contextual insights right in the board view. Raise any blockers and troubleshoot concerns."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: reportWhenYouLaunchImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.Launch.ImageAlt",
                            defaultMessage: "Deployment insights"
                        })
                    }
                },
                Icon: $1aa7d4808711a645$var$TargetIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.Launch.Header",
                    defaultMessage: "When you launch"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.Launch.Description",
                    defaultMessage: "Create custom views to track tasks that support your go-to-market strategy, and optimize your delivery pipeline with deployment frequency and cycle time insights."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: reportBringItAllTogetherImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.Dashboards.ImageAlt",
                            defaultMessage: "Jira dashboard showing progress to goal"
                        })
                    }
                },
                Icon: $1aa7d4808711a645$var$LayoutIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.Dashboards.Header",
                    defaultMessage: "Bring it all together with dashboards"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightReportSection.Card.Dashboards.Description",
                    defaultMessage: "Track the metrics that matter most to your team. With dozens of built-in gadgets, easily customize dashboards for teams, stakeholders, and leadership."
                })
            })
        ]
    });
};

});

parcelRegister("h03Vd", function(module, exports) {

$parcel$export(module.exports, "TrackSection", function () { return $e5ec57a4eae656ec$export$5827ab3bf1f482ae; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dTlTl = parcelRequire("dTlTl");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $10R19 = parcelRequire("10R19");

var $6MUoN = parcelRequire("6MUoN");
const $e5ec57a4eae656ec$var$ChartIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M4.39796e-06 17.2286L4.39796e-06 0.518066L3.42857 0.518066L3.42857 13.2552L9.46269 7.55626L12.8571 10.9507L18.1468 5.6613L15.0126 5.6613L15.0126 2.23274L24 2.23274V11.2201H20.5714V8.08538L12.8571 15.7994L9.39442 12.3367L3.42857 17.9711L3.42857 21.0894H24V24.518H4.39796e-06L4.39796e-06 17.2364C-1.46609e-06 17.2338 -1.46588e-06 17.2312 4.39796e-06 17.2286Z",
            fill: "#1868DB"
        })
    });
const $e5ec57a4eae656ec$var$PieChartIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.8387 2.84065C4.85266 2.84065 0 7.6933 0 13.6794C0 19.6654 4.85266 24.5181 10.8387 24.5181C16.8248 24.5181 21.6774 19.6654 21.6774 13.6794H10.8387V2.84065Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 10.5826C24 5.0241 19.494 0.518066 13.9355 0.518066V10.5826L24 10.5826Z",
                fill: "#1868DB"
            })
        ]
    });
const $e5ec57a4eae656ec$var$BidirectionalArrowsIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24 6.85316L17.6648 13.1884L15.3759 10.8995L17.8037 8.47163H0.670364V5.2346H17.8036L15.3759 2.80687L17.6648 0.517944L24 6.85316Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M6.33525 24.518L0 18.1827L6.3353 11.8478L8.62417 14.1367L6.19649 16.5643H23.3297V19.8013H6.19645L8.62417 22.2291L6.33525 24.518Z",
                fill: "#1868DB"
            })
        ]
    });
const $e5ec57a4eae656ec$var$GroupIcon = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M6.41935 17.5502C6.41935 14.5572 8.84568 12.1308 11.8387 12.1308C14.8317 12.1308 17.2581 14.5572 17.2581 17.5502V24.5179H6.41935V17.5502Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.4839 5.16311C16.4839 7.72856 14.4042 9.80827 11.8387 9.80827C9.27326 9.80827 7.19355 7.72856 7.19355 5.16311C7.19355 2.59765 9.27326 0.517944 11.8387 0.517944C14.4042 0.517944 16.4839 2.59765 16.4839 5.16311Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.1124 9.71719C17.4097 9.77692 17.7173 9.80827 18.0323 9.80827C20.5977 9.80827 22.6774 7.72856 22.6774 5.16311C22.6774 2.59765 20.5977 0.517944 18.0323 0.517944C17.7173 0.517944 17.4097 0.549287 17.1124 0.609022C18.168 1.83032 18.8065 3.42215 18.8065 5.16311C18.8065 6.90406 18.168 8.49589 17.1124 9.71719Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M6.56506 0.609022C5.50947 1.83032 4.87097 3.42215 4.87097 5.16311C4.87097 6.90406 5.50946 8.49589 6.56506 9.71719C6.26772 9.77692 5.9601 9.80827 5.64516 9.80827C3.07971 9.80827 1 7.72856 1 5.16311C1 2.59765 3.07971 0.517944 5.64516 0.517944C5.9601 0.517944 6.26772 0.549287 6.56506 0.609022Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M6.30986 12.1308C4.94089 13.5273 4.09677 15.4402 4.09677 17.5502V24.5179H1V16.0018C1 13.8639 2.73309 12.1308 4.87097 12.1308H6.30986Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M19.5806 24.5179V17.5502C19.5806 15.4402 18.7365 13.5273 17.3676 12.1308H18.8065C20.9443 12.1308 22.6774 13.8639 22.6774 16.0018V24.5179H19.5806Z",
                fill: "#1868DB"
            })
        ]
    });
const $e5ec57a4eae656ec$export$5827ab3bf1f482ae = ()=>{
    const intl = (0, $f6qj2.default)();
    const showGwp7999JiraFeaturesUpdates = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7999JiraFeatures);
    const trackProjectBoardsImage = (0, $10R19.useLocalizedImage)("trackProjectBoardsImage");
    const trackTaskManagementImage = (0, $10R19.useLocalizedImage)("trackTaskManagementImage");
    const trackDependencyManagementImage = (0, $10R19.useLocalizedImage)("trackDependencyManagementImage");
    const trackGoalTrackingImage = (0, $10R19.useLocalizedImage)("trackGoalTrackingImage");
    if (showGwp7999JiraFeaturesUpdates) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6MUoN.FeaturedInfoSection), {
        variant: (0, $6MUoN.TRACK),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.TabsSection.Track.Label",
            defaultMessage: "Track"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Header",
            defaultMessage: "Stay on schedule"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Description",
            defaultMessage: "Get clarity on the status of every project - from cross-team initiatives down to the details of individual tasks."
        }),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).trackTrackWorkWhereYouWork,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.TrackWork.Alt",
                            defaultMessage: "Jira and Gmail integration"
                        })
                    }
                },
                Icon: $e5ec57a4eae656ec$var$ChartIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.TrackWork.Header",
                    defaultMessage: "Track work where you work"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.TrackWork.Description",
                    defaultMessage: "Keep work up-to-date by tracking progress from your favorite tools like Slack, Figma and Gmail powered by an AI-assist"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).trackMonitorProgress,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.MonitorProgress.Alt",
                            defaultMessage: "Timeline view in Jira"
                        })
                    }
                },
                Icon: $e5ec57a4eae656ec$var$PieChartIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.MonitorProgress.Header",
                    defaultMessage: "Monitor progress"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.MonitorProgress.Description",
                    defaultMessage: "Stay up-to-date on the work's progress using the view you like: boards, lists, timeline, or calendars."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).trackRemoveManualWork,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.RemoveManualWork.Alt",
                            defaultMessage: "use Natural Language to create automations in Jira"
                        })
                    }
                },
                Icon: $e5ec57a4eae656ec$var$BidirectionalArrowsIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.RemoveManualWork.Header",
                    defaultMessage: "Remove manual work"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.RemoveManualWork.Description",
                    defaultMessage: "Use Rovo AI to create custom automations to keep your status up to date - from automated reminders to rules that move work forward."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: (0, $6MUoN.FeaturedImages).trackManageDependencies,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.ManageDependencies.Alt",
                            defaultMessage: "Map dependencies in Jira"
                        })
                    }
                },
                Icon: $e5ec57a4eae656ec$var$GroupIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.ManageDependencies.Header",
                    defaultMessage: "Manage dependencies"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.Gwp7999TrackSection.Card.ManageDependencies.Description",
                    defaultMessage: "Connect engineering, product, and marketing initiatives to coordinate big launches across every team."
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6MUoN.FeaturedInfoSection), {
        variant: (0, $6MUoN.TRACK),
        eyebrow: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.TabsSection.Track.Label",
            defaultMessage: "Track"
        }),
        header: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Header",
            defaultMessage: "Manage the big picture down to every detail"
        }),
        description: intl.formatMessage({
            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Description",
            defaultMessage: "Now that work is underway, use Jira to understand the major moving pieces and quickly drill down to the tiniest of details."
        }),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: trackProjectBoardsImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.ProjectBoards.ImageAlt",
                            defaultMessage: "Board view in Jira"
                        })
                    }
                },
                Icon: $e5ec57a4eae656ec$var$ChartIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.ProjectBoards.Header",
                    defaultMessage: "Project boards"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.ProjectBoards.Description",
                    defaultMessage: "Track the status of everyone's tasks at each stage of the workflow. Understand how work is distributed across the team, what\u2019s still in progress, and what to tackle next."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: trackTaskManagementImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.TaskManagement.ImageAlt",
                            defaultMessage: "Task details in Jira"
                        })
                    }
                },
                Icon: $e5ec57a4eae656ec$var$PieChartIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.TaskManagement.Header",
                    defaultMessage: "Task management"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.TaskManagement.Description",
                    defaultMessage: "Tasks in Jira house the information you need to understand real-time work status, such as development activity and related issue progress. Integrate data from popular apps."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: trackDependencyManagementImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.DependencyManagement.ImageAlt",
                            defaultMessage: "Timeline view in Jira with dependencies "
                        })
                    }
                },
                Icon: $e5ec57a4eae656ec$var$BidirectionalArrowsIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.DependencyManagement.Header",
                    defaultMessage: "Dependency management"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.DependencyManagement.Description",
                    defaultMessage: "Jira shows you the order in which work needs to get done so you can spot bottlenecks before they become a blocker."
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dTlTl.FeaturedInfoCard), {
                image: {
                    image: {
                        src: trackGoalTrackingImage,
                        alt: intl.formatMessage({
                            id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.GoalTracking.ImageAlt",
                            defaultMessage: "Project goals in Summary view in Jira"
                        })
                    }
                },
                Icon: $e5ec57a4eae656ec$var$GroupIcon,
                title: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.GoalTracking.Header",
                    defaultMessage: "Goal tracking"
                }),
                body: intl.formatMessage({
                    id: "JiraSoftwareFeaturesPageV2.HighlightTrackSection.Card.GoalTracking.Description",
                    defaultMessage: "Understand how work is mapping to company goals over time in the summary view. Easily share progress with stakeholders."
                })
            })
        ]
    });
};

});

parcelRegister("5OR9G", function(module, exports) {

$parcel$export(module.exports, "FinalCTASection", function () { return $a0a8dfed92ffc4b6$export$6a60a86ef3cbc9d3; });
/* final-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $ix9oc = parcelRequire("ix9oc");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $a0a8dfed92ffc4b6$var$heroContainerStyles = null;
const $a0a8dfed92ffc4b6$var$imageContainerStyles = null;
const $a0a8dfed92ffc4b6$var$imageStyles = null;
const $a0a8dfed92ffc4b6$export$9c2bc11809fc972d = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _p12f1oh5 _4t3i1mjv _16jlidpf _1o9zidpf _i0dl1wug _1mjb1txw _dh1a1h6o _1tvskb7n _1bzwkb7n _1a8lf1ug _1knen7od _8fz61osq _tnrupg4v _1rkbi4q4"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            alt: "",
            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-feature-v2-cta.webp",
            loading: "lazy",
            className: (0, $esG4f.default)([
                "_p12f1osq"
            ])
        })
    });
};
const $a0a8dfed92ffc4b6$export$6a60a86ef3cbc9d3 = ()=>{
    const intl = (0, $f6qj2.default)();
    const headerText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CtaSection.Header",
        defaultMessage: "Bring the big picture into view for the whole team"
    });
    const descriptionText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.CtaSection.Description",
        defaultMessage: "Connect all of your teams with Jira, and launch your next big idea."
    });
    const buttonText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.Cta.TryJiraFree",
        defaultMessage: "Try Jira free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "hero",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
            layout: "12",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_ca0q16xz _u5f3idpf _n3td16xz _19bvidpf _1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _1tkeidpf _p12f1ns9 _19pkidpf _2hwx1wug _otyridpf _18u01wug _zulpzwfg _tl28vbgk _axwiidpf _1hwcvbgk _sp8tidpf _1gde1bp4 _1kmxzwfg _1ggmidpf _1ykzvbgk _1maeidpf _1p94idpf _d47fidpf _1qv9idpf _d600idpf _1t7v1feq _rpgfkb7n _eivrkb7n _qbuof1ug _1pmeftgi _1r021hlo _161y4jg8 _1fdl1fw0 _1is1ckbl _1m158pqr _inu0idpf _1g2pahaf _1q2n13ei _yhtsviql _7t6211uf _140l4jg8 _s0881nn1 _1i4z1tcg _1mx7ftgi _ftgm1j6v _1xco1hlo _phqogrf3 _nlorgrf3 _1qvngrf3 _19qpgrf3 _1f7t1h6o _1cxy1h6o"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($a0a8dfed92ffc4b6$export$9c2bc11809fc972d, {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.default), {
                        headerText: headerText,
                        headerType: "h2",
                        bodyText: descriptionText,
                        className: "textContainerStyles",
                        ctaProps: {
                            buttonProps: {
                                value: buttonText,
                                href: (0, $3FBn4.useLocalizedHref)("/software/jira/free"),
                                variant: "primary",
                                color: "blue",
                                dangerouslySetInnerHTML: {
                                    __html: buttonText
                                },
                                dataEventProps: {
                                    "data-product-key": "jiraSoftware",
                                    "data-event": "clicked",
                                    "data-event-container": "ctaSection",
                                    "data-event-component": "linkButton"
                                }
                            }
                        }
                    })
                ]
            })
        })
    });
};

});

parcelRegister("dnFkf", function(module, exports) {

$parcel$export(module.exports, "HeroSection", function () { return $e4198ce81ed13dc8$export$4489c2ed11909944; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $ix9oc = parcelRequire("ix9oc");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $hrScA = parcelRequire("hrScA");

var $fvAxO = parcelRequire("fvAxO");

var $10R19 = parcelRequire("10R19");
const $e4198ce81ed13dc8$var$heroContainerStyles = null;
const $e4198ce81ed13dc8$var$imageContainerStyles = null;
const $e4198ce81ed13dc8$var$imageStyles = null;
const $e4198ce81ed13dc8$export$38d2695eccda79ea = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            alt: "",
            src: (0, $10R19.useLocalizedImage)("heroImage"),
            loading: "lazy",
            className: (0, $esG4f.default)([
                "_12vemgnk _1lrw1dfr _y3gn1h6o _1bsbj4ss _p12f1osq _1s4pzoqa _1rfmi4q4"
            ])
        })
    });
};
const $e4198ce81ed13dc8$export$4489c2ed11909944 = ()=>{
    const intl = (0, $f6qj2.default)();
    const showGwp7999JiraFeaturesUpdates = (0, $hrScA.checkFeatureFlagGate)((0, $fvAxO.featureFlags).gwp7999JiraFeatures);
    const heroHeaderText = showGwp7999JiraFeaturesUpdates ? intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.Hero.Gwp7999Header",
        defaultMessage: "Get to know Jira's project management features"
    }) : intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.Hero.Header",
        defaultMessage: "Project management features for all teams"
    });
    const heroBodyText = showGwp7999JiraFeaturesUpdates ? intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.Hero.Gwp7999Body",
        defaultMessage: "Built to help every team go from big idea to launch faster."
    }) : intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.Hero.Body",
        defaultMessage: "Built for every team, Jira is how modern organizations take work from to-do to done."
    });
    const buttonText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.Cta.TryJiraFree",
        defaultMessage: "Try Jira free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "hero",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_ca0ql1r9 _u5f3idpf _n3tdvbgk _19bvidpf _1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o _1tkeidpf _p12f1ns9 _19pkidpf _2hwx1wug _otyridpf _18u01wug _zulpzwfg _na0i1bp4 _tl2812am _axwiidpf _1hwc1ul9 _sp8tidpf _1b4zidpf _1waj1hlo _9tuo1wto _1kob26nv _izsy9y44 _2l1dckbl _wzx0bys6 _132lgrf3 _16fqgrf3 _uoefc4v4 _kn48grf3 _1u1xzoqa _19ts1b9w _lmsz17rr _1xeeeo28 _g0eh8pqr _rxao1p2n _v3ku1hlo _zpfm26nv _8pu11nn1 _12v41j6v _zlxh1tcg _mysdbys6 _lrptidpf _1qixidpf _7bws7vkz _1d65idpf _18bszoqa _j90veo28 _1twaidpf _czjzidpf _cb7uidpf _msbxidpf _ra68idpf _k16eidpf _1c33idpf _1spif6fq _6kegidpf _187uidpf _17xn7vkz _dxa7idpf"
            ]),
            style: {
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.default), {
                    headerText: heroHeaderText,
                    headerType: "h1",
                    bodyText: heroBodyText,
                    className: "textContainerStyles",
                    ctaProps: {
                        buttonProps: {
                            value: buttonText,
                            href: (0, $3FBn4.useLocalizedHref)("/software/jira/free"),
                            variant: "primary",
                            color: "blue",
                            dangerouslySetInnerHTML: {
                                __html: buttonText
                            },
                            dataEventProps: {
                                "data-product-key": "jiraSoftware",
                                "data-event": "clicked",
                                "data-event-container": "heroSection",
                                "data-event-component": "linkButton"
                            }
                        }
                    }
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)($e4198ce81ed13dc8$export$38d2695eccda79ea, {})
            ]
        })
    });
};

});

parcelRegister("6V1Wm", function(module, exports) {

$parcel$export(module.exports, "IntegrationsSection", function () { return $04cee1ccefe35b52$export$94c8b142f0acfaff; });
/* integrations.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $04cee1ccefe35b52$export$94c8b142f0acfaff = ()=>{
    const intl = (0, $f6qj2.default)();
    const header = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.IntegrationsSection.Header",
        defaultMessage: "Plug into your favorite tools"
    });
    const body = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.IntegrationsSection.Description",
        defaultMessage: "If your team uses it, we integrate with it. Choose from the over 3000+ integrations available in the Atlassian Marketplace."
    });
    const ctaText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.IntegrationsSection.Cta",
        defaultMessage: "Explore Integrations"
    });
    intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.IntegrationsSection.ImageAlt",
        defaultMessage: "A collection of logos of tools that Jira integrates with"
    });
    const companyLogos1 = [
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/google-drive-icon.svg",
            alt: "Google Drive"
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/google-docs-icon.svg",
            alt: "Google Docs"
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/figma-icon.svg",
            alt: "Figma"
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/slack-icon.svg",
            alt: "Slack"
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/zoom-icon.svg",
            alt: "Zoom"
        }
    ];
    const companyLogos2 = [
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/teams-icon.svg",
            alt: "Microsoft Teams"
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/salesforce-icon.svg",
            alt: "Salesforce"
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/qmetry-icon.svg",
            alt: "QMetry"
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/miro-icon.svg",
            alt: "Miro"
        },
        {
            src: "https://wac-cdn.atlassian.com/misc-assets/svgs/github-icon.svg",
            alt: "GitHub"
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_bfhk1rga _mkrz16kd _ca0qvbgk _u5f3idpf _n3tdvbgk _19bvidpf _1agjkqtm _1nps2w51 _1kmxvbgk _1ggmidpf _1ykzidpf _1maeidpf _1vthglyw"
            ]),
            style: {
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.StyledBackground), {
                bgColor: (0, $5ohHq.wacToken)("color.neutral.light100"),
                partialBackgrounds: [
                    {
                        imageLink: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Logo_wall_left.svg",
                        positionDesktop: "sideLeft",
                        positionTablet: "hidden",
                        positionMobile: "hidden"
                    },
                    {
                        imageLink: "https://wac-cdn.atlassian.com/misc-assets/webp-images/Logo_wall_right.svg",
                        positionDesktop: "sideRight",
                        positionTablet: "hidden",
                        positionMobile: "hidden"
                    }
                ],
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
                        className: (0, $esG4f.default)([
                            "_19pkvbgk _2hwxidpf _otyrvbgk _18u0idpf _1e0c1txw _2lx21bp4 _zulpzwfg _476didpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _2lx21bp4 _1pzm1h6o _1afj1h6o _31ku1h6o _dkzuidpf _1n46idpf _clfdidpf _17f71wug _if5y1wug _11pq1wug _at0eidpf _1gnpidpf _q0a5idpf _1nx01wug _7e5b1wug _c3k81wug _clfdftgi _q0a57vkz _w77h1ogm"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                        children: header
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        children: body
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                        variant: "secondary",
                                        color: "black",
                                        href: "https://marketplace.atlassian.com/",
                                        dataEventProps: {
                                            "data-event": "clicked",
                                            "data-event-component": "linkButton",
                                            "data-event-container": "integrationsSection",
                                            "data-product-key": "jira",
                                            "data-label": ctaText,
                                            "data-label-english": "Explore Integrations"
                                        },
                                        children: ctaText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _1n261g80 _1bah1h6o _p12f1kdj _zulp10yn _19pk1wug _2hwx1wug _otyr1wug _18u01wug _b8yq1osq _181n11p5 _1j8b1rzm _12e81h6o"
                                ]),
                                children: [
                                    companyLogos1.map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($04cee1ccefe35b52$var$CompanyLogo, {
                                            src: logo.src,
                                            alt: logo.alt,
                                            visibleBreakpoint: "onlyTablet"
                                        }, index)),
                                    companyLogos2.map((logo, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($04cee1ccefe35b52$var$CompanyLogo, {
                                            src: logo.src,
                                            alt: logo.alt,
                                            visibleBreakpoint: "mobileAndTablet"
                                        }, index))
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $04cee1ccefe35b52$var$CompanyLogo = ({ src: src, alt: alt, visibleBreakpoint: visibleBreakpoint })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0cglyw _2rko1ul9 _4cvr1h6o _1bah1h6o _11q7cd5j _1bsb53f4 _4t3i53f4 _ca0qgktf _u5f3gktf _n3tdgktf _19bvgktf _rtys1osq _19l31osq _mezj1wug _bna71wug",
            visibleBreakpoint === "onlyTablet" && "_kzvi1txw _n6ov1txw",
            visibleBreakpoint === "mobileAndTablet" && "_liwc1txw"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            src: src,
            alt: alt,
            loading: "lazy"
        })
    });
};

});

parcelRegister("kYPcD", function(module, exports) {

$parcel$export(module.exports, "ManageSection", function () { return $556e985e31eaad56$export$df5bc9f9ceaf5b31; });
/* manage.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable react/no-unstable-nested-components */ /* eslint-disable react-hooks/rules-of-hooks */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $ix9oc = parcelRequire("ix9oc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");
const $556e985e31eaad56$var$Eyelash = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "25",
        viewBox: "0 0 40 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23.632 8.42251L24.7544 7.4286C24.7544 7.4286 25.0032 6.84209 24.8041 6.44563C24.6825 6.20123 24.4945 5.96228 24.29 5.77762C23.8753 5.40832 23.3832 5.28879 23.1675 5.86991C23.1399 5.85362 23.0957 5.85364 23.057 5.82648C22.9796 6.5651 22.0506 6.60315 21.7133 7.15168C21.846 7.24401 21.7023 7.17336 21.7023 7.17336C21.752 7.75447 21.1881 8.0858 21.1881 8.09123C20.4527 9.20458 19.1035 10.4483 18.4456 11.768L18.4732 11.7788L18.4954 11.8006C18.7387 11.8223 18.3848 12.1482 18.3461 12.0178C17.5665 12.4143 16.5159 13.6145 16.3611 14.4618C16.527 14.5704 16.4385 14.717 16.3943 14.6518C15.8358 14.6138 11.4014 19.3496 13.7734 19.2519L13.9172 19.4148C14.2434 19.165 16.4993 17.2479 16.5159 17.2696C16.9693 17.5031 16.8863 15.3959 17.3563 16.3517C19.8389 15.8955 22.9187 10.3234 22.9187 10.3234L22.9906 9.66079C22.9906 9.66079 23.8863 9.11767 23.6264 8.41708L23.632 8.42251Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M4.81616 4.90336L4.57284 4.28422C4.57284 4.28422 5.11469 3.39894 4.55624 2.89385L5.08709 1.50356C5.08709 1.50356 5.03179 0.868118 4.6724 0.60743C4.4457 0.444501 4.16923 0.314139 3.90383 0.248967C3.3675 0.107761 2.86988 0.22186 2.94729 0.840992C2.91411 0.840992 2.87536 0.857229 2.82559 0.851798C3.10205 1.54153 2.29484 1.99232 2.25614 2.63318C2.41649 2.6549 2.53811 2.70378 2.44965 2.70378L2.2506 2.66036C2.56577 3.15458 1.86904 3.28491 2.47725 3.80085L2.22293 3.70307C2.09023 5.02823 1.47094 6.73358 1.50964 8.20537H1.54285C1.54285 8.20537 1.63132 8.57468 1.54285 8.47692C1.03416 9.18295 0.669234 10.7199 0.918048 11.54C1.1171 11.5617 -1.19963 18.1224 0.857235 16.9656L1.06181 17.047C1.23322 16.6777 1.37142 16.3682 1.86352 16.0478C1.8414 15.9826 1.88565 15.988 1.67001 15.9445C1.64237 15.9228 1.58157 15.8848 1.49311 15.8739C0.973362 15.7762 2.68736 12.7729 2.68736 12.7729C4.67788 11.2467 4.81063 4.9088 4.81063 4.9088L4.81616 4.90336Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M39.8603 17.4274C39.6723 16.9115 39.3019 16.5748 38.8264 16.9875C38.8098 16.9604 38.7711 16.9386 38.749 16.8952C38.3232 17.5089 37.4883 17.107 36.9298 17.4383C37.0017 17.5795 36.9077 17.4546 36.9077 17.4546C36.6699 17.9868 36.0175 18.0194 36.0175 18.0248C34.8287 18.6657 33.0428 19.1273 31.8319 19.9854L31.8485 20.0071L31.8595 20.0343C32.0641 20.1646 31.5942 20.2895 31.6218 20.1538C30.7427 20.1375 29.2387 20.7077 28.6968 21.3757C28.7908 21.5495 28.8406 21.0607 29.1503 21.6201C28.9733 21.7016 28.8296 21.8645 28.6526 21.9297C28.4868 21.5495 28.6415 21.6364 28.6305 21.5604C28.155 21.2671 21.9678 23.3744 24.1021 24.39L24.1519 24.6018C24.561 24.5312 25.4236 24.3682 25.3849 24.2867C25.1747 23.8142 27.4749 23.8903 27.4804 23.9229L28.6637 23.5047C31.0689 24.2542 36.4709 20.7892 36.4709 20.7892L36.8579 20.2407C36.8579 20.2407 37.9085 20.181 38.0191 19.4423L39.4843 19.0893C39.4843 19.0893 39.9875 18.6874 39.9986 18.2475C40.0096 17.9759 39.9598 17.6772 39.8713 17.422L39.8603 17.4274Z",
                fill: "#101214"
            })
        ]
    });
const $556e985e31eaad56$var$Stars = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "126",
        height: "64",
        viewBox: "0 0 126 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M126 15.5613C125.593 13.5037 125.727 16.089 124.977 15.7532C124.682 17.3843 122.812 18.3865 122.421 19.6232C122.635 20.0389 122.753 20.2734 122.346 20.5933C121.773 20.0229 121.023 20.9931 120.3 22.1498C119.63 23.573 117.348 26.5368 117.208 25.7425C117.198 25.1082 113.64 31.0517 113.994 29.3033C112.494 30.3907 110.902 31.8673 109.241 33.5464C109.075 32.5922 108.904 31.6487 108.732 30.7265C108.716 30.7532 108.732 30.8331 108.684 30.7745C108.47 31.2542 109.466 33.6689 108.368 34.4419C107.94 31.3449 106.322 20.0122 108.256 28.3171C105.389 20.8012 120.08 20.3747 124.302 15.5507C126.6 11.4195 111.417 19.7831 110.125 20.54C110.125 20.54 110.195 20.2361 110.195 20.2308C103.498 24.4898 108.116 7.07517 101.96 6.0144C99.2548 7.10715 98.4297 11.3342 97.235 13.7116C97.4814 13.6156 98.0279 11.4035 98.8476 11.1583C98.2904 12.2991 96.0938 17.896 96.8599 14.9056C91.6845 30.2468 87.0502 29.4845 78.7994 33.3864C78.3762 33.5144 56.7314 41.3555 59.228 43.8022C60.5942 42.9014 62.8016 42.7521 63.8999 41.8086C63.9213 41.3289 63.9427 41.0623 64.4838 40.9557C65.116 42.4802 69.6111 38.5251 70.1254 38.4717C70.3397 39.6338 78.0922 34.6711 76.6671 36.2222C80.2888 35.4333 84.8857 33.5357 89.6539 31.5474C88.0252 38.8769 84.3767 44.234 84.3767 44.234C84.3767 44.234 73.6079 39.6817 64.1999 42.4323C68.9789 44.5165 78.344 43.6796 83.9535 46.4834C79.6781 58.2105 76.8867 67.3896 79.887 61.2542L79.962 61.67C80.9425 57.9546 83.6909 54.3353 84.1142 50.7159C83.4338 49.0527 85.1643 49.5165 85.8715 47.1497C87.8323 48.3011 94.7437 48.7169 91.5613 51.5261C89.0378 55.7265 81.8747 59.2766 79.6031 63.9941C83.7927 63.7223 88.5878 58.0186 91.4327 54.9696C91.4327 54.9696 91.4809 55.2734 91.4809 55.2787C93.3507 53.9621 94.958 50.1295 97.6582 52.1444C97.6529 52.1444 97.1761 52.1497 97.1653 52.1497C101.221 53.3811 111.893 67.0805 111.968 56.201C111.636 50.0282 109.343 37.0325 109.343 37.0325C109.343 37.0325 111.915 32.9867 113.399 32.5975C114.701 31.5954 125.952 20.396 125.989 15.5613H126ZM94.1383 25.5026C95.2366 22.3363 96.1849 19.8097 95.7938 21.9792C97.8297 18.6903 99.5602 13.0506 101.96 10.3267C103.991 15.3374 105.175 23.1413 105.175 23.1413C105.175 23.1413 98.8155 25.8705 93.565 27.1498C93.7579 26.5954 93.9454 26.041 94.1329 25.5026H94.1383ZM87.4198 45.3374C87.4198 45.3374 90.2915 36.009 91.3898 32.1924C91.3898 32.2724 91.5506 30.3534 91.5559 30.4227C91.5559 30.4227 101.719 27.2777 105.261 25.7212C105.888 29.1114 106.482 32.5229 107.007 35.8811C103.053 39.9803 96.0724 48.3598 96.0724 48.3598C96.0724 48.3598 90.479 47.299 87.4198 45.3428V45.3374ZM109 56.2329C109 56.3395 109 57.0591 108.781 56.6806C108.791 56.7233 108.802 56.7659 108.813 56.8086C108.797 56.7713 108.775 56.8086 108.781 56.6753C100.487 50.5559 93.6186 51.6167 104.093 42.6988C103.6 42.7574 101.596 44.5059 101.585 44.4685C101.885 42.9014 107.988 38.0986 104.746 41.9259C105.529 41.2916 106.514 40.396 107.538 39.3886C108.309 45.0069 109.091 50.7212 109 56.2276V56.2329Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M45.1481 15.604L45.1053 15.3694C44.3391 16.1903 42.5175 16.4676 42.0782 17.2885C42.1853 17.7309 42.3354 17.9014 41.8907 18.0774C38.7618 20.4601 33.9668 22.9121 30.5057 25.1669C30.1253 23.7276 29.252 21.0464 29.252 21.0464C29.1395 21.4036 28.9842 19.33 28.8824 18.669C30.0503 18.5837 31.154 18.5731 32.1559 18.685L32.1023 18.5997C32.1505 18.6211 32.2738 18.5624 32.322 18.6637C35.349 17.0859 38.8261 16.9739 42.2979 15.54C43.8784 15.8439 47.9233 13.4664 43.214 13.8396C40.7281 14.6605 37.8082 13.8662 35.4937 15.2362C35.4937 15.2362 35.5741 14.9696 35.5741 14.9643C32.6059 15.1295 27.6394 17.6456 27.4519 12.9974C27.2697 13.0827 27.8055 13.5571 27.2215 13.8183C27.1197 13.3599 26.9322 12.9174 26.8518 12.4803C27.2537 12.4004 27.1679 12.6775 27.2537 12.7149C27.4251 12.8908 25.7482 -2.56761 24.2695 0.364158L24.0444 0.300195C24.0712 0.806591 24.0873 1.27033 24.0712 1.75007C23.2676 0.96649 22.914 2.02722 22.2818 3.43979C22.0889 5.23617 20.8835 6.62213 20.337 8.33855C20.6799 8.44516 20.4816 8.54111 20.3155 8.40784C20.278 9.67117 19.4101 10.1509 19.6565 11.4196C19.6565 11.4196 19.4637 11.2117 19.4583 11.2064C18.3654 13.4505 18.1243 18.0614 14.7061 18.072C14.7865 18.2533 15.3436 17.7522 15.5847 18.3492C15.0758 18.4238 14.5775 18.5891 14.0953 18.6477C14.0418 18.2426 14.3364 18.3439 14.3793 18.2639C14.4811 18.2586 -4.801 18.9089 1.13525 22.4004C2.65681 22.7202 3.63727 23.9888 5.03025 24.6285C5.19098 24.3033 5.22847 24.5112 5.08381 24.6552C6.17677 24.7831 6.43395 25.6466 7.58048 25.4974C7.58048 25.4974 7.36616 25.6733 7.3608 25.6733C10.72 27.0699 13.6131 28.6157 11.4058 32.4004C11.6094 32.4164 11.4487 32.8801 11.4058 32.8002C10.8808 33.6424 5.50172 44.8364 6.53574 47.5602C6.69647 49.0101 7.63941 48.2479 9.01632 47.1392C11.7648 43.8716 13.806 43.7916 15.3169 41.0784C15.3169 41.0784 15.3865 41.3556 15.3919 41.3609C17.7439 39.9696 20.9906 34.7404 24.0284 35.1829C25.3517 35.3588 34.7758 44.9803 34.69 42.3204L34.915 42.2458C34.7436 41.8886 34.6633 39.6605 34.3632 38.4558C32.8095 35.2948 33.6667 33.6424 32.0326 31.6541C32.0326 31.6541 32.3059 31.686 32.3112 31.686C31.2987 29.5645 31.1379 27.459 33.3131 26.1637C33.147 26.0517 32.8684 26.8087 32.3434 26.4302C32.7881 26.0677 33.1792 25.6413 33.6078 25.3108C33.8596 25.6306 33.5328 25.7159 33.5274 25.8119C33.7096 25.9985 48.8127 15.3108 45.1481 15.6093V15.604ZM25.3624 29.298C22.6247 33.2479 19.378 28.7703 16.1044 27.475C17.026 24.9857 17.926 22.3843 18.9279 20.0976C21.071 20.3694 25.8125 17.6136 26.4286 20.087C27.3126 23.8716 29.5038 27.1978 25.3624 29.2927V29.298ZM20.9692 16.281L20.8674 16.2917C20.9102 16.2597 20.9209 16.1104 21.0335 16.1157C21.3549 11.6914 22.2979 9.33536 24.1409 4.95903C26.0803 8.86628 24.4248 12.2511 25.5285 16.4302C23.3533 16.9206 23.0533 16.862 20.4656 17.0646C20.6316 16.7927 20.7977 16.5315 20.9692 16.281ZM12.0487 24.6712C9.34312 23.9356 6.70182 22.9334 3.91585 21.3982C4.83736 19.5219 13.9185 20.7373 15.9276 20.4121C15.5526 21.4249 15.199 22.4217 14.9043 23.3758L14.9365 23.3652C14.9365 23.3652 14.7168 24.3353 14.7007 24.0901C14.4061 24.5912 14.0739 25.2415 13.731 25.9664C13.1095 25.5187 12.0434 24.6765 12.0434 24.6765L12.0487 24.6712ZM17.1652 36.8886C14.3257 38.8449 11.4808 42.0592 8.85557 44.2927C7.14648 42.5549 14.3364 33.2586 15.1561 29.9484C16.4473 30.5667 17.8885 31.5048 16.3348 30.0603C16.0187 29.7618 19.4476 32.5763 20.5995 33.3119C19.2119 34.4099 18.4618 36.201 17.1706 36.8886H17.1652ZM29.2681 30.8119C30.3075 32.7842 31.4647 36.185 32.0969 38.7809C29.236 36.782 27.409 35.0869 25.057 32.9388C25.2178 32.7895 25.3785 32.6402 25.5338 32.4909C25.2445 32.5176 26.1875 31.7394 26.075 31.9473C26.8304 31.4942 27.8215 30.8065 28.8449 30.0336C29.0806 30.4334 29.2574 30.8119 29.2574 30.8119H29.2681Z",
                fill: "#101214"
            })
        ]
    });
const $556e985e31eaad56$export$df5bc9f9ceaf5b31 = ()=>{
    const intl = (0, $f6qj2.default)(); /*** TEXT DECLARATIONS ***/ 
    const headerText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Header",
        defaultMessage: "Manage projects big and small"
    });
    const descriptionText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Description",
        defaultMessage: "The most flexible and scalable tool in the market\xa0with granular controls over security, privacy, and workflows."
    });
    const callToActionQuestionText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Question",
        defaultMessage: "Interested in the benefits of centralized administration on the Atlassian cloud platform?"
    });
    const ctaText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Cta",
        defaultMessage: "Learn more here"
    });
    const ctaAriaLabel = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.ValuePropSection.CtaAriaLabel",
        defaultMessage: "Learn more about centralized administration on the Atlassian cloud platform"
    });
    const cards = [
        {
            icon: "globe",
            text: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Icon.Globe.Text",
                defaultMessage: "Global and project-level configuration"
            })
        },
        {
            icon: "workflow",
            text: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Icon.Wire.Text",
                defaultMessage: "Customizable fields, workflows, and more"
            })
        },
        {
            icon: "foursquares",
            text: intl.formatMessage({
                id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Icon.FourSquare.Text",
                defaultMessage: "Rich APIs"
            })
        },
        {
            icon: "openlock",
            text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Icon.Unlock.Text",
                defaultMessage: "Permissions and <link>privacy controls</link>",
                values: {
                    link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            className: "manage-link",
                            href: (0, $3FBn4.useLocalizedHref)("/trust/data-protection?tab=privacy"),
                            children: str
                        })
                }
            })
        },
        {
            icon: "closedlock",
            text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Icon.Lock.Text",
                defaultMessage: "Data residency, <link>data security & compliance</link>",
                values: {
                    link: (str)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            className: "manage-link",
                            href: (0, $3FBn4.useLocalizedHref)("/software/jira/security"),
                            children: str
                        })
                }
            })
        },
        {
            icon: "cog",
            text: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "JiraSoftwareFeaturesPageV2.ValuePropSection.Icon.Cog.Text",
                defaultMessage: "<link>SAML & SSO</link>",
                values: {
                    link: (str)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            className: "manage-link",
                            href: (0, $3FBn4.useLocalizedHref)("/software/guard"),
                            children: str
                        });
                    }
                }
            })
        }
    ]; /*** CSS DECLARATIONS ***/ 
    const headingTextStyles = null;
    const cardContainerStyles = null;
    const cardStyles = null;
    const dividerStyles = null;
    const ctaStyles = null;
    const eyelashStyles = null;
    const starsStyles = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _2lx21bp4 _p12fi4q4 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o _19121cl4 _19pkftgi _2hwx1wug _otyrftgi _18u01wug _zulpftgi _1pfh12am _1n46idpf _if5yidpf _1gnpidpf _7e5bidpf _1wudh2mm _1u5a1o8l _clfdidpf _11pqidpf _q0a5idpf _c3k8idpf _j6qud3bo _b8yqorz4 _aop4ftgi _1ssfldb6 _eosxftgi _5ysqldb6"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                children: /*#__PURE__*/ (0, $loA2J.jsxs)("h2", {
                                    children: [
                                        headerText,
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_kqswstnw _rjxpbx3o _152tbx3o _1l7dpm4n _xaejpm4n"
                                            ]),
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)($556e985e31eaad56$var$Eyelash, {})
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                children: descriptionText
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                        className: (0, $esG4f.default)([
                            "_1e0c1txw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2lx2vrvc _1n261g80 _1bah1h6o _zulp10yn _1fvkidpf _13w57vkz _b60cidpf _1kcd7vkz _7iyz1fw0 _p1061tcg _13031ul9 _1of01hlo _v3z01pz4 _v33w17la _19v91fw0 _1gde1bp4 _ag851h6o _8164ftgi _f7w0i4q4 _ltb71jje _1c31i4q4 _1orb1jje _pdlm10mc _vo541yxl _1to21jje"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                        },
                        children: cards.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _1bah1h6o _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ix9oc.default), {
                                    iconName: card.icon,
                                    iconSize: "small",
                                    isCentered: true,
                                    bodyText: card.text
                                })
                            }, index))
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                        className: (0, $esG4f.default)([
                            "_19it1ia1 _p12fi4q4 _1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug _10jx1osq _dbjgidpf _1hvk1wug _isu4zwfg _15qm1wug"
                        ]),
                        style: {
                            "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
                        }
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_kqswh2mm _1bsb1osq _p12fi4q4 _y3gn1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _85i5vbgk _j6qusby8 _10jx1osq _p0o3gktf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_kqswstnw _152t1uiu _liwcglyw"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($556e985e31eaad56$var$Stars, {})
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                children: callToActionQuestionText
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                href: (0, $3FBn4.useLocalizedHref)("/trust/centralized-administration"),
                                text: ctaText,
                                ariaLabel: ctaAriaLabel
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});

parcelRegister("KxTXe", function(module, exports) {

$parcel$export(module.exports, "TabsSection", function () { return $59ded0119195b8a7$export$502de1d4d55224c1; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ // eslint-disable no-non-orangelogic-images-eslint

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $cutM5 = parcelRequire("cutM5");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $gAJUc = parcelRequire("gAJUc");

var $10R19 = parcelRequire("10R19");

var $4Wkep = parcelRequire("4Wkep");
const $59ded0119195b8a7$var$wrapperStyle = null;
const $59ded0119195b8a7$var$slantedLineStyle = null;
const $59ded0119195b8a7$var$headerContainerStyle = null;
const $59ded0119195b8a7$var$tabOutlineOffset = "4px";
const $59ded0119195b8a7$var$headerStyle = null;
const $59ded0119195b8a7$var$tabList = null;
const $59ded0119195b8a7$var$tabStyles = null;
const $59ded0119195b8a7$var$currentStyle = null;
const $59ded0119195b8a7$var$textBlockStyles = null;
const $59ded0119195b8a7$var$SampleTab = ({ title: title, isSelected: isSelected })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        className: (0, $esG4f.default)([
            "_1ul9ymf6 _bfhkcd5j _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3iajfg _2rko1f4h _y4ti1ul9 _bozg1ul9 _80omtlke _19it1uu4 _ect4bzd7 _k48p1nn1 _1wybgktf _1dbzzucj _1bg41y44 _nt751hlo",
            isSelected && "_19it8djs _bfhk1ybm",
            "h5"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: title
    });
};
const $59ded0119195b8a7$export$502de1d4d55224c1 = ()=>{
    const intl = (0, $f6qj2.default)();
    const shouldHideTabsSection = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7999JiraFeatures);
    const headerText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Header",
        defaultMessage: "Where devs, marketers, and every team in between get work done"
    }); // Plan tab content
    const planLabelText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Plan.Label",
        defaultMessage: "Plan"
    });
    const planBodyText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Plan.Body",
        defaultMessage: "Align teams, resources, and deliverables to ensure the project hits deadlines and maps to company goals from the start."
    }); // Plan testimonial content
    const planTestimonialQuote = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Plan.Quote",
        defaultMessage: "Work becomes a lot more visible when it's all in one place. It makes collaboration a whole lot easier."
    });
    const planTestimonialTitle = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Plan.JobTitle",
        defaultMessage: "Internal Infrastructure, Canva",
        description: "Canva is a company."
    });
    const planTestimonialAuthor = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Plan.Author",
        defaultMessage: "Jeff Lai"
    });
    const planTestimonialImage = "https://wac-cdn.atlassian.com/misc-assets/webp-images/Pasted Graphic-2395339363.webp"; // Track tab content
    const trackLabelText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Track.Label",
        defaultMessage: "Track"
    });
    const trackBodyText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Track.Body",
        defaultMessage: "No matter how your team gets work done - Scrum, Kanban, or something in-between - Jira gives you visibility from start to finish."
    }); // Track testimonial content
    const trackTestimonialQuote = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Track.Quote",
        defaultMessage: "The pace of delivery from idea to reality has exploded."
    });
    const trackTestimonialTitle = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Track.JobTitle",
        defaultMessage: "Agile Lead, Cancer Research UK",
        description: "Cancer Research UK is a company."
    });
    const trackTestimonialAuthor = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Track.Author",
        defaultMessage: "Greg Franklin"
    });
    const trackTestimonialImage = "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab2image-29451184.webp"; // Collaborate tab content
    const collaborateLabelText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Collaborate.Label",
        defaultMessage: "Collaborate"
    });
    const collaborateBodyText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Collaborate.Body",
        defaultMessage: "Turn Jira into your team\u2019s collaboration hub with real-time updates from popular 3rd party apps, commenting, Smart Links, and attachments."
    }); // Collaborate testimonial content
    const collaborateTestimonialQuote = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Collaborate.Quote",
        defaultMessage: "People are practicing more knowledge-sharing than ever before, resulting in more transparency and efficiency."
    });
    const collaborateTestimonialTitle = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Collaborate.JobTitle",
        defaultMessage: "Business Analyst, Audi",
        description: "Audi is a company."
    });
    const collaborateTestimonialAuthor = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Collaborate.Author",
        defaultMessage: "Martin Binder"
    });
    const collaborateTestimonialImage = "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab3image-29484945.webp"; // Launch tab content
    const launchLabelText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Launch.Label",
        defaultMessage: "Launch"
    });
    const launchBodyText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Launch.Body",
        defaultMessage: "Connect your go-to-market and software teams with shared release calendars, so launch day goes off without a hitch."
    }); // Launch testimonial content
    const launchTestimonialQuote = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Launch.Quote",
        defaultMessage: "Less friction in the development process means better results and a faster time to market."
    });
    const launchTestimonialTitle = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Launch.JobTitle",
        defaultMessage: "Director of Engineering, Trulia",
        description: "Trulia is a company."
    });
    const launchTestimonialAuthor = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Launch.Author",
        defaultMessage: "Louis Bennet"
    });
    const launchTestimonialImage = "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab4image-29379446.webp"; // Report tab content
    const reportLabelText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Report.Label",
        defaultMessage: "Report"
    });
    const reportBodyText = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Report.Body",
        defaultMessage: "Gather insights into work - before, during, and after the project - to confirm everything is on track, and pivot when it\u2019s not."
    }); // Report testimonial content
    const reportTestimonialQuote = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Report.Quote",
        defaultMessage: "Full visibility in Jira across the whole organization enables you to make better management judgment."
    });
    const reportTestimonialTitle = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Report.JobTitle",
        defaultMessage: "Digital Portfolio Director, Inchcape",
        description: "Inchcape is a company."
    });
    const reportTestimonialAuthor = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.Report.Author",
        defaultMessage: "Paul Leaon"
    });
    const reportTestimonialImage = "https://wac-cdn.atlassian.com/misc-assets/webp-images/tab5image-29413207.webp"; // shared CTA text
    const ctaTextJiraFree = intl.formatMessage({
        id: "JiraSoftwareFeaturesPageV2.TabsSection.CtaText",
        defaultMessage: "Try Jira free"
    });
    const sampleTabs = [
        {
            id: "plan",
            title: planLabelText,
            description: planBodyText,
            ctaText: ctaTextJiraFree,
            ctaUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/free"),
            imageUrl: (0, $10R19.useLocalizedImage)("planLabelImage"),
            testimonialImage: planTestimonialImage,
            testimonialAuthor: planTestimonialAuthor,
            testimonialTitle: planTestimonialTitle,
            testimonialQuote: planTestimonialQuote
        },
        {
            id: "track",
            title: trackLabelText,
            description: trackBodyText,
            ctaText: ctaTextJiraFree,
            ctaUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/free"),
            imageUrl: (0, $10R19.useLocalizedImage)("trackLabelImage"),
            testimonialImage: trackTestimonialImage,
            testimonialAuthor: trackTestimonialAuthor,
            testimonialTitle: trackTestimonialTitle,
            testimonialQuote: trackTestimonialQuote
        },
        {
            id: "collaborate",
            title: collaborateLabelText,
            description: collaborateBodyText,
            ctaText: ctaTextJiraFree,
            ctaUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/free"),
            imageUrl: (0, $10R19.useLocalizedImage)("collaborateLabelImage"),
            testimonialImage: collaborateTestimonialImage,
            testimonialAuthor: collaborateTestimonialAuthor,
            testimonialTitle: collaborateTestimonialTitle,
            testimonialQuote: collaborateTestimonialQuote
        },
        {
            id: "launch",
            title: launchLabelText,
            description: launchBodyText,
            ctaText: ctaTextJiraFree,
            ctaUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/free"),
            imageUrl: (0, $10R19.useLocalizedImage)("launchLabelImage"),
            testimonialImage: launchTestimonialImage,
            testimonialAuthor: launchTestimonialAuthor,
            testimonialTitle: launchTestimonialTitle,
            testimonialQuote: launchTestimonialQuote
        },
        {
            id: "report",
            title: reportLabelText,
            description: reportBodyText,
            ctaText: ctaTextJiraFree,
            ctaUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/free"),
            imageUrl: (0, $10R19.useLocalizedImage)("reportLabelImage"),
            testimonialImage: reportTestimonialImage,
            testimonialAuthor: reportTestimonialAuthor,
            testimonialTitle: reportTestimonialTitle,
            testimonialQuote: reportTestimonialQuote
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_11q71rga _syaz1hlo _1reo15vq _18m915vq"
        ]),
        style: {
            "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100")),
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1h6d9qjg _1dqonqa1 _189e1wbu _4t3iidpf _1bsbidpf"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                    "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                layout: "12",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_ca0qgktf _u5f3idpf _n3tdidpf _19bvidpf _y3gn1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_1e0c1o8l _y3gn1h6o _k48p1fw0 _1wyb1ylp _vwz4ckbl _p12fukw8 _6rth1f0o _flz014no _280zor1b _1hr2sby8 _1cqszwfg _1bys10mc _1rkbp2n4"
                        ]),
                        children: headerText
                    })
                })
            }),
            shouldHideTabsSection ? null : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                        className: (0, $esG4f.default)([
                            "_ca0q1y44 _u5f37vkz _n3td1wqb _19bv7vkz _1kmx1y44 _1ggmzwfg _1ykz1ul9 _1maezwfg",
                            "tab-list"
                        ]),
                        children: sampleTabs.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                                className: "round-tab",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($59ded0119195b8a7$var$SampleTab, {
                                    title: tab.title
                                })
                            }, index))
                    }),
                    sampleTabs.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4TabPanel), {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
                                    layout: "4-8",
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                            className: (0, $esG4f.default)([
                                                "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _r8nt1fw0 _ggmhzwfg _1axi10mc _1x1tidpf _s9kqidpf _4wztidpf _98csidpf _1adi1nn1 _zcqx1tcg _1v71c4v4 _oxk417la"
                                            ]),
                                            style: {
                                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                                    children: tab.title
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    children: tab.description
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                    text: tab.ctaText,
                                                    type: "primary",
                                                    href: tab.ctaUrl
                                                })
                                            ]
                                        }),
                                        $59ded0119195b8a7$export$b081103f53b612e1(tab.imageUrl)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Wkep.TestimonialCard), {
                                        image: tab.testimonialImage,
                                        quote: tab.testimonialQuote,
                                        name: tab.testimonialAuthor,
                                        title: tab.testimonialTitle
                                    })
                                })
                            ]
                        }, index))
                ]
            })
        ]
    });
};
const $59ded0119195b8a7$export$b081103f53b612e1 = (imageUrl)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            alt: "",
            src: imageUrl,
            className: (0, $esG4f.default)([
                "_1bsb1osq _4t3i1wug"
            ])
        })
    });
};

});
parcelRegister("4Wkep", function(module, exports) {

$parcel$export(module.exports, "TestimonialCard", function () { return $5233175cd1a3cf35$export$a34a40ba0fc7f13f; });
/* testimonial.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
const $5233175cd1a3cf35$var$imageContainerStyles = null;
const $5233175cd1a3cf35$var$customerImageStyles = null;
const $5233175cd1a3cf35$var$quoteContainerStyles = null;
const $5233175cd1a3cf35$export$a34a40ba0fc7f13f = ({ image: image, quote: quote, name: name, title: title })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4XrxY.Row), {
        layout: "4-8",
        children: [
            $5233175cd1a3cf35$export$86b0df2437854ec1(image),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _19pk3okq _2hwxidpf _otyr3okq _18u0idpf _1bsb1wug _y3gn1e5h _q5ugidpf _7tld1wug _14adgktf _4uro1wug _fnem1ou6 _1lac1ou6 _kqabowjs _1h9nowjs _115vzwfg _1yvrzwfg _134tcs5v _pep5cs5v _1pix2hoz _pe1n2hoz _1i8u1x4e _1sez1x4e _1ci6idpf _6desidpf _13sr1x4e _1mab1x4e _1gteidpf _g7g0idpf _13bp1dup _s5vq1dup _1ohn1tcg _yvfo1tcg _1hs0owjs _h1u7owjs _1xnri4q4 _pgvwi4q4 _1aqbgktf _1rltgktf _gvsbowjs _947mowjs _5p2w1f4h _15in1f4h _jigvidpf _1854idpf _10n3idpf _1s53idpf _h6ob10yn _169h10yn _hqv3idpf _l8zhidpf _ll807vkz _1sz57vkz _1usegrho _1m0agrho _16sc1fw0 _18gn1fw0 _bhjmidpf _1pplidpf _106widpf _dig1idpf _16q2idpf _1ta1idpf _1v4gidpf _1gj0idpf _niqioxwj _ayieoxwj _19431j6v _1gu51j6v _183p1nn1 _lc6s1nn1 _1qlrangw _wz5aangw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("blockquote", {
                        className: "quote",
                        children: [
                            "\u201C",
                            quote,
                            "\u201D"
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: "name",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: "title",
                        children: title
                    })
                ]
            })
        ]
    });
};
const $5233175cd1a3cf35$export$86b0df2437854ec1 = (image)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _kqswh2mm _19pkymf6 _2hwxidpf _otyr1a70 _18u0ppey _y3gnusic _xsmr1h6o _q5ug1ul9 _7tldidpf _14adidpf _4uroidpf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            src: image,
            alt: "",
            className: (0, $esG4f.default)([
                "_1bsb1w8k _1s4puuw1 _1rfm1w8k _q5ugidpf _7tld1ul9 _14adidpf _4uroidpf"
            ])
        })
    });
};

});






//# sourceMappingURL=index.ae9d32c0.js.map
